export type Maybe<T> = T | null
export type InputMaybe<T> = Maybe<T>
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] }
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & {
  [SubKey in K]?: Maybe<T[SubKey]>
}
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & {
  [SubKey in K]: Maybe<T[SubKey]>
}
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string
  String: string
  Boolean: boolean
  Int: number
  Float: number
  BigInt: bigint
  BigIntLocationID: bigint
  BigIntStopID: bigint
  Date: string
  DateTime: string
  Time: string
  TimeDelta: number
  Void: unknown
}

export type AdaptiveDeliveryDate = {
  __typename?: 'AdaptiveDeliveryDate'
  deliveryEnd: Scalars['DateTime']
  deliveryStart: Scalars['DateTime']
}

export type AddTrailerChangeInput = {
  legId: Scalars['Int']
  locationId?: InputMaybe<Scalars['BigIntLocationID']>
  noteBody?: InputMaybe<Scalars['String']>
  /** Index of the stop before which to add the trailer change */
  stopIdx: Scalars['Int']
}

export type AddTrailerChangeResponse =
  | InvalidLegStatus
  | InvalidLoadStatus
  | InvalidRadiusVersion
  | InvalidStopEvent
  | InvalidStopIdx
  | InvalidStopLocation
  | InvalidStopStatus
  | InvalidStopType
  | NoCostCenterAssignedToLoad
  | ObjectDoesNotExist
  | TractorNotExists
  | TrailerChangeAdded

export type AddedCustomerCostCenterResponse =
  | CostCenterNotExists
  | CustomerCostCenterUpdated
  | InvalidCostCenterForCustomer

export type AddedCustomerLatenessConfigurationResponse =
  | CustomerLatenessConfigurationNotFound
  | CustomerLatenessConfigurationUpdated
  | InvalidCustomerLatenessConfiguration

export type Address = {
  __typename?: 'Address'
  city?: Maybe<Scalars['String']>
  countryCode?: Maybe<Scalars['String']>
  countryName?: Maybe<Scalars['String']>
  countrySubdivisionCode?: Maybe<Scalars['String']>
  countrySubdivisionName?: Maybe<Scalars['String']>
  line1?: Maybe<Scalars['String']>
  line2?: Maybe<Scalars['String']>
  postalCode?: Maybe<Scalars['String']>
  stateOrProvinceAbbrev?: Maybe<Scalars['String']>
}

export type AddressQuery = {
  cityIcontains?: InputMaybe<Scalars['String']>
  cityIsNotNull?: InputMaybe<Scalars['Boolean']>
  cityIsNull?: InputMaybe<Scalars['Boolean']>
  distinctOn?: InputMaybe<Array<Scalars['String']>>
  line2Eq?: InputMaybe<Scalars['String']>
  line2IsNotNull?: InputMaybe<Scalars['Boolean']>
  line2IsNull?: InputMaybe<Scalars['Boolean']>
  shipmentCostCenterIdIn?: InputMaybe<Array<Scalars['Int']>>
}

export type AssignCarrierToLegResponse =
  | CarrierAssignedToLeg
  | InvalidLegIdx
  | InvalidLoadStatus
  | InvalidRadiusVersion
  | InvalidSourceSystem
  | ObjectDoesNotExist

export type AssignDriverToShareRequestInput = {
  assignedDriverId: Scalars['Int']
  id: Scalars['Int']
}

export type AssignDriversToLegResponse =
  | DriverAssignedToLeg
  | InvalidDriverAssignment
  | InvalidLegStatus
  | InvalidLegWithCarrierAction
  | InvalidLoadStatus
  | InvalidTmwVersionIdClient
  | InvalidTmwVersionIdScos
  | ObjectDoesNotExist
  | TmwValidationError

export type AssignTractorToLegResponse =
  | InvalidEquipmentMove
  | InvalidLegStatus
  | InvalidLegUpdateError
  | InvalidLegWithCarrierAction
  | InvalidLoadStatus
  | InvalidTmwVersionIdClient
  | InvalidTmwVersionIdScos
  | InvalidTractorStatus
  | ObjectDoesNotExist
  | TmwValidationError
  | TractorAssignedToLeg

export type AssignTrailerToLoadResponse =
  | InvalidLoadStatus
  | InvalidRadiusVersion
  | InvalidTrailerAssign
  | InvalidTrailerStatus
  | TrailerAssignedToLoad

export type AssignTrailerToStopInput = {
  stopId: Scalars['BigIntStopID']
  trailerId?: InputMaybe<Scalars['Int']>
}

export type AssignTrailerToStopResponse =
  | InvalidLoadStatus
  | InvalidTrailerAssign
  | InvalidTrailerStatus
  | NoCostCenterAssignedToLoad
  | ObjectDoesNotExist
  | TrailerAssignedToStop

export type AssociatedLoad = {
  __typename?: 'AssociatedLoad'
  /** Not valid to call on either TM or DTS AssociatedLoad. */
  associatedLoads?: Maybe<Scalars['Void']>
  auditTrailEvents: Array<AuditTrailEvent>
  autoCompleteScheduledTime?: Maybe<Scalars['DateTime']>
  /** Resolves to the base DTS load for an integrated TM load. */
  baseDtsLoad?: Maybe<BaseLoad>
  /** Not valid to call on either TM or DTS AssociatedLoad. */
  baseLoad?: Maybe<Scalars['Void']>
  billToId?: Maybe<Scalars['Int']>
  carrierIsPrime?: Maybe<Scalars['Boolean']>
  costCenter?: Maybe<CostCenter>
  courierJsonExtract?: Maybe<Scalars['String']>
  createdAt?: Maybe<Scalars['DateTime']>
  customerNumbers?: Maybe<Scalars['String']>
  customerReferenceNumbers: Array<CustomerReferenceNumber>
  dispatchAt?: Maybe<Scalars['DateTime']>
  documents: DocumentResponse
  endTime?: Maybe<Scalars['DateTime']>
  equipmentSize?: Maybe<Scalars['String']>
  equipmentType?: Maybe<EquipmentType>
  etasLastCalculated?: Maybe<Scalars['DateTime']>
  exceptions: Array<ExceptionTypes>
  firstPickupScheduledTimes?: Maybe<DynamicDateRange>
  firstPickupTimes?: Maybe<DynamicDateRange>
  firstStopScheduledTimes?: Maybe<DynamicDateRange>
  firstStopTimes?: Maybe<DynamicDateRange>
  freightDetails: FreightDetails
  freightRecordReferences: Array<FreightRecordReference>
  gpsEventsWithLocations: Array<GpsEventWithLocation>
  id: Scalars['Int']
  initialEstimatedTime: Scalars['Int']
  integratedRyderNumber?: Maybe<Scalars['String']>
  isRv3?: Maybe<Scalars['Boolean']>
  lastDeliveryScheduledTimes?: Maybe<DynamicDateRange>
  lastDeliveryTimes?: Maybe<DynamicDateRange>
  lastStopScheduledTimes?: Maybe<DynamicDateRange>
  lastStopTimes?: Maybe<DynamicDateRange>
  latestGpsEvent?: Maybe<GpsEventWithLocation>
  legs: Array<Leg>
  minNeedBy?: Maybe<LoadMinNeedByInfo>
  nextStop?: Maybe<Stop>
  notes: Array<LoadNote>
  operationalStop?: Maybe<OperationalStop>
  primaryReference?: Maybe<LoadReference>
  proReference?: Maybe<CustomerReferenceNumber>
  references: Array<CustomerReferenceNumber>
  route?: Maybe<Route>
  routeId?: Maybe<Scalars['Int']>
  ryderNumber?: Maybe<Scalars['String']>
  searchAndDisplayReferences: Array<CustomerReferenceNumber>
  /** @deprecated temporary for preseving backward compatibility. Eventually use `search_and_display_references` instead */
  searchAndDisplayReferences_Deprecated: Array<CustomerReferenceNumber>
  shipmentIds: Array<Scalars['Int']>
  source: LoadSource
  sourceSystem: SourceSystem
  startTime?: Maybe<Scalars['DateTime']>
  status: LoadStatus
  stopReferences: Array<StopReference>
  targetDispatchStartInterval?: Maybe<Scalars['TimeDelta']>
  tenderStatus: LoadTenderStatus
  tmwVersionId: Scalars['BigInt']
  topActionableLateStop?: Maybe<Stop>
  trailer?: Maybe<Trailer>
  trailerUnitNumbers: Array<Maybe<Scalars['String']>>
  transitMode: TransitMode
}

export type AssociatedTmStop = {
  __typename?: 'AssociatedTMStop'
  action: LocationActionType
  actualMiles?: Maybe<Scalars['Int']>
  adaptiveDeliveryDate?: Maybe<AdaptiveDeliveryDate>
  appointmentEnd?: Maybe<Scalars['DateTime']>
  appointmentStart?: Maybe<Scalars['DateTime']>
  arrivalTime?: Maybe<Scalars['DateTime']>
  associatedShipmentIds: StopAssociatedShipments
  /** Not valid to call on TM Stops. */
  associatedTmStop?: Maybe<Scalars['Void']>
  attemptable: Scalars['Boolean']
  /** Not valid to call. */
  baseDtsStop?: Maybe<Scalars['Void']>
  carrierEta?: Maybe<Scalars['DateTime']>
  /** @deprecated Use effectiveEta instead */
  carrierOrGeneratedEta?: Maybe<Scalars['DateTime']>
  customerAppointmentEnd?: Maybe<Scalars['DateTime']>
  departureTime?: Maybe<Scalars['DateTime']>
  documents: DocumentResponse
  effectiveEta?: Maybe<Scalars['DateTime']>
  effectiveEtaType?: Maybe<DynamicDateType>
  estimateData?: Maybe<StopEstimateFields>
  estimatedArrivalTime?: Maybe<Scalars['DateTime']>
  estimatedDepartureTime?: Maybe<Scalars['DateTime']>
  exceptions: Array<ExceptionTypes>
  id: Scalars['BigIntStopID']
  idx: Scalars['Int']
  isAppointmentValid: Scalars['Boolean']
  isCriticalAppointment: Scalars['Boolean']
  isDocExpected: Scalars['Boolean']
  isReorderable: Scalars['Boolean']
  isReschedulable: Scalars['Boolean']
  isTrailerAssignable: Scalars['Boolean']
  isTrailerSegmentStart: Scalars['Boolean']
  isValidForTrailerChange: Scalars['Boolean']
  latenessStatus?: Maybe<StopLatenessStatus>
  latenessThresholdTime?: Maybe<Scalars['DateTime']>
  location?: Maybe<Location>
  mileageType?: Maybe<Scalars['String']>
  minNeedBy?: Maybe<Scalars['DateTime']>
  /** @deprecated Use min_need_by instead */
  needBy?: Maybe<Scalars['DateTime']>
  notes: Array<LoadNote>
  plannedArrivalEnd?: Maybe<Scalars['DateTime']>
  plannedArrivalStart?: Maybe<Scalars['DateTime']>
  plannedDepartureEnd?: Maybe<Scalars['DateTime']>
  plannedDepartureStart?: Maybe<Scalars['DateTime']>
  plannedMiles?: Maybe<Scalars['Float']>
  references: Array<CustomerReferenceNumber>
  removable: Scalars['Boolean']
  runningLateSeconds: Scalars['Int']
  scosAction?: Maybe<ScosStopAction>
  scosActionFullName?: Maybe<Scalars['String']>
  skippable: Scalars['Boolean']
  status?: Maybe<StopStatus>
  stopReferences: Array<StopReference>
  tractorMileage?: Maybe<Scalars['Int']>
  trailer?: Maybe<Trailer>
  trailerId?: Maybe<Scalars['Int']>
  trailerSegmentIdx?: Maybe<Scalars['Int']>
  type?: Maybe<Scalars['String']>
  unactualizable: Scalars['Boolean']
  updatedAt?: Maybe<Scalars['DateTime']>
  validForSplit: Scalars['Boolean']
}

export type AttemptedStopException = {
  __typename?: 'AttemptedStopException'
  createdAt?: Maybe<Scalars['DateTime']>
  createdBy?: Maybe<User>
  description?: Maybe<Scalars['String']>
  driverCreatedBy?: Maybe<Scalars['Int']>
  id: Scalars['Int']
  rescheduledRyderNumber?: Maybe<Scalars['String']>
  stopId: Scalars['BigIntStopID']
  updatedAt?: Maybe<Scalars['DateTime']>
}

export type AuditTrailEvent = {
  __typename?: 'AuditTrailEvent'
  carrierScac?: Maybe<Scalars['String']>
  createDt: Scalars['DateTime']
  customerNumber: Scalars['String']
  eventCode: Scalars['String']
  eventDescription?: Maybe<Scalars['String']>
  eventName?: Maybe<Scalars['String']>
  eventTime: Scalars['DateTime']
  loadNumber?: Maybe<Scalars['String']>
  location?: Maybe<Location>
  memo?: Maybe<Scalars['String']>
  reasonCode?: Maybe<Scalars['String']>
  reasonName?: Maybe<Scalars['String']>
  shipmentNumber?: Maybe<Scalars['String']>
  source?: Maybe<Scalars['String']>
  stopId?: Maybe<Scalars['Int']>
  stopSequence?: Maybe<Scalars['Int']>
  submitter: Scalars['String']
}

export type AvailableCustomerFilterConfiguration = {
  __typename?: 'AvailableCustomerFilterConfiguration'
  filterType: CustomerFilterType
  surface: CustomerFilterSurface
}

export type BackhaulCodeUpdated = {
  __typename?: 'BackhaulCodeUpdated'
  load?: Maybe<Load>
}

export enum BackhaulEligibleCode {
  Cclton = 'CCLTON',
  Cmpahr = 'CMPAHR',
  Cupref = 'CUPREF',
  Dnnasm = 'DNNASM',
  Drturn = 'DRTURN',
  Drvchc = 'DRVCHC',
  Fmdirc = 'FMDIRC',
  Hoscft = 'HOSCFT',
  Intbhl = 'INTBHL',
  Mcbrkd = 'MCBRKD',
  Other = 'OTHER',
  Shdist = 'SHDIST',
  Spceqp = 'SPCEQP',
  Unk = 'UNK',
  Vbhpln = 'VBHPLN',
  Wethr = 'WETHR',
  Yes = 'YES',
  Yeshh = 'YESHH',
  Yespb = 'YESPB',
}

export type BaseDtsStop = {
  __typename?: 'BaseDTSStop'
  action: LocationActionType
  actualMiles?: Maybe<Scalars['Int']>
  adaptiveDeliveryDate?: Maybe<AdaptiveDeliveryDate>
  appointmentEnd?: Maybe<Scalars['DateTime']>
  appointmentStart?: Maybe<Scalars['DateTime']>
  arrivalTime?: Maybe<Scalars['DateTime']>
  associatedShipmentIds: StopAssociatedShipments
  /** Not valid to call. */
  associatedTmStop?: Maybe<Scalars['Void']>
  attemptable: Scalars['Boolean']
  /** Not valid to call on DTS Stops. */
  baseDtsStop?: Maybe<Scalars['Void']>
  carrierEta?: Maybe<Scalars['DateTime']>
  /** @deprecated Use effectiveEta instead */
  carrierOrGeneratedEta?: Maybe<Scalars['DateTime']>
  customerAppointmentEnd?: Maybe<Scalars['DateTime']>
  departureTime?: Maybe<Scalars['DateTime']>
  documents: DocumentResponse
  effectiveEta?: Maybe<Scalars['DateTime']>
  effectiveEtaType?: Maybe<DynamicDateType>
  estimateData?: Maybe<StopEstimateFields>
  estimatedArrivalTime?: Maybe<Scalars['DateTime']>
  estimatedDepartureTime?: Maybe<Scalars['DateTime']>
  exceptions: Array<ExceptionTypes>
  id: Scalars['BigIntStopID']
  idx: Scalars['Int']
  isAppointmentValid: Scalars['Boolean']
  isCriticalAppointment: Scalars['Boolean']
  isDocExpected: Scalars['Boolean']
  isReorderable: Scalars['Boolean']
  isReschedulable: Scalars['Boolean']
  isTrailerAssignable: Scalars['Boolean']
  isTrailerSegmentStart: Scalars['Boolean']
  isValidForTrailerChange: Scalars['Boolean']
  latenessStatus?: Maybe<StopLatenessStatus>
  latenessThresholdTime?: Maybe<Scalars['DateTime']>
  location?: Maybe<Location>
  mileageType?: Maybe<Scalars['String']>
  minNeedBy?: Maybe<Scalars['DateTime']>
  /** @deprecated Use min_need_by instead */
  needBy?: Maybe<Scalars['DateTime']>
  notes: Array<LoadNote>
  plannedArrivalEnd?: Maybe<Scalars['DateTime']>
  plannedArrivalStart?: Maybe<Scalars['DateTime']>
  plannedDepartureEnd?: Maybe<Scalars['DateTime']>
  plannedDepartureStart?: Maybe<Scalars['DateTime']>
  plannedMiles?: Maybe<Scalars['Float']>
  references: Array<CustomerReferenceNumber>
  removable: Scalars['Boolean']
  runningLateSeconds: Scalars['Int']
  scosAction?: Maybe<ScosStopAction>
  scosActionFullName?: Maybe<Scalars['String']>
  skippable: Scalars['Boolean']
  status?: Maybe<StopStatus>
  stopReferences: Array<StopReference>
  tractorMileage?: Maybe<Scalars['Int']>
  trailer?: Maybe<Trailer>
  trailerId?: Maybe<Scalars['Int']>
  trailerSegmentIdx?: Maybe<Scalars['Int']>
  type?: Maybe<Scalars['String']>
  unactualizable: Scalars['Boolean']
  updatedAt?: Maybe<Scalars['DateTime']>
  validForSplit: Scalars['Boolean']
}

export type BaseLoad = {
  __typename?: 'BaseLoad'
  /** Not valid to call on a BaseLoad. */
  associatedLoads?: Maybe<Scalars['Void']>
  auditTrailEvents: Array<AuditTrailEvent>
  autoCompleteScheduledTime?: Maybe<Scalars['DateTime']>
  /** Resolves to the base DTS load for an integrated TM load. */
  baseDtsLoad?: Maybe<BaseLoad>
  /** Not valid to call on a BaseLoad. */
  baseLoad?: Maybe<Scalars['Void']>
  billToId?: Maybe<Scalars['Int']>
  carrierIsPrime?: Maybe<Scalars['Boolean']>
  costCenter?: Maybe<CostCenter>
  courierJsonExtract?: Maybe<Scalars['String']>
  createdAt?: Maybe<Scalars['DateTime']>
  customerNumbers?: Maybe<Scalars['String']>
  customerReferenceNumbers: Array<CustomerReferenceNumber>
  dispatchAt?: Maybe<Scalars['DateTime']>
  documents: DocumentResponse
  endTime?: Maybe<Scalars['DateTime']>
  equipmentSize?: Maybe<Scalars['String']>
  equipmentType?: Maybe<EquipmentType>
  etasLastCalculated?: Maybe<Scalars['DateTime']>
  exceptions: Array<ExceptionTypes>
  firstPickupScheduledTimes?: Maybe<DynamicDateRange>
  firstPickupTimes?: Maybe<DynamicDateRange>
  firstStopScheduledTimes?: Maybe<DynamicDateRange>
  firstStopTimes?: Maybe<DynamicDateRange>
  freightDetails: FreightDetails
  freightRecordReferences: Array<FreightRecordReference>
  gpsEventsWithLocations: Array<GpsEventWithLocation>
  id: Scalars['Int']
  initialEstimatedTime: Scalars['Int']
  integratedRyderNumber?: Maybe<Scalars['String']>
  isRv3?: Maybe<Scalars['Boolean']>
  lastDeliveryScheduledTimes?: Maybe<DynamicDateRange>
  lastDeliveryTimes?: Maybe<DynamicDateRange>
  lastStopScheduledTimes?: Maybe<DynamicDateRange>
  lastStopTimes?: Maybe<DynamicDateRange>
  latestGpsEvent?: Maybe<GpsEventWithLocation>
  legs: Array<Leg>
  minNeedBy?: Maybe<LoadMinNeedByInfo>
  nextStop?: Maybe<Stop>
  notes: Array<LoadNote>
  operationalStop?: Maybe<OperationalStop>
  primaryReference?: Maybe<LoadReference>
  proReference?: Maybe<CustomerReferenceNumber>
  references: Array<CustomerReferenceNumber>
  route?: Maybe<Route>
  routeId?: Maybe<Scalars['Int']>
  ryderNumber?: Maybe<Scalars['String']>
  searchAndDisplayReferences: Array<CustomerReferenceNumber>
  /** @deprecated temporary for preseving backward compatibility. Eventually use `search_and_display_references` instead */
  searchAndDisplayReferences_Deprecated: Array<CustomerReferenceNumber>
  /** Not valid to call on a BaseLoad. */
  shipmentIds?: Maybe<Scalars['Void']>
  source: LoadSource
  sourceSystem: SourceSystem
  startTime?: Maybe<Scalars['DateTime']>
  status: LoadStatus
  stopReferences: Array<StopReference>
  targetDispatchStartInterval?: Maybe<Scalars['TimeDelta']>
  tenderStatus: LoadTenderStatus
  tmwVersionId: Scalars['BigInt']
  topActionableLateStop?: Maybe<Stop>
  trailer?: Maybe<Trailer>
  trailerUnitNumbers: Array<Maybe<Scalars['String']>>
  transitMode: TransitMode
}

export type BillTo = {
  __typename?: 'BillTo'
  companyTmwId: Scalars['String']
  id: Scalars['Int']
  name: Scalars['String']
}

export type BillToUpdated = {
  __typename?: 'BillToUpdated'
  load: Load
}

export enum CdlClass {
  A = 'A',
  B = 'B',
  C = 'C',
}

export enum CdlEndorsement {
  DoubleTriple = 'DOUBLE_TRIPLE',
  Hazmat = 'HAZMAT',
  Tank = 'TANK',
  TankHazmat = 'TANK_HAZMAT',
}

export enum CdlRestriction {
  ClassBcVehicleOnly = 'CLASS_BC_VEHICLE_ONLY',
  ClassCVehicleOnly = 'CLASS_C_VEHICLE_ONLY',
  CmvFullAirBrake = 'CMV_FULL_AIR_BRAKE',
  FifthWheel = 'FIFTH_WHEEL',
  FullAirBrake = 'FULL_AIR_BRAKE',
  Manual = 'MANUAL',
  MedicalVariance = 'MEDICAL_VARIANCE',
}

export type CancelLoadResponse =
  | InvalidLoadStatus
  | InvalidRadiusVersion
  | InvalidStopStatus
  | LoadCancelled
  | ObjectDoesNotExist

export type Carrier = {
  __typename?: 'Carrier'
  baseTrackingLink?: Maybe<Scalars['String']>
  id: Scalars['Int']
  name: Scalars['String']
  scac?: Maybe<Scalars['String']>
  sourceId?: Maybe<Scalars['String']>
  sourceSystem: SourceSystem
}

export type CarrierAssignedToLeg = {
  __typename?: 'CarrierAssignedToLeg'
  load: Load
}

export type CarrierDetails = {
  __typename?: 'CarrierDetails'
  carrier?: Maybe<Carrier>
  trackingLink?: Maybe<Scalars['String']>
}

export type CarrierPaginatedResponse = {
  __typename?: 'CarrierPaginatedResponse'
  meta?: Maybe<PageMeta>
  results: Array<Carrier>
}

export type CarrierQuery = {
  fuzzyMatch?: InputMaybe<Scalars['String']>
  idIn?: InputMaybe<Array<Scalars['Int']>>
  limit?: InputMaybe<Scalars['Int']>
  loadCostCenterIdIn?: InputMaybe<Array<Scalars['Int']>>
  nameEq?: InputMaybe<Scalars['String']>
  offset?: InputMaybe<Scalars['Int']>
  scacEq?: InputMaybe<Scalars['String']>
  scacIn?: InputMaybe<Array<Scalars['String']>>
  scacIsNotNull?: InputMaybe<Scalars['Boolean']>
  scacIsNull?: InputMaybe<Scalars['Boolean']>
  sort?: Array<CarrierSortFields>
  sourceIdEq?: InputMaybe<Scalars['String']>
  sourceIdIn?: InputMaybe<Array<Scalars['String']>>
  sourceIdIsNotNull?: InputMaybe<Scalars['Boolean']>
  sourceIdIsNull?: InputMaybe<Scalars['Boolean']>
  sourceSystemEq?: InputMaybe<SourceSystem>
}

export enum CarrierSortFields {
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
}

export enum CarrierType {
  NonPrime = 'NON_PRIME',
  Prime = 'PRIME',
}

export type ColumnConfiguration = {
  __typename?: 'ColumnConfiguration'
  displayName?: Maybe<Scalars['String']>
  id?: Maybe<Scalars['Int']>
  order: Scalars['Int']
  type: ColumnType
}

export type ColumnConfigurationGroup = {
  __typename?: 'ColumnConfigurationGroup'
  columnConfigurations: Array<ColumnConfiguration>
  customerId: Scalars['Int']
  entity: Entity
  id: Scalars['Int']
}

export type ColumnConfigurationInput = {
  displayName?: InputMaybe<Scalars['String']>
  order: Scalars['Int']
  type: ColumnType
}

export enum ColumnType {
  ActualDelivery = 'ACTUAL_DELIVERY',
  ActualPickupEnd = 'ACTUAL_PICKUP_END',
  ActualPickupStart = 'ACTUAL_PICKUP_START',
  AppointmentDeliveryEnd = 'APPOINTMENT_DELIVERY_END',
  AppointmentDeliveryStart = 'APPOINTMENT_DELIVERY_START',
  AppointmentPickupEnd = 'APPOINTMENT_PICKUP_END',
  AppointmentPickupStart = 'APPOINTMENT_PICKUP_START',
  CostCenter = 'COST_CENTER',
  DriverCarrier = 'DRIVER_CARRIER',
  End = 'END',
  EtaDelivery = 'ETA_DELIVERY',
  LoadCarrier = 'LOAD_CARRIER',
  LoadCountOfBikes = 'LOAD_COUNT_OF_BIKES',
  LoadCountOfDocuments = 'LOAD_COUNT_OF_DOCUMENTS',
  LoadCountOfShipments = 'LOAD_COUNT_OF_SHIPMENTS',
  LoadCreatedAt = 'LOAD_CREATED_AT',
  LoadCustomerStatus = 'LOAD_CUSTOMER_STATUS',
  LoadDestination = 'LOAD_DESTINATION',
  LoadDriver = 'LOAD_DRIVER',
  LoadExceptions = 'LOAD_EXCEPTIONS',
  LoadFirstPickupScheduledTimes = 'LOAD_FIRST_PICKUP_SCHEDULED_TIMES',
  LoadFirstPickupTimes = 'LOAD_FIRST_PICKUP_TIMES',
  LoadFirstStopScheduledTimes = 'LOAD_FIRST_STOP_SCHEDULED_TIMES',
  LoadFirstStopTimes = 'LOAD_FIRST_STOP_TIMES',
  LoadHashReference = 'LOAD_HASH_REFERENCE',
  LoadLastDeliveryScheduledTimes = 'LOAD_LAST_DELIVERY_SCHEDULED_TIMES',
  LoadLastDeliveryTimes = 'LOAD_LAST_DELIVERY_TIMES',
  LoadLastStopScheduledTimes = 'LOAD_LAST_STOP_SCHEDULED_TIMES',
  LoadLastStopTimes = 'LOAD_LAST_STOP_TIMES',
  LoadMinNeedBy = 'LOAD_MIN_NEED_BY',
  LoadNextStop = 'LOAD_NEXT_STOP',
  LoadNextStopEta = 'LOAD_NEXT_STOP_ETA',
  LoadOperatorStatus = 'LOAD_OPERATOR_STATUS',
  LoadOrigin = 'LOAD_ORIGIN',
  LoadPrimaryReference = 'LOAD_PRIMARY_REFERENCE',
  LoadTotalCostReference = 'LOAD_TOTAL_COST_REFERENCE',
  LoadTransitMode = 'LOAD_TRANSIT_MODE',
  NeedBy = 'NEED_BY',
  PlannedDeliveryEnd = 'PLANNED_DELIVERY_END',
  PlannedDeliveryStart = 'PLANNED_DELIVERY_START',
  PlannedPickupEnd = 'PLANNED_PICKUP_END',
  PlannedPickupStart = 'PLANNED_PICKUP_START',
  PoCrdd = 'PO_CRDD',
  PoFrdd = 'PO_FRDD',
  PoFrsd = 'PO_FRSD',
  PoOrdd = 'PO_ORDD',
  PoOrsd = 'PO_ORSD',
  PoVenm = 'PO_VENM',
  PrimaryReference = 'PRIMARY_REFERENCE',
  RouteCode = 'ROUTE_CODE',
  RyderLoadNumber = 'RYDER_LOAD_NUMBER',
  RyderNumber = 'RYDER_NUMBER',
  ShipmentAdaptiveDeliveryDate = 'SHIPMENT_ADAPTIVE_DELIVERY_DATE',
  ShipmentBundleCodeReference = 'SHIPMENT_BUNDLE_CODE_REFERENCE',
  ShipmentCarrier = 'SHIPMENT_CARRIER',
  ShipmentCode = 'SHIPMENT_CODE',
  ShipmentColorDescriptionReference = 'SHIPMENT_COLOR_DESCRIPTION_REFERENCE',
  ShipmentCreatedDate = 'SHIPMENT_CREATED_DATE',
  ShipmentDestination = 'SHIPMENT_DESTINATION',
  ShipmentExceptions = 'SHIPMENT_EXCEPTIONS',
  ShipmentExternalVehicleNumberReference = 'SHIPMENT_EXTERNAL_VEHICLE_NUMBER_REFERENCE',
  ShipmentFirstPickupScheduledTimes = 'SHIPMENT_FIRST_PICKUP_SCHEDULED_TIMES',
  ShipmentFirstPickupTimes = 'SHIPMENT_FIRST_PICKUP_TIMES',
  ShipmentLastDeliveryScheduledTimes = 'SHIPMENT_LAST_DELIVERY_SCHEDULED_TIMES',
  ShipmentLastDeliveryTimes = 'SHIPMENT_LAST_DELIVERY_TIMES',
  ShipmentModelNumberReference = 'SHIPMENT_MODEL_NUMBER_REFERENCE',
  ShipmentOrigin = 'SHIPMENT_ORIGIN',
  ShipmentPoNumberReference = 'SHIPMENT_PO_NUMBER_REFERENCE',
  ShipmentRequestedDeliveryDate = 'SHIPMENT_REQUESTED_DELIVERY_DATE',
  ShipmentRequestedPickupDate = 'SHIPMENT_REQUESTED_PICKUP_DATE',
  ShipmentSalesOrderNumberReference = 'SHIPMENT_SALES_ORDER_NUMBER_REFERENCE',
  ShipmentStatus = 'SHIPMENT_STATUS',
  ShipmentTransitMode = 'SHIPMENT_TRANSIT_MODE',
  ShipmentVinReference = 'SHIPMENT_VIN_REFERENCE',
  Start = 'START',
  StopCount = 'STOP_COUNT',
  TractorUnitNumber = 'TRACTOR_UNIT_NUMBER',
  TrailerUnitNumber = 'TRAILER_UNIT_NUMBER',
}

/** Response type for completing a service event. */
export type CompleteServiceEventResponse =
  | InvalidServiceEventComplete
  | InvalidServiceEventStatus
  | InvalidTractorStatus
  | InvalidTrailerStatus
  | NotSupportedByCostCenter
  | ObjectDoesNotExist
  | TractorServiceEventCompleted
  | TrailerServiceEventCompleted

export type CompletedStopsReordered = {
  __typename?: 'CompletedStopsReordered'
  load: Load
}

export type Consignee = {
  __typename?: 'Consignee'
  allowNotifications: Scalars['Boolean']
  createdAt?: Maybe<Scalars['String']>
  customerId: Scalars['Int']
  email?: Maybe<Scalars['String']>
  enabledNotificationTypes: Array<ConsigneeNotificationType>
  id: Scalars['Int']
  location?: Maybe<Location>
  locationId?: Maybe<Scalars['BigIntLocationID']>
  phone?: Maybe<Scalars['String']>
  sentNotifications: Array<SentNotification>
  tmStopLocationReferenceValue?: Maybe<Scalars['String']>
  updatedAt?: Maybe<Scalars['String']>
  xMinAwayMinutes?: Maybe<Scalars['Int']>
}

export type ConsigneeSentNotificationsArgs = {
  limit?: InputMaybe<Scalars['Int']>
}

export type ConsigneeAllowNotificationsUpdate = {
  allowNotifications: Scalars['Boolean']
  consigneeId: Scalars['Int']
}

export type ConsigneeAllowNotificationsUpdateResponse =
  | ConsigneeAllowNotificationsUpdated
  | ObjectDoesNotExist

export type ConsigneeAllowNotificationsUpdated = {
  __typename?: 'ConsigneeAllowNotificationsUpdated'
  consignee: Consignee
}

export type ConsigneeAlreadyExists = ErrorType & {
  __typename?: 'ConsigneeAlreadyExists'
  message: Scalars['String']
}

export type ConsigneeCreate = {
  customerId: Scalars['Int']
  email?: InputMaybe<Scalars['String']>
  locationId?: InputMaybe<Scalars['BigIntLocationID']>
  locationReference?: InputMaybe<Scalars['String']>
  notificationTypes?: Array<ConsigneeNotificationType>
  phone?: InputMaybe<Scalars['String']>
  xMinAwayMinutes?: InputMaybe<Scalars['Int']>
}

export type ConsigneeCreateResponse =
  | ConsigneeAlreadyExists
  | ConsigneeCreated
  | InvalidConsigneeCreate
  | ObjectDoesNotExist

export type ConsigneeCreated = {
  __typename?: 'ConsigneeCreated'
  consignee: Consignee
}

export enum ConsigneeNotificationType {
  Lateness = 'LATENESS',
  LatenessAll = 'LATENESS_ALL',
  LateArrivalException = 'LATE_ARRIVAL_EXCEPTION',
  LoadPlanned = 'LOAD_PLANNED',
  OsdException = 'OSD_EXCEPTION',
  StatusStarted = 'STATUS_STARTED',
  StopCompleted = 'STOP_COMPLETED',
  XMinAway = 'X_MIN_AWAY',
  XMinAwayAll = 'X_MIN_AWAY_ALL',
}

export type ConsigneeNotificationTypeToggle = {
  consigneeId: Scalars['Int']
  enabled: Scalars['Boolean']
  notificationType: ConsigneeNotificationType
}

export type ConsigneeNotificationTypeToggleResponse =
  | ConsigneeNotificationTypeToggled
  | ObjectDoesNotExist

export type ConsigneeNotificationTypeToggled = {
  __typename?: 'ConsigneeNotificationTypeToggled'
  consigneeId: Scalars['Int']
  enabledNotificationTypes: Array<ConsigneeNotificationType>
}

export type Contact = {
  __typename?: 'Contact'
  email?: Maybe<Scalars['String']>
  firstName: Scalars['String']
  id: Scalars['Int']
  lastName?: Maybe<Scalars['String']>
  phoneNumber?: Maybe<Scalars['String']>
}

export type CostCenter = {
  __typename?: 'CostCenter'
  allowedStopEvents: Array<NamedStopEvent>
  billTos: Array<BillTo>
  canEditFacilities: Scalars['Boolean']
  canManageEquipment: Scalars['Boolean']
  code?: Maybe<Scalars['String']>
  customerName: Scalars['String']
  drivers: Array<Driver>
  fixedRoutes: Array<Route>
  id: Scalars['Int']
  isFmsBusinessUnit: Scalars['Boolean']
  name: Scalars['String']
  radiusVersion: RadiusVersion
  stopLateReasons: Array<StopLateReason>
  stopTypes: Array<CostCenterStopType>
  supportsResourceChange: Scalars['Boolean']
  usesTenderStatus: Scalars['Boolean']
}

export type CostCenterFixedRoutesArgs = {
  query?: InputMaybe<RouteQuery>
}

export type CostCenterEmacsInfo = {
  __typename?: 'CostCenterEmacsInfo'
  costCenter: CostCenter
  costCenterId: Scalars['Int']
  driverEmacsInfo: Array<DriverEmacsInfo>
  emacsInfo: Array<EmacsAggregate>
  rollingWeeklySums: Array<DatedEmacsAggregate>
}

export type CostCenterNotExists = ErrorType & {
  __typename?: 'CostCenterNotExists'
  message: Scalars['String']
}

export type CostCenterPaginatedResponse = {
  __typename?: 'CostCenterPaginatedResponse'
  meta?: Maybe<PageMeta>
  results: Array<CostCenter>
}

export type CostCenterQuery = {
  codeEq?: InputMaybe<Scalars['String']>
  codeIn?: InputMaybe<Array<Scalars['String']>>
  codeIsNotNull?: InputMaybe<Scalars['Boolean']>
  codeIsNull?: InputMaybe<Scalars['Boolean']>
  customerId?: InputMaybe<Scalars['Int']>
  customerIdIn?: InputMaybe<Array<Scalars['Int']>>
  customerNameEq?: InputMaybe<Scalars['String']>
  customerNameIn?: InputMaybe<Array<Scalars['String']>>
  distanceToCostCenterIdLessThan?: InputMaybe<Array<Scalars['Int']>>
  fuzzyMatch?: InputMaybe<Scalars['String']>
  geotabIdIn?: InputMaybe<Array<Scalars['String']>>
  geotabIdIsNotNull?: InputMaybe<Scalars['Boolean']>
  geotabIdIsNull?: InputMaybe<Scalars['Boolean']>
  hasDriverManager?: InputMaybe<Scalars['Boolean']>
  hasPayrollDriver?: InputMaybe<Scalars['Boolean']>
  idEq?: InputMaybe<Scalars['Int']>
  idIn?: InputMaybe<Array<Scalars['Int']>>
  isActiveEq?: InputMaybe<Scalars['Boolean']>
  isOnboardedEq?: InputMaybe<Scalars['Boolean']>
  isRealCostCenter?: InputMaybe<Scalars['Boolean']>
  limit?: InputMaybe<Scalars['Int']>
  nameIcontains?: InputMaybe<Scalars['String']>
  nameIlike?: InputMaybe<Scalars['String']>
  offset?: InputMaybe<Scalars['Int']>
  sort?: Array<CostCenterSortFields>
  stopLocationIdIn?: InputMaybe<Array<Scalars['Int']>>
}

export enum CostCenterSortFields {
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
}

export type CostCenterStopType = {
  __typename?: 'CostCenterStopType'
  code: Scalars['String']
  name: Scalars['String']
  namedScosActions: Array<NamedStopEvent>
}

export type CostCenterToOtherCostCenterDistance = {
  __typename?: 'CostCenterToOtherCostCenterDistance'
  id: Scalars['Int']
  otherCostCentersDistance: Array<OtherCostCenterDistance>
}

export type CreateCustomerResponse =
  | CostCenterNotExists
  | CustomerAlreadyExists
  | CustomerCreated
  | InvalidCostCenterCode
  | InvalidCostCenterForCustomer
  | InvalidTmCustomerCode

export type CreateFacilityContactResponse =
  | FacilityContactCreated
  | InvalidContact
  | InvalidEmailAddress
  | InvalidFacilityForEdit
  | InvalidPhoneNumber
  | ObjectDoesNotExist

export type CreateFacilityNoteResponse =
  | FacilityNoteCreated
  | InvalidFacilityForEdit
  | ObjectDoesNotExist

export type CreateFacilityResponse =
  | CostCenterNotExists
  | DuplicateFacilityCode
  | DuplicateFacilityName
  | FacilityCreated
  | InvalidCountryCode
  | InvalidCountrySubdivisionCode
  | InvalidFacilityCode
  | InvalidFacilityName
  | NotSupportedByCostCenter

export type CreateLoadNoteResponse =
  | InvalidLoadNoteCreate
  | InvalidLoadStatus
  | InvalidRadiusVersion
  | LoadNoteCreated
  | ObjectDoesNotExist

/** Response type for creating a note. */
export type CreateNoteResponse =
  | InvalidNoteBody
  | InvalidTractorStatus
  | InvalidTrailerStatus
  | NoteCreated
  | ObjectDoesNotExist

export type CreateReferenceResponse =
  | FreightRecordReferenceCreated
  | InvalidLoadStatus
  | InvalidRadiusVersion
  | InvalidReferenceCreate
  | LoadReferenceCreated
  | ObjectDoesNotExist
  | StopReferenceCreated

/** Response type for creating a service event. */
export type CreateServiceEventResponse =
  | InvalidTractorStatus
  | InvalidTrailerStatus
  | NotSupportedByCostCenter
  | ObjectDoesNotExist
  | TractorServiceEventCreated
  | TrailerServiceEventCreated

/** Response for creating a trailer */
export type CreateTrailerResponse =
  | DuplicateTrailerUnitNumber
  | DuplicateTrailerVin
  | InvalidTrailerCreate
  | ObjectDoesNotExist
  | TrailerCreated

export type Customer = {
  __typename?: 'Customer'
  availableFiltersConfiguration?: Maybe<Array<AvailableCustomerFilterConfiguration>>
  code?: Maybe<Scalars['String']>
  columnConfigurationGroups: Array<ColumnConfigurationGroup>
  consignees: Array<Consignee>
  docInfoLabel?: Maybe<Scalars['String']>
  enabledExceptionTypes: Array<ExceptionType>
  enabledFilters: Array<CustomerFilterType>
  id: Scalars['Int']
  name: Scalars['String']
  transitionDate?: Maybe<Scalars['DateTime']>
  type: CustomerType
  useLatenessAll: Scalars['Boolean']
  useXmaAll: Scalars['Boolean']
}

export type CustomerAlreadyExists = ErrorType & {
  __typename?: 'CustomerAlreadyExists'
  message: Scalars['String']
}

export type CustomerCodeUpdate = {
  code: Scalars['String']
  customerId: Scalars['Int']
}

export type CustomerColumnConfigurationUpsert = {
  columnConfigurations: Array<ColumnConfigurationInput>
  customerId: Scalars['Int']
  entity: Entity
}

export type CustomerColumnConfigurationUpserted = {
  __typename?: 'CustomerColumnConfigurationUpserted'
  columnConfigurationGroup?: Maybe<ColumnConfigurationGroup>
}

export type CustomerCostCenter = {
  costCenterId: Scalars['Int']
  customerId: Scalars['Int']
}

export type CustomerCostCenterCreate = {
  costCenterCode: Scalars['String']
  customerId: Scalars['Int']
}

export type CustomerCostCenterUpdated = {
  __typename?: 'CustomerCostCenterUpdated'
  customerId: Scalars['Int']
}

export type CustomerCreate = {
  code?: InputMaybe<Scalars['String']>
  costCenterCodes: Array<Scalars['String']>
  name: Scalars['String']
  type: CustomerType
}

export type CustomerCreated = {
  __typename?: 'CustomerCreated'
  customer: Customer
}

export type CustomerExceptionQuery = {
  appointmentDateRange?: InputMaybe<Array<Scalars['DateTime']>>
  carrierIdIn?: InputMaybe<Array<Scalars['Int']>>
  carrierIsRyderDts?: InputMaybe<Scalars['Boolean']>
  carrierUnassigned?: InputMaybe<Scalars['Boolean']>
  costCenterIdIn?: InputMaybe<Array<Scalars['Int']>>
  etaActualDateRange?: InputMaybe<Array<Scalars['DateTime']>>
  firstPickupScheduledTimesDateRange?: InputMaybe<Array<Scalars['DateTime']>>
  firstPickupTimesDateRange?: InputMaybe<Array<Scalars['DateTime']>>
  firstStopScheduledTimesDateRange?: InputMaybe<Array<Scalars['DateTime']>>
  firstStopTimesDateRange?: InputMaybe<Array<Scalars['DateTime']>>
  lastDeliveryScheduledTimesDateRange?: InputMaybe<Array<Scalars['DateTime']>>
  lastDeliveryTimesDateRange?: InputMaybe<Array<Scalars['DateTime']>>
  lastStopScheduledTimesDateRange?: InputMaybe<Array<Scalars['DateTime']>>
  lastStopTimesDateRange?: InputMaybe<Array<Scalars['DateTime']>>
  limit?: InputMaybe<Scalars['Int']>
  locationIdIn?: InputMaybe<Array<Scalars['BigIntLocationID']>>
  offset?: InputMaybe<Scalars['Int']>
  plannedStartDateRange?: InputMaybe<Array<Scalars['Date']>>
  routeIdIn?: InputMaybe<Array<Scalars['Int']>>
  scheduledTimesDateRange?: InputMaybe<Array<Scalars['DateTime']>>
  sortByArrival?: InputMaybe<SortInput>
  sortByExceptionType?: InputMaybe<SortInput>
  sortByScheduledTime?: InputMaybe<SortInput>
  typeIn?: InputMaybe<Array<ExceptionType>>
}

export type CustomerExceptionRow = {
  __typename?: 'CustomerExceptionRow'
  exception: CustomerExceptionTypes
  load?: Maybe<Load>
  stop?: Maybe<Stop>
}

export type CustomerExceptionRowPaginatedResponse = {
  __typename?: 'CustomerExceptionRowPaginatedResponse'
  meta?: Maybe<PageMeta>
  results: Array<CustomerExceptionRow>
}

export type CustomerExceptionTypes =
  | AttemptedStopException
  | DamageException
  | LateArrivalException
  | MissingDocumentException
  | OverageException
  | RunningLateException
  | ShortageException
  | SkippedStopException

export type CustomerFilterConfigToggle = {
  customerId: Scalars['Int']
  enabled: Scalars['Boolean']
  filterType: CustomerFilterType
}

export type CustomerFilterConfigToggleResponse =
  | CustomerFilterConfigToggled
  | ObjectDoesNotExist

export type CustomerFilterConfigToggled = {
  __typename?: 'CustomerFilterConfigToggled'
  customerId: Scalars['Int']
  enabledFilters: Array<CustomerFilterType>
}

export enum CustomerFilterSurface {
  Exceptions = 'EXCEPTIONS',
  Loads = 'LOADS',
  Network = 'NETWORK',
  Shipments = 'SHIPMENTS',
}

export enum CustomerFilterType {
  ExceptionCarrier = 'EXCEPTION_CARRIER',
  ExceptionCostCenter = 'EXCEPTION_COST_CENTER',
  ExceptionDateAppointment = 'EXCEPTION_DATE_APPOINTMENT',
  ExceptionDateEtaActual = 'EXCEPTION_DATE_ETA_ACTUAL',
  ExceptionDateFirstPickup = 'EXCEPTION_DATE_FIRST_PICKUP',
  ExceptionDateFirstStop = 'EXCEPTION_DATE_FIRST_STOP',
  ExceptionDateLastDelivery = 'EXCEPTION_DATE_LAST_DELIVERY',
  ExceptionDateLastStop = 'EXCEPTION_DATE_LAST_STOP',
  ExceptionDatePlannedStart = 'EXCEPTION_DATE_PLANNED_START',
  ExceptionDateScheduledFirstPickup = 'EXCEPTION_DATE_SCHEDULED_FIRST_PICKUP',
  ExceptionDateScheduledFirstStop = 'EXCEPTION_DATE_SCHEDULED_FIRST_STOP',
  ExceptionDateScheduledLastDelivery = 'EXCEPTION_DATE_SCHEDULED_LAST_DELIVERY',
  ExceptionDateScheduledLastStop = 'EXCEPTION_DATE_SCHEDULED_LAST_STOP',
  ExceptionDateScheduledTimes = 'EXCEPTION_DATE_SCHEDULED_TIMES',
  ExceptionLocation = 'EXCEPTION_LOCATION',
  ExceptionRoute = 'EXCEPTION_ROUTE',
  ExceptionType = 'EXCEPTION_TYPE',
  LoadCarrier = 'LOAD_CARRIER',
  LoadCarrierType = 'LOAD_CARRIER_TYPE',
  LoadCostCenter = 'LOAD_COST_CENTER',
  LoadDateFirstPickup = 'LOAD_DATE_FIRST_PICKUP',
  LoadDateFirstStop = 'LOAD_DATE_FIRST_STOP',
  LoadDateLastDelivery = 'LOAD_DATE_LAST_DELIVERY',
  LoadDateLastStop = 'LOAD_DATE_LAST_STOP',
  LoadDatePlannedStart = 'LOAD_DATE_PLANNED_START',
  LoadDateScheduledFirstPickup = 'LOAD_DATE_SCHEDULED_FIRST_PICKUP',
  LoadDateScheduledFirstStop = 'LOAD_DATE_SCHEDULED_FIRST_STOP',
  LoadDateScheduledLastDelivery = 'LOAD_DATE_SCHEDULED_LAST_DELIVERY',
  LoadDateScheduledLastStop = 'LOAD_DATE_SCHEDULED_LAST_STOP',
  LoadExceptions = 'LOAD_EXCEPTIONS',
  LoadFilterGroup = 'LOAD_FILTER_GROUP',
  LoadOriginDestination = 'LOAD_ORIGIN_DESTINATION',
  LoadRoute = 'LOAD_ROUTE',
  LoadRunningLate = 'LOAD_RUNNING_LATE',
  LoadStatus = 'LOAD_STATUS',
  LoadStopLocation = 'LOAD_STOP_LOCATION',
  LoadTractor = 'LOAD_TRACTOR',
  LoadTrailer = 'LOAD_TRAILER',
  NetworkExceptions = 'NETWORK_EXCEPTIONS',
  NetworkRunningLate = 'NETWORK_RUNNING_LATE',
  NetworkWhiteGlove = 'NETWORK_WHITE_GLOVE',
  ShipmentCarrier = 'SHIPMENT_CARRIER',
  ShipmentCarrierType = 'SHIPMENT_CARRIER_TYPE',
  ShipmentCostCenter = 'SHIPMENT_COST_CENTER',
  ShipmentDateActualDelivery = 'SHIPMENT_DATE_ACTUAL_DELIVERY',
  ShipmentDateActualPickup = 'SHIPMENT_DATE_ACTUAL_PICKUP',
  ShipmentDateAppointmentDelivery = 'SHIPMENT_DATE_APPOINTMENT_DELIVERY',
  ShipmentDateAppointmentPickup = 'SHIPMENT_DATE_APPOINTMENT_PICKUP',
  ShipmentDateDelivery = 'SHIPMENT_DATE_DELIVERY',
  ShipmentDateMustArriveBy = 'SHIPMENT_DATE_MUST_ARRIVE_BY',
  ShipmentDatePickup = 'SHIPMENT_DATE_PICKUP',
  ShipmentDatePlannedDelivery = 'SHIPMENT_DATE_PLANNED_DELIVERY',
  ShipmentDatePlannedPickup = 'SHIPMENT_DATE_PLANNED_PICKUP',
  ShipmentDateScheduledDelivery = 'SHIPMENT_DATE_SCHEDULED_DELIVERY',
  ShipmentDateScheduledPickup = 'SHIPMENT_DATE_SCHEDULED_PICKUP',
  ShipmentExceptions = 'SHIPMENT_EXCEPTIONS',
  ShipmentFilterGroup = 'SHIPMENT_FILTER_GROUP',
  ShipmentMode = 'SHIPMENT_MODE',
  ShipmentOriginDestination = 'SHIPMENT_ORIGIN_DESTINATION',
  ShipmentRunningLate = 'SHIPMENT_RUNNING_LATE',
  ShipmentStatus = 'SHIPMENT_STATUS',
  ShipmentSupplier = 'SHIPMENT_SUPPLIER',
  ShipmentWhiteGlove = 'SHIPMENT_WHITE_GLOVE',
}

export type CustomerLatenessConfiguration = {
  customerId: Scalars['Int']
  id: Scalars['Int']
  relativeDatetimeField: RelativeDatetimeField
  thresholdMins: Scalars['Int']
  transitMode: LatenessTransitMode
}

export type CustomerLatenessConfigurationCreate = {
  customerId: Scalars['Int']
  relativeDatetimeField: RelativeDatetimeField
  thresholdMins: Scalars['Int']
  transitMode: LatenessTransitMode
}

export type CustomerLatenessConfigurationDelete = {
  customerId: Scalars['Int']
  id: Scalars['Int']
}

export type CustomerLatenessConfigurationNotFound = ErrorType & {
  __typename?: 'CustomerLatenessConfigurationNotFound'
  message: Scalars['String']
}

export type CustomerLatenessConfigurationUpdated = {
  __typename?: 'CustomerLatenessConfigurationUpdated'
  customerId: Scalars['Int']
}

export type CustomerPaginatedResponse = {
  __typename?: 'CustomerPaginatedResponse'
  meta?: Maybe<PageMeta>
  results: Array<Customer>
}

export type CustomerQuery = {
  codeEq?: InputMaybe<Scalars['String']>
  codeIn?: InputMaybe<Array<Scalars['String']>>
  codeIsNotNull?: InputMaybe<Scalars['Boolean']>
  codeIsNull?: InputMaybe<Scalars['Boolean']>
  limit?: InputMaybe<Scalars['Int']>
  nameEq?: InputMaybe<Scalars['String']>
  nameIlike?: InputMaybe<Scalars['String']>
  offset?: InputMaybe<Scalars['Int']>
  typeEq?: InputMaybe<CustomerType>
}

export type CustomerReferenceNumber = {
  __typename?: 'CustomerReferenceNumber'
  displayName?: Maybe<Scalars['String']>
  id: Scalars['Int']
  isDisplayed: Scalars['Boolean']
  loadId: Scalars['Int']
  sourceSystem: SourceSystem
  type: Scalars['String']
  typeName?: Maybe<Scalars['String']>
  value: Scalars['String']
}

export type CustomerReferenceNumberPaginatedResponse = {
  __typename?: 'CustomerReferenceNumberPaginatedResponse'
  meta?: Maybe<PageMeta>
  results: Array<CustomerReferenceNumber>
}

export type CustomerReferenceNumberQuery = {
  costCenterIdIn?: InputMaybe<Array<Scalars['Int']>>
  distinctOn?: InputMaybe<Array<Scalars['String']>>
  idEq?: InputMaybe<Scalars['Int']>
  idIn?: InputMaybe<Array<Scalars['Int']>>
  isSearchAndDisplay?: InputMaybe<Scalars['Boolean']>
  limit?: InputMaybe<Scalars['Int']>
  loadCostCenterIdIn?: InputMaybe<Array<Scalars['Int']>>
  loadIdEq?: InputMaybe<Scalars['Int']>
  loadIdIn?: InputMaybe<Array<Scalars['Int']>>
  loadIdIsNotNull?: InputMaybe<Scalars['Boolean']>
  loadIdIsNull?: InputMaybe<Scalars['Boolean']>
  loadReferenceTypeCostCenterIdIn?: InputMaybe<Array<Scalars['Int']>>
  offset?: InputMaybe<Scalars['Int']>
  sourceSystemEq?: InputMaybe<SourceSystem>
  sourceSystemNotIn?: InputMaybe<Array<SourceSystem>>
  typeEq?: InputMaybe<Scalars['String']>
  typeIn?: InputMaybe<Array<Scalars['String']>>
  valueEq?: InputMaybe<Scalars['String']>
  valueIcontains?: InputMaybe<Scalars['String']>
  valueIlikeAny?: InputMaybe<Array<Scalars['String']>>
  valueIn?: InputMaybe<Array<Scalars['String']>>
}

export enum CustomerType {
  Dts = 'DTS',
  Integrated = 'INTEGRATED',
  Tm = 'TM',
}

export type CustomerUpdated = {
  __typename?: 'CustomerUpdated'
  customer: Customer
}

export type CustomerUserCreate = {
  costCenterCodes: Array<Scalars['String']>
  customerId: Scalars['Int']
  email: Scalars['String']
}

export type CustomerUserCreateResponse =
  | CustomerUserCreated
  | InvalidEmailAddress
  | InvalidPassword
  | InvalidUserCredentials
  | ObjectDoesNotExist
  | UserAlreadyExists
  | UserHasCustomer

export type CustomerUserCreated = {
  __typename?: 'CustomerUserCreated'
  user: User
}

export type CustomerUserUpdate = {
  costCenterCodes: Array<Scalars['String']>
  userId: Scalars['Int']
}

export type CustomerUserUpdateResponse =
  | CustomerUserUpdated
  | InvalidCostCenterForCustomer
  | InvalidCustomerForUser

export type CustomerUserUpdated = {
  __typename?: 'CustomerUserUpdated'
  costCenterCodes: Array<Scalars['String']>
  userId: Scalars['Int']
}

export type DamageException = {
  __typename?: 'DamageException'
  createdAt?: Maybe<Scalars['DateTime']>
  description?: Maybe<Scalars['String']>
  id: Scalars['Int']
  osdRecordId: Scalars['Int']
  stopId: Scalars['BigIntStopID']
  updatedAt?: Maybe<Scalars['DateTime']>
}

export type DatedEmacsAggregate = {
  __typename?: 'DatedEmacsAggregate'
  date: Scalars['Date']
  emacsAggregate: EmacsAggregate
}

export enum DayOfWeek {
  Friday = 'FRIDAY',
  Monday = 'MONDAY',
  Saturday = 'SATURDAY',
  Sunday = 'SUNDAY',
  Thursday = 'THURSDAY',
  Tuesday = 'TUESDAY',
  Wednesday = 'WEDNESDAY',
}

export type DefaultTractorAssignmentError = ErrorType & {
  __typename?: 'DefaultTractorAssignmentError'
  message: Scalars['String']
}

export type DeleteFacilityContactResponse =
  | FacilityContactDeleted
  | InvalidFacilityForEdit
  | ObjectDoesNotExist

export type DeleteFacilityNoteResponse =
  | FacilityNoteDeleted
  | InvalidFacilityForEdit
  | ObjectDoesNotExist

/** Response type for deleting a note. */
export type DeleteNoteResponse =
  | InvalidLoadNoteDelete
  | InvalidLoadStatus
  | InvalidRadiusVersion
  | InvalidTractorStatus
  | InvalidTrailerStatus
  | NoteDeleted
  | ObjectDoesNotExist

export type DeleteQualificationResponse = ObjectDoesNotExist | QualificationDeleted

export type DeleteReferenceResponse =
  | FreightRecordReferenceDeleted
  | InvalidLoadStatus
  | InvalidRadiusVersion
  | LoadReferenceDeleted
  | ObjectDoesNotExist
  | StopReferenceDeleted

/** Response type for deleting a service event. */
export type DeleteServiceEventResponse =
  | InvalidServiceEventStatus
  | InvalidTractorStatus
  | InvalidTrailerStatus
  | NotSupportedByCostCenter
  | ObjectDoesNotExist
  | ServiceEventDeleted

export type DeleteTrailerChangeResponse =
  | InvalidLegStatus
  | InvalidLoadStatus
  | InvalidRadiusVersion
  | InvalidStopEvent
  | InvalidStopStatus
  | InvalidTrailerChangeDelete
  | ObjectDoesNotExist
  | TrailerChangeDeleted

export type DenyDriverShareRequestInput = {
  id: Scalars['Int']
}

export type DispatchLoadToDriverResponse =
  | DispatchedToDrivers
  | InvalidDriverAssignment
  | InvalidLegUpdateError
  | InvalidLoadStatus
  | InvalidTmwVersionIdClient
  | InvalidTmwVersionIdScos
  | NoDriverAssignedToLeg
  | ObjectDoesNotExist
  | TmwValidationError

export type DispatchedToDrivers = {
  __typename?: 'DispatchedToDrivers'
  load: Load
  tmwVersionId: Scalars['BigInt']
}

export type Document = {
  __typename?: 'Document'
  createdAt?: Maybe<Scalars['DateTime']>
  docInfo?: Maybe<Scalars['String']>
  extension: DocumentExtension
  name: Scalars['String']
  stopId?: Maybe<Scalars['BigIntStopID']>
  tmwStopId?: Maybe<Scalars['Int']>
  type: DocumentType
  url: Scalars['String']
}

export enum DocumentExtension {
  Pdf = 'PDF',
}

export type DocumentList = {
  __typename?: 'DocumentList'
  documents: Array<Document>
}

export type DocumentListWithMissing = {
  __typename?: 'DocumentListWithMissing'
  documents: Array<DocumentOrMissing>
}

export type DocumentOrMissing = Document | MissingDocument

export type DocumentResponse =
  | DocumentList
  | DocumentListWithMissing
  | UnableToRetrieveDocuments

export enum DocumentType {
  BillOfLading = 'BILL_OF_LADING',
  Cargo = 'CARGO',
  DeliveryReceipt = 'DELIVERY_RECEIPT',
  DriverSignOff = 'DRIVER_SIGN_OFF',
  ExtraTripSlip = 'EXTRA_TRIP_SLIP',
  FineReceipt = 'FINE_RECEIPT',
  FuelReceipt = 'FUEL_RECEIPT',
  InspectionCertificate = 'INSPECTION_CERTIFICATE',
  Invoice = 'INVOICE',
  LateSlip = 'LATE_SLIP',
  LetterOfAuthorization = 'LETTER_OF_AUTHORIZATION',
  LoadQuality = 'LOAD_QUALITY',
  LumperCertificate = 'LUMPER_CERTIFICATE',
  LumperReceipt = 'LUMPER_RECEIPT',
  Mb = 'MB',
  Miscellaneous = 'MISCELLANEOUS',
  Osd = 'OSD',
  Other = 'OTHER',
  PackingSlip = 'PACKING_SLIP',
  Photograph = 'PHOTOGRAPH',
  PortTicket = 'PORT_TICKET',
  PortTicketInOut = 'PORT_TICKET_IN_OUT',
  ProofOfDelivery = 'PROOF_OF_DELIVERY',
  Return = 'RETURN',
  ScannedDocument = 'SCANNED_DOCUMENT',
  Tender = 'TENDER',
  TripSheet = 'TRIP_SHEET',
  WeightCertificate = 'WEIGHT_CERTIFICATE',
  WeightReceipt = 'WEIGHT_RECEIPT',
  WfxReceipt = 'WFX_RECEIPT',
}

export type Driver = {
  __typename?: 'Driver'
  associatedTractor?: Maybe<Tractor>
  authorizedToDrive: Scalars['Boolean']
  costCenters: Array<DriverCostCenter>
  defaultTractorId?: Maybe<Scalars['Int']>
  domicile?: Maybe<Location>
  email?: Maybe<Scalars['String']>
  employeeId?: Maybe<Scalars['String']>
  fullname: Scalars['String']
  geodapterStatus?: Maybe<DriverStatus>
  geotabId?: Maybe<Scalars['String']>
  id: Scalars['Int']
  isActive: Scalars['Boolean']
  license: DriversLicense
  manager?: Maybe<Worker>
  managerId?: Maybe<Scalars['Int']>
  phone?: Maybe<Scalars['String']>
  preferences: Array<Scalars['String']>
  previouslySharedToCostCenter: Scalars['Boolean']
  qualifications: Array<DriverQualification>
  tmwId?: Maybe<Scalars['String']>
}

export type DriverPreviouslySharedToCostCenterArgs = {
  costCenterId: Scalars['Int']
}

export type DriverAssignedToLeg = {
  __typename?: 'DriverAssignedToLeg'
  equipmentMoveAction?: Maybe<EquipmentMove>
  load: Load
  tractorAssignErrorMessage?: Maybe<DefaultTractorAssignmentError>
}

export enum DriverAvailabilityStatus {
  Available = 'AVAILABLE',
  Off = 'OFF',
  OnLoad = 'ON_LOAD',
  Unknown = 'UNKNOWN',
}

export type DriverCostCenter = {
  __typename?: 'DriverCostCenter'
  code?: Maybe<Scalars['String']>
  customerName: Scalars['String']
  id: Scalars['Int']
  isOperational: Scalars['Boolean']
  isPayroll: Scalars['Boolean']
  name: Scalars['String']
}

export enum DriverDutyStatus {
  D = 'D',
  Off = 'OFF',
  On = 'ON',
  Sb = 'SB',
  Ym = 'YM',
}

export type DriverEmacsInfo = {
  __typename?: 'DriverEmacsInfo'
  driver: Driver
  driverId: Scalars['Int']
  emacsInfo: EmacsAggregate
  rollingWeeklySums: Array<DatedEmacsAggregate>
}

export type DriverPaginatedResponse = {
  __typename?: 'DriverPaginatedResponse'
  meta?: Maybe<PageMeta>
  results: Array<Driver>
}

export type DriverQualification = {
  __typename?: 'DriverQualification'
  completedAt?: Maybe<Scalars['Date']>
  driverId: Scalars['Int']
  expiresAt?: Maybe<Scalars['Date']>
  id: Scalars['Int']
  name: Scalars['String']
}

export type DriverQualificationAdd = {
  completedAt?: InputMaybe<Scalars['Date']>
  driverId: Scalars['Int']
  expiresAt?: InputMaybe<Scalars['Date']>
  qualificationId: Scalars['Int']
}

export type DriverQualificationRemoved = {
  __typename?: 'DriverQualificationRemoved'
  driverId: Scalars['Int']
  qualificationId: Scalars['Int']
}

export type DriverQualificationUpdate = {
  completedAt?: InputMaybe<Scalars['Date']>
  driverId: Scalars['Int']
  expiresAt?: InputMaybe<Scalars['Date']>
  qualificationId: Scalars['Int']
}

export type DriverQuery = {
  availableDuringFutureWindow?: InputMaybe<Array<Scalars['DateTime']>>
  availableDuringHaulRequestWindow?: InputMaybe<Array<Scalars['DateTime']>>
  cdlClassIn?: InputMaybe<Array<Scalars['String']>>
  costCenterIdIn?: InputMaybe<Array<Scalars['Int']>>
  costCenterNameIn?: InputMaybe<Array<Scalars['String']>>
  distanceToCostCenterIdLessThan?: InputMaybe<Array<Scalars['Int']>>
  dutyStatusIn?: InputMaybe<Array<Scalars['String']>>
  employeeIdIn?: InputMaybe<Array<Scalars['String']>>
  employeeIdOrTmwIdEq?: InputMaybe<Array<Scalars['String']>>
  endorsementsContain?: InputMaybe<Array<Scalars['String']>>
  fuzzyMatch?: InputMaybe<Scalars['String']>
  geotabIdIn?: InputMaybe<Array<Scalars['String']>>
  geotabIdIsNotNull?: InputMaybe<Scalars['Boolean']>
  geotabIdIsNull?: InputMaybe<Scalars['Boolean']>
  idEq?: InputMaybe<Scalars['Int']>
  idIn?: InputMaybe<Array<Scalars['Int']>>
  isActiveEq?: InputMaybe<Scalars['Boolean']>
  limit?: InputMaybe<Scalars['Int']>
  notOnActiveLeg?: InputMaybe<Scalars['Boolean']>
  offset?: InputMaybe<Scalars['Int']>
  onActiveLeg?: InputMaybe<Scalars['Boolean']>
  payrollCostCenterIdIn?: InputMaybe<Array<Scalars['Int']>>
  payrollCostCenterNameIn?: InputMaybe<Array<Scalars['String']>>
  qualificationIdsContain?: InputMaybe<Array<Scalars['Int']>>
  restrictionsContain?: InputMaybe<Array<Scalars['String']>>
  sort?: Array<DriverSortFields>
  sortByDriverDomicileDistanceToCostCenterId?: InputMaybe<Scalars['Int']>
  sortByDriverFullname?: InputMaybe<Scalars['Boolean']>
  tmwIdIn?: InputMaybe<Array<Scalars['String']>>
  tmwIdIsNotNull?: InputMaybe<Scalars['Boolean']>
  tmwIdIsNull?: InputMaybe<Scalars['Boolean']>
}

export enum DriverRequestStatus {
  Complete = 'COMPLETE',
  Covered = 'COVERED',
  New = 'NEW',
  Removed = 'REMOVED',
  Unknown = 'UNKNOWN',
}

export type DriverShareRequest = {
  __typename?: 'DriverShareRequest'
  assignedDriver?: Maybe<Driver>
  cdlClass: Array<CdlClass>
  endTime: Scalars['DateTime']
  endorsements: Array<CdlEndorsement>
  id: Scalars['Int']
  note: Scalars['String']
  qualifications: Array<DriverShareRequestQualification>
  requester: User
  requesterCostCenter: CostCenter
  restrictions: Array<CdlRestriction>
  startTime: Scalars['DateTime']
  status: DriverRequestStatus
}

export type DriverShareRequestCreateInput = {
  cdlClass?: Array<CdlClass>
  endTime: Scalars['DateTime']
  endorsements?: Array<CdlEndorsement>
  note?: Scalars['String']
  qualificationIds: Array<Scalars['Int']>
  requesterCostCenterId: Scalars['Int']
  requesterId: Scalars['Int']
  restrictions?: Array<CdlRestriction>
  startTime: Scalars['DateTime']
  status: DriverRequestStatus
}

export type DriverShareRequestPaginatedResponse = {
  __typename?: 'DriverShareRequestPaginatedResponse'
  meta?: Maybe<PageMeta>
  results: Array<DriverShareRequest>
}

export type DriverShareRequestQualification = {
  __typename?: 'DriverShareRequestQualification'
  driverShareRequestId: Scalars['Int']
  qualificationId: Scalars['Int']
}

export type DriverShareRequestQuery = {
  limit?: InputMaybe<Scalars['Int']>
  offset?: InputMaybe<Scalars['Int']>
  requesterCostCenterIdEq?: InputMaybe<Scalars['Int']>
  requesterIdEq?: InputMaybe<Scalars['Int']>
  sort?: Array<DriverShareRequestSortFields>
  statusEq?: InputMaybe<DriverRequestStatus>
}

export type DriverShareRequestResponse = DriverShareRequest

export enum DriverShareRequestSortFields {
  EndTimeAsc = 'END_TIME_ASC',
  EndTimeDesc = 'END_TIME_DESC',
  StartTimeAsc = 'START_TIME_ASC',
  StartTimeDesc = 'START_TIME_DESC',
  StatusAsc = 'STATUS_ASC',
  StatusDesc = 'STATUS_DESC',
}

export type DriverSignOffInfo = {
  __typename?: 'DriverSignOffInfo'
  documentUrl?: Maybe<Scalars['String']>
  driver: Driver
  driverAgrees?: Maybe<Scalars['Boolean']>
  driverId: Scalars['Int']
  remark: Scalars['String']
}

export enum DriverSortFields {
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
}

export type DriverStatus = {
  __typename?: 'DriverStatus'
  availability: DriverAvailabilityStatus
  breakSecRemaining: Scalars['Int']
  currentLeg?: Maybe<Leg>
  currentRyderNumber?: Maybe<Scalars['String']>
  cycleSecRemaining: Scalars['Int']
  driverId: Scalars['Int']
  drivingSecRemaining: Scalars['Int']
  isShortHaulRuleset: Scalars['Boolean']
  nextLeg?: Maybe<Leg>
  overlappingLoadAssignmentsForDriver: Array<Load>
  /** Legs between 24h ago and 24h in the future that the driver is assigned to. */
  recentLegs: Array<Leg>
  shiftSecRemaining: Scalars['Int']
  status: DriverDutyStatus
  statusStartTime?: Maybe<Scalars['DateTime']>
  /** Timestamp in UTC driver is available to work after a 10 hr break. */
  tenHrResetPta?: Maybe<Scalars['String']>
  /** Timestamp in UTC driver is available to work after a 34 hr break. */
  thirtyFourHrResetPta?: Maybe<Scalars['String']>
  tractor?: Maybe<Tractor>
  tractorVin?: Maybe<Scalars['String']>
}

export type DriverStatusOverlappingLoadAssignmentsForDriverArgs = {
  legId: Scalars['Int']
}

export type DriverUpdate = {
  domicileId?: InputMaybe<Scalars['Int']>
  id: Scalars['Int']
  license?: InputMaybe<DriversLicenseUpdate>
  preferences?: InputMaybe<Array<Scalars['String']>>
}

export type DriverWithStatus = {
  __typename?: 'DriverWithStatus'
  authorizedToDrive: Scalars['Boolean']
  costCenters: Array<DriverCostCenter>
  currentStatus: DriverStatus
  domicile?: Maybe<Location>
  email?: Maybe<Scalars['String']>
  employeeId?: Maybe<Scalars['String']>
  fullname: Scalars['String']
  geotabId?: Maybe<Scalars['String']>
  id: Scalars['Int']
  isActive: Scalars['Boolean']
  license: DriversLicense
  phone?: Maybe<Scalars['String']>
  preferences: Array<Scalars['String']>
  qualifications: Array<DriverQualification>
  tmwId?: Maybe<Scalars['String']>
}

export type DriverWithStatusPaginatedResponse = {
  __typename?: 'DriverWithStatusPaginatedResponse'
  meta?: Maybe<PageMeta>
  results: Array<DriverWithStatus>
}

export type DriversLicense = {
  __typename?: 'DriversLicense'
  cdlClass?: Maybe<CdlClass>
  endorsements: Array<CdlEndorsement>
  expiresAt?: Maybe<Scalars['Date']>
  medcardExpiration?: Maybe<Scalars['Date']>
  restrictions: Array<CdlRestriction>
}

export type DriversLicenseUpdate = {
  cdlClass?: InputMaybe<CdlClass>
  endorsements?: InputMaybe<Array<CdlEndorsement>>
  expiresAt?: InputMaybe<Scalars['Date']>
  medcardExpiration?: InputMaybe<Scalars['Date']>
  restrictions?: InputMaybe<Array<CdlRestriction>>
}

export type DuplicateFacilityCode = ErrorType & {
  __typename?: 'DuplicateFacilityCode'
  message: Scalars['String']
}

export type DuplicateFacilityName = ErrorType & {
  __typename?: 'DuplicateFacilityName'
  message: Scalars['String']
}

export type DuplicateTrailerUnitNumber = ErrorType & {
  __typename?: 'DuplicateTrailerUnitNumber'
  message: Scalars['String']
}

export type DuplicateTrailerVin = ErrorType & {
  __typename?: 'DuplicateTrailerVin'
  message: Scalars['String']
}

export type DynamicDateRange = {
  __typename?: 'DynamicDateRange'
  dateType: DynamicDateType
  end?: Maybe<Scalars['DateTime']>
  start?: Maybe<Scalars['DateTime']>
  timeZoneCode?: Maybe<Scalars['String']>
  timeZoneName?: Maybe<Scalars['String']>
}

export enum DynamicDateType {
  Actual = 'ACTUAL',
  Appointment = 'APPOINTMENT',
  CarrierEta = 'CARRIER_ETA',
  Eta = 'ETA',
  Planned = 'PLANNED',
}

export type EmacsAggregate = {
  __typename?: 'EmacsAggregate'
  inefficiencyPercent?: Maybe<Scalars['Float']>
  totalOnDutyTime: Scalars['Float']
  totalShiftEndTime: Scalars['Float']
  totalShiftStartTime: Scalars['Float']
  totalStoppedTime: Scalars['Float']
}

export enum Entity {
  FreightRecord = 'FREIGHT_RECORD',
  Load = 'LOAD',
  Shipment = 'SHIPMENT',
  Stop = 'STOP',
}

export type EquipmentMove = {
  __typename?: 'EquipmentMove'
  message?: Maybe<Scalars['String']>
  type: EquipmentMoveType
}

export enum EquipmentMoveType {
  CreateOnCurrentLeg = 'CREATE_ON_CURRENT_LEG',
  DeleteOnCurrentLeg = 'DELETE_ON_CURRENT_LEG',
  UpdateOnCurrentLeg = 'UPDATE_ON_CURRENT_LEG',
}

export enum EquipmentOwnerType {
  CustomerOwned = 'CUSTOMER_OWNED',
  RyderOwned = 'RYDER_OWNED',
}

export enum EquipmentStatus {
  Available = 'AVAILABLE',
  InUse = 'IN_USE',
  OutOfService = 'OUT_OF_SERVICE',
  Retired = 'RETIRED',
}

export enum EquipmentType {
  Bobtail = 'BOBTAIL',
  Car = 'CAR',
  CargoVan = 'CARGO_VAN',
  Chassis = 'CHASSIS',
  Conestogal = 'CONESTOGAL',
  ContainerRefrigerated = 'CONTAINER_REFRIGERATED',
  ContainerStandard = 'CONTAINER_STANDARD',
  CsxRrOriginCore = 'CSX_RR_ORIGIN_CORE',
  DoubleAxle = 'DOUBLE_AXLE',
  DoubleDropLowBoy = 'DOUBLE_DROP_LOW_BOY',
  DoubleDropTriAxleExtendedTrailer = 'DOUBLE_DROP_TRI_AXLE_EXTENDED_TRAILER',
  DryVanPaperspec = 'DRY_VAN_PAPERSPEC',
  DumpEnd = 'DUMP_END',
  DumpSide = 'DUMP_SIDE',
  Flatbed = 'FLATBED',
  FlatbedCurtainSide = 'FLATBED_CURTAIN_SIDE',
  FoodTrailerFrozen = 'FOOD_TRAILER_FROZEN',
  Forklift = 'FORKLIFT',
  GravelDumper = 'GRAVEL_DUMPER',
  HarleyDedicatedDv = 'HARLEY_DEDICATED_DV',
  HighCube = 'HIGH_CUBE',
  Hopper = 'HOPPER',
  HotOilTruck = 'HOT_OIL_TRUCK',
  HydroExcavationTruck = 'HYDRO_EXCAVATION_TRUCK',
  Intermodal = 'INTERMODAL',
  IntermodalReefer = 'INTERMODAL_REEFER',
  IntermodalVan = 'INTERMODAL_VAN',
  LessThanTruckLoad = 'LESS_THAN_TRUCK_LOAD',
  Liftgate = 'LIFTGATE',
  LtlSyngenta = 'LTL_SYNGENTA',
  MiniFloat = 'MINI_FLOAT',
  Moffett = 'MOFFETT',
  NsRrOriginCore = 'NS_RR_ORIGIN_CORE',
  Other = 'OTHER',
  PickupTruck = 'PICKUP_TRUCK',
  Pneumatic = 'PNEUMATIC',
  PumpTruck = 'PUMP_TRUCK',
  QuadAxleTrailer = 'QUAD_AXLE_TRAILER',
  Railcar = 'RAILCAR',
  RailcarHighCube = 'RAILCAR_HIGH_CUBE',
  Refrigerated = 'REFRIGERATED',
  RemovableGooseNeck = 'REMOVABLE_GOOSE_NECK',
  RollOnRollOffShips = 'ROLL_ON_ROLL_OFF_SHIPS',
  ShortSemiSyngenta = 'SHORT_SEMI_SYNGENTA',
  SprinterVan = 'SPRINTER_VAN',
  StepDeck = 'STEP_DECK',
  StraightTruck = 'STRAIGHT_TRUCK',
  TandemSyngenta = 'TANDEM_SYNGENTA',
  Tanker = 'TANKER',
  TankerChemical = 'TANKER_CHEMICAL',
  TriAxle = 'TRI_AXLE',
  TruckVan = 'TRUCK_VAN',
  UpRrOriginCore = 'UP_RR_ORIGIN_CORE',
  VacuumTruck = 'VACUUM_TRUCK',
  VanDry = 'VAN_DRY',
  VanSyngenta = 'VAN_SYNGENTA',
  WinchTruck = 'WINCH_TRUCK',
}

export type ErrorType = {
  message: Scalars['String']
}

export enum ExceptionType {
  AttemptedStop = 'ATTEMPTED_STOP',
  Damage = 'DAMAGE',
  LateArrival = 'LATE_ARRIVAL',
  MissingDocument = 'MISSING_DOCUMENT',
  Overage = 'OVERAGE',
  RunningLate = 'RUNNING_LATE',
  Shortage = 'SHORTAGE',
  SkippedStop = 'SKIPPED_STOP',
}

export type ExceptionTypes =
  | AttemptedStopException
  | DamageException
  | LateArrivalException
  | MissingDocumentException
  | OverageException
  | ShortageException
  | SkippedStopException

export type ExceptionUpdateRequest = {
  description?: InputMaybe<Scalars['String']>
  id: Scalars['Int']
  shouldCascade?: Scalars['Boolean']
  stopLateReasonCodeId?: InputMaybe<Scalars['Int']>
  stopLateReasonId?: InputMaybe<Scalars['Int']>
}

export type ExceptionUpdateResponse =
  | ExceptionUpdated
  | InvalidExceptionUpdate
  | ObjectDoesNotExist

export type ExceptionUpdated = {
  __typename?: 'ExceptionUpdated'
  exception: ExceptionTypes
  exceptionId: Scalars['Int']
  load: Load
}

export type Facility = {
  __typename?: 'Facility'
  address?: Maybe<Address>
  archivedAt?: Maybe<Scalars['DateTime']>
  contacts: Array<Contact>
  costCenters: Array<CostCenter>
  defaultStopType?: Maybe<Scalars['String']>
  facilityCode: Scalars['String']
  id: Scalars['BigIntLocationID']
  name?: Maybe<Scalars['String']>
  notes: Array<FacilityNote>
  observesDst?: Maybe<Scalars['Boolean']>
  operatingHours: Array<OperatingHours>
  point?: Maybe<GpsPoint>
  polygons: Array<GpsPolygon>
  radius: Scalars['Int']
  sourceId?: Maybe<Scalars['String']>
  sourceSystem?: Maybe<SourceSystem>
  timeZoneCode: Scalars['String']
  timeZoneName: Scalars['String']
}

export type FacilityAddressCreate = {
  city: Scalars['String']
  country: Scalars['String']
  line1: Scalars['String']
  line2?: InputMaybe<Scalars['String']>
  postalCode: Scalars['String']
  stateProvinceCode: Scalars['String']
}

export type FacilityContactCreateRequest = {
  email?: InputMaybe<Scalars['String']>
  facilityId: Scalars['BigIntLocationID']
  firstName: Scalars['String']
  lastName?: InputMaybe<Scalars['String']>
  phoneNumber?: InputMaybe<Scalars['String']>
}

export type FacilityContactCreated = {
  __typename?: 'FacilityContactCreated'
  contact: Contact
}

export type FacilityContactDeleteRequest = {
  contactId: Scalars['Int']
  facilityId: Scalars['BigIntLocationID']
}

export type FacilityContactDeleted = {
  __typename?: 'FacilityContactDeleted'
  facilityId: Scalars['BigIntLocationID']
}

export type FacilityContactUpdateRequest = {
  contactId: Scalars['Int']
  email?: InputMaybe<Scalars['String']>
  facilityId: Scalars['BigIntLocationID']
  firstName: Scalars['String']
  lastName?: InputMaybe<Scalars['String']>
  phoneNumber?: InputMaybe<Scalars['String']>
}

export type FacilityContactUpdated = {
  __typename?: 'FacilityContactUpdated'
  contact: Contact
}

export type FacilityCreate = {
  addressCreate: FacilityAddressCreate
  costCenterId: Scalars['Int']
  facilityCode: Scalars['String']
  gpsPoint?: InputMaybe<GpsPointInput>
  name: Scalars['String']
}

export type FacilityCreated = {
  __typename?: 'FacilityCreated'
  facility: Facility
}

export type FacilityNote = {
  __typename?: 'FacilityNote'
  body: Scalars['String']
  id: Scalars['Int']
}

export type FacilityNoteCreateRequest = {
  body: Scalars['String']
  facilityId: Scalars['BigIntLocationID']
}

export type FacilityNoteCreated = {
  __typename?: 'FacilityNoteCreated'
  note: FacilityNote
}

export type FacilityNoteDeleteRequest = {
  facilityId: Scalars['BigIntLocationID']
  id: Scalars['Int']
}

export type FacilityNoteDeleted = {
  __typename?: 'FacilityNoteDeleted'
  facilityId: Scalars['BigIntLocationID']
}

export type FacilityNoteUpdateRequest = {
  body: Scalars['String']
  facilityId: Scalars['BigIntLocationID']
  id: Scalars['Int']
}

export type FacilityNoteUpdated = {
  __typename?: 'FacilityNoteUpdated'
  note: FacilityNote
}

export type FacilityPaginatedResponse = {
  __typename?: 'FacilityPaginatedResponse'
  meta?: Maybe<PageMeta>
  results: Array<Facility>
}

export type FacilityQuery = {
  archivedAtIsNotNull?: InputMaybe<Scalars['Boolean']>
  archivedAtIsNull?: InputMaybe<Scalars['Boolean']>
  costCenterIdIn?: InputMaybe<Array<Scalars['Int']>>
  facilityCodeEq?: InputMaybe<Scalars['String']>
  facilityCodeIn?: InputMaybe<Array<Scalars['String']>>
  facilityCodeIsNotNull?: InputMaybe<Scalars['Boolean']>
  facilityCodeIsNull?: InputMaybe<Scalars['Boolean']>
  fuzzyMatch?: InputMaybe<Scalars['String']>
  fuzzyMatchOrLocationReferenceValue?: InputMaybe<Scalars['String']>
  idEq?: InputMaybe<Scalars['Int']>
  idIn?: InputMaybe<Array<Scalars['BigIntLocationID']>>
  limit?: InputMaybe<Scalars['Int']>
  loadIdIn?: InputMaybe<Array<Scalars['Int']>>
  locationReferenceValueIn?: InputMaybe<Array<Scalars['String']>>
  nameEq?: InputMaybe<Scalars['String']>
  nameIcontains?: InputMaybe<Scalars['String']>
  nameIn?: InputMaybe<Array<Scalars['String']>>
  nameIsNotNull?: InputMaybe<Scalars['Boolean']>
  nameIsNull?: InputMaybe<Scalars['Boolean']>
  noteEq?: InputMaybe<Scalars['String']>
  noteIsNotNull?: InputMaybe<Scalars['Boolean']>
  noteIsNull?: InputMaybe<Scalars['Boolean']>
  offset?: InputMaybe<Scalars['Int']>
  polygonIdIn?: InputMaybe<Array<Scalars['Int']>>
  routeIdIn?: InputMaybe<Array<Scalars['Int']>>
  sort?: Array<LocationSortFields>
  sortByName?: InputMaybe<SortInput>
  sourceIdEq?: InputMaybe<Scalars['String']>
  sourceIdIn?: InputMaybe<Array<Scalars['String']>>
  sourceIdIsNotNull?: InputMaybe<Scalars['Boolean']>
  sourceIdIsNull?: InputMaybe<Scalars['Boolean']>
  sourceSystemEq?: InputMaybe<SourceSystem>
  sourceSystemIn?: InputMaybe<Array<SourceSystem>>
  sourceSystemIsNotNull?: InputMaybe<Scalars['Boolean']>
  sourceSystemIsNull?: InputMaybe<Scalars['Boolean']>
  tmwIdEq?: InputMaybe<Scalars['String']>
  tmwIdIn?: InputMaybe<Array<Scalars['String']>>
  tmwIdIsNotNull?: InputMaybe<Scalars['Boolean']>
  tmwIdIsNull?: InputMaybe<Scalars['Boolean']>
}

export type FilterGroup = {
  __typename?: 'FilterGroup'
  customerId: Scalars['Int']
  entity: FilterGroupEntity
  id: Scalars['Int']
  isSecure: Scalars['Boolean']
  name: Scalars['String']
}

export enum FilterGroupEntity {
  Load = 'LOAD',
  Shipment = 'SHIPMENT',
  Unknown = 'UNKNOWN',
}

export type FreightDetails = {
  __typename?: 'FreightDetails'
  freightRecords: Array<FreightRecord>
  totalVolume?: Maybe<Scalars['Float']>
  totalVolumeUnit?: Maybe<VolumeUnit>
  totalWeight?: Maybe<Scalars['Float']>
  totalWeightUnit?: Maybe<WeightUnit>
}

export type FreightRecord = {
  __typename?: 'FreightRecord'
  commodityCode?: Maybe<Scalars['String']>
  commodityDescription?: Maybe<Scalars['String']>
  id: Scalars['Int']
  osdRecord?: Maybe<OsdRecord>
  quantity?: Maybe<Scalars['Float']>
  quantityUnit?: Maybe<QuantityUnit>
  references: Array<FreightRecordReference>
  stopId: Scalars['BigIntStopID']
  volume?: Maybe<Scalars['Float']>
  volumeUnit?: Maybe<VolumeUnit>
  weight?: Maybe<Scalars['Float']>
  weightUnit?: Maybe<WeightUnit>
}

export type FreightRecordCreate = {
  commodityCode?: InputMaybe<Scalars['String']>
  commodityDescription?: InputMaybe<Scalars['String']>
  createdBy?: InputMaybe<Scalars['Int']>
  quantity?: InputMaybe<Scalars['Float']>
  quantityUnit?: InputMaybe<QuantityUnit>
  stopId: Scalars['BigIntStopID']
  volume?: InputMaybe<Scalars['Float']>
  volumeUnit?: InputMaybe<VolumeUnit>
  weight?: InputMaybe<Scalars['Float']>
  weightUnit?: InputMaybe<WeightUnit>
}

export type FreightRecordCreateResponse =
  | FreightRecordCreated
  | InvalidFreightRecordCreate
  | InvalidFreightRecordRange
  | InvalidLoadStatus
  | InvalidRadiusVersion
  | ObjectDoesNotExist

export type FreightRecordCreated = {
  __typename?: 'FreightRecordCreated'
  freightRecord: FreightRecord
  load: Load
}

export type FreightRecordDelete = {
  id: Scalars['Int']
}

export type FreightRecordDeleteResponse =
  | FreightRecordDeleted
  | InvalidLoadStatus
  | InvalidRadiusVersion
  | ObjectDoesNotExist

export type FreightRecordDeleted = {
  __typename?: 'FreightRecordDeleted'
  id: Scalars['Int']
  load: Load
}

export type FreightRecordNotExists = ErrorType & {
  __typename?: 'FreightRecordNotExists'
  message: Scalars['String']
}

export type FreightRecordReference = {
  __typename?: 'FreightRecordReference'
  displayName?: Maybe<Scalars['String']>
  freightRecordId: Scalars['Int']
  id: Scalars['Int']
  type: Scalars['String']
  value: Scalars['String']
}

export type FreightRecordReferenceCreate = {
  freightRecordId: Scalars['Int']
  type: Scalars['String']
  value: Scalars['String']
}

export type FreightRecordReferenceCreated = {
  __typename?: 'FreightRecordReferenceCreated'
  load: Load
  reference: FreightRecordReference
}

export type FreightRecordReferenceDelete = {
  id: Scalars['Int']
}

export type FreightRecordReferenceDeleted = {
  __typename?: 'FreightRecordReferenceDeleted'
  load: Load
  reference: FreightRecordReference
}

export type FreightRecordReferencePaginatedResponse = {
  __typename?: 'FreightRecordReferencePaginatedResponse'
  meta?: Maybe<PageMeta>
  results: Array<FreightRecordReference>
}

export type FreightRecordReferenceQuery = {
  costCenterIdIn?: InputMaybe<Array<Scalars['Int']>>
  distinctOn?: InputMaybe<Array<Scalars['String']>>
  freightRecordIdEq?: InputMaybe<Scalars['Int']>
  freightRecordIdIn?: InputMaybe<Array<Scalars['Int']>>
  idEq?: InputMaybe<Scalars['Int']>
  idIn?: InputMaybe<Array<Scalars['Int']>>
  limit?: InputMaybe<Scalars['Int']>
  offset?: InputMaybe<Scalars['Int']>
  typeEq?: InputMaybe<Scalars['String']>
  typeIn?: InputMaybe<Array<Scalars['String']>>
  valueEq?: InputMaybe<Scalars['String']>
  valueIcontains?: InputMaybe<Scalars['String']>
  valueIlikeAny?: InputMaybe<Array<Scalars['String']>>
  valueIn?: InputMaybe<Array<Scalars['String']>>
}

export type FreightRecordReferenceUpdate = {
  id: Scalars['Int']
  type?: InputMaybe<Scalars['String']>
  value?: InputMaybe<Scalars['String']>
}

export type FreightRecordReferenceUpdated = {
  __typename?: 'FreightRecordReferenceUpdated'
  load: Load
  reference: FreightRecordReference
}

export type FreightRecordUpdate = {
  id: Scalars['Int']
  quantity?: InputMaybe<Scalars['Float']>
  quantityUnit?: InputMaybe<QuantityUnit>
  stopId?: InputMaybe<Scalars['BigIntStopID']>
  volume?: InputMaybe<Scalars['Float']>
  volumeUnit?: InputMaybe<VolumeUnit>
  weight?: InputMaybe<Scalars['Float']>
  weightUnit?: InputMaybe<WeightUnit>
}

export type FreightRecordUpdateResponse =
  | FreightRecordUpdated
  | InvalidFreightRecordRange
  | InvalidFreightRecordUpdate
  | InvalidLoadStatus
  | InvalidRadiusVersion
  | ObjectDoesNotExist

export type FreightRecordUpdated = {
  __typename?: 'FreightRecordUpdated'
  freightRecord: FreightRecord
  load: Load
}

export type GpsEventWithLocation = {
  __typename?: 'GPSEventWithLocation'
  address?: Maybe<Address>
  cityState?: Maybe<Scalars['String']>
  point: GpsPoint
  speedMph?: Maybe<Scalars['Int']>
  timestamp: Scalars['DateTime']
  tzCode?: Maybe<Scalars['String']>
  tzName?: Maybe<Scalars['String']>
}

export type GpsPoint = {
  __typename?: 'GPSPoint'
  lat: Scalars['Float']
  lon: Scalars['Float']
}

export type GpsPointInput = {
  lat: Scalars['Float']
  lon: Scalars['Float']
}

export type GpsPolygon = {
  __typename?: 'GPSPolygon'
  bounds: Array<GpsPoint>
  id: Scalars['Int']
}

export type GpsPolygonBaseInput = {
  bounds: Array<GpsPointInput>
}

export type GpsPolygonCreate = {
  bounds: Array<GpsPointInput>
}

export type GpsPolygonUpdate = {
  bounds?: InputMaybe<Array<GpsPointInput>>
  id: Scalars['Int']
}

export type GeodapterTimeout = ErrorType & {
  __typename?: 'GeodapterTimeout'
  message: Scalars['String']
}

export type Georoute = {
  __typename?: 'Georoute'
  actualRoute: Array<GpsPoint>
  expectedRoute: Array<GpsPoint>
}

export type GetDriversStatusResponse =
  | DriverWithStatusPaginatedResponse
  | GeodapterTimeout
  | InvalidDriverStatus

export type GetTrackingInfoResponse =
  | InvalidTrackingLink
  | TrackingInfo
  | TrackingLinkInternalError

export type HarleyDealerUserCreate = {
  dealerNumber: Scalars['String']
  email: Scalars['String']
}

export type HarleyDealerUserCreateResponse =
  | HarleyDealerUserCreated
  | InvalidDealerNumber
  | InvalidEmailAddress
  | InvalidPassword
  | InvalidUserCredentials
  | ObjectDoesNotExist
  | UserAlreadyExists
  | UserHasCustomer

export type HarleyDealerUserCreated = {
  __typename?: 'HarleyDealerUserCreated'
  user: User
}

export enum HomePage {
  DriverVisibility = 'DRIVER_VISIBILITY',
  Loadboard = 'LOADBOARD',
}

export type InvalidAttemptStop = ErrorType & {
  __typename?: 'InvalidAttemptStop'
  message: Scalars['String']
}

export type InvalidBillToUpdate = ErrorType & {
  __typename?: 'InvalidBillToUpdate'
  message: Scalars['String']
}

export type InvalidColumnConfiguration = ErrorType & {
  __typename?: 'InvalidColumnConfiguration'
  message: Scalars['String']
}

export type InvalidConsigneeCreate = ErrorType & {
  __typename?: 'InvalidConsigneeCreate'
  message: Scalars['String']
}

export type InvalidContact = ErrorType & {
  __typename?: 'InvalidContact'
  message: Scalars['String']
}

export type InvalidCostCenterCode = ErrorType & {
  __typename?: 'InvalidCostCenterCode'
  message: Scalars['String']
}

export type InvalidCostCenterForCustomer = ErrorType & {
  __typename?: 'InvalidCostCenterForCustomer'
  message: Scalars['String']
}

export type InvalidCountryCode = ErrorType & {
  __typename?: 'InvalidCountryCode'
  message: Scalars['String']
}

export type InvalidCountrySubdivisionCode = ErrorType & {
  __typename?: 'InvalidCountrySubdivisionCode'
  message: Scalars['String']
}

export type InvalidCustomerForUser = ErrorType & {
  __typename?: 'InvalidCustomerForUser'
  message: Scalars['String']
}

export type InvalidCustomerLatenessConfiguration = ErrorType & {
  __typename?: 'InvalidCustomerLatenessConfiguration'
  message: Scalars['String']
}

export type InvalidDealerNumber = ErrorType & {
  __typename?: 'InvalidDealerNumber'
  message: Scalars['String']
}

export type InvalidDriverAssignment = ErrorType & {
  __typename?: 'InvalidDriverAssignment'
  message: Scalars['String']
}

export type InvalidDriverStatus = ErrorType & {
  __typename?: 'InvalidDriverStatus'
  message: Scalars['String']
}

export type InvalidEmailAddress = ErrorType & {
  __typename?: 'InvalidEmailAddress'
  message: Scalars['String']
}

export type InvalidEquipmentMove = ErrorType & {
  __typename?: 'InvalidEquipmentMove'
  message: Scalars['String']
}

export type InvalidExceptionUpdate = ErrorType & {
  __typename?: 'InvalidExceptionUpdate'
  message: Scalars['String']
}

export type InvalidFacilityCode = ErrorType & {
  __typename?: 'InvalidFacilityCode'
  message: Scalars['String']
}

export type InvalidFacilityForEdit = ErrorType & {
  __typename?: 'InvalidFacilityForEdit'
  message: Scalars['String']
}

export type InvalidFacilityName = ErrorType & {
  __typename?: 'InvalidFacilityName'
  message: Scalars['String']
}

export type InvalidFreightRecordCreate = ErrorType & {
  __typename?: 'InvalidFreightRecordCreate'
  message: Scalars['String']
}

export type InvalidFreightRecordRange = ErrorType & {
  __typename?: 'InvalidFreightRecordRange'
  message: Scalars['String']
}

export type InvalidFreightRecordUpdate = ErrorType & {
  __typename?: 'InvalidFreightRecordUpdate'
  message: Scalars['String']
}

export type InvalidLegIdx = ErrorType & {
  __typename?: 'InvalidLegIdx'
  message: Scalars['String']
}

export type InvalidLegStartTime = ErrorType & {
  __typename?: 'InvalidLegStartTime'
  message: Scalars['String']
}

export type InvalidLegStatus = ErrorType & {
  __typename?: 'InvalidLegStatus'
  message: Scalars['String']
}

export type InvalidLegUpdateError = ErrorType & {
  __typename?: 'InvalidLegUpdateError'
  message: Scalars['String']
}

export type InvalidLegWithCarrierAction = ErrorType & {
  __typename?: 'InvalidLegWithCarrierAction'
  message: Scalars['String']
}

export type InvalidLoadNoteCreate = ErrorType & {
  __typename?: 'InvalidLoadNoteCreate'
  message: Scalars['String']
}

export type InvalidLoadNoteDelete = ErrorType & {
  __typename?: 'InvalidLoadNoteDelete'
  message: Scalars['String']
}

export type InvalidLoadNoteUpdate = ErrorType & {
  __typename?: 'InvalidLoadNoteUpdate'
  message: Scalars['String']
}

export type InvalidLoadStatus = ErrorType & {
  __typename?: 'InvalidLoadStatus'
  message: Scalars['String']
}

export type InvalidNeedByUpdate = ErrorType & {
  __typename?: 'InvalidNeedByUpdate'
  message: Scalars['String']
}

export type InvalidNoteBody = ErrorType & {
  __typename?: 'InvalidNoteBody'
  message: Scalars['String']
}

export type InvalidOdometer = ErrorType & {
  __typename?: 'InvalidOdometer'
  message: Scalars['String']
}

export type InvalidOperatingHoursError = ErrorType & {
  __typename?: 'InvalidOperatingHoursError'
  message: Scalars['String']
}

export type InvalidOsdRecord = ErrorType & {
  __typename?: 'InvalidOsdRecord'
  message: Scalars['String']
}

export type InvalidPassword = ErrorType & {
  __typename?: 'InvalidPassword'
  message: Scalars['String']
}

export type InvalidPhoneNumber = ErrorType & {
  __typename?: 'InvalidPhoneNumber'
  message: Scalars['String']
}

export type InvalidRadiusVersion = ErrorType & {
  __typename?: 'InvalidRadiusVersion'
  message: Scalars['String']
}

export type InvalidReferenceCreate = ErrorType & {
  __typename?: 'InvalidReferenceCreate'
  message: Scalars['String']
}

export type InvalidReferenceUpdate = ErrorType & {
  __typename?: 'InvalidReferenceUpdate'
  message: Scalars['String']
}

export type InvalidRescheduleStop = ErrorType & {
  __typename?: 'InvalidRescheduleStop'
  message: Scalars['String']
}

export type InvalidRoute = ErrorType & {
  __typename?: 'InvalidRoute'
  message: Scalars['String']
}

export type InvalidRouteStopLocation = ErrorType & {
  __typename?: 'InvalidRouteStopLocation'
  message: Scalars['String']
}

export type InvalidRouteUpdate = ErrorType & {
  __typename?: 'InvalidRouteUpdate'
  message: Scalars['String']
}

export type InvalidServiceEventComplete = ErrorType & {
  __typename?: 'InvalidServiceEventComplete'
  message: Scalars['String']
}

export type InvalidServiceEventStart = ErrorType & {
  __typename?: 'InvalidServiceEventStart'
  message: Scalars['String']
}

export type InvalidServiceEventStatus = ErrorType & {
  __typename?: 'InvalidServiceEventStatus'
  message: Scalars['String']
}

export type InvalidServiceEventUpdate = ErrorType & {
  __typename?: 'InvalidServiceEventUpdate'
  message: Scalars['String']
}

export type InvalidSkipStop = ErrorType & {
  __typename?: 'InvalidSkipStop'
  message: Scalars['String']
}

export type InvalidSourceSystem = ErrorType & {
  __typename?: 'InvalidSourceSystem'
  message: Scalars['String']
}

export type InvalidStopAdd = ErrorType & {
  __typename?: 'InvalidStopAdd'
  message: Scalars['String']
}

export type InvalidStopAppointmentEnd = ErrorType & {
  __typename?: 'InvalidStopAppointmentEnd'
  message: Scalars['String']
}

export type InvalidStopAppointmentStart = ErrorType & {
  __typename?: 'InvalidStopAppointmentStart'
  message: Scalars['String']
}

export type InvalidStopAppointmentTime = ErrorType & {
  __typename?: 'InvalidStopAppointmentTime'
  message: Scalars['String']
}

export type InvalidStopDateTime = ErrorType & {
  __typename?: 'InvalidStopDateTime'
  message: Scalars['String']
}

export type InvalidStopDelete = ErrorType & {
  __typename?: 'InvalidStopDelete'
  message: Scalars['String']
}

export type InvalidStopEstimateQuery = ErrorType & {
  __typename?: 'InvalidStopEstimateQuery'
  message: Scalars['String']
}

export type InvalidStopEvent = ErrorType & {
  __typename?: 'InvalidStopEvent'
  message: Scalars['String']
}

export type InvalidStopForLeg = ErrorType & {
  __typename?: 'InvalidStopForLeg'
  message: Scalars['String']
}

export type InvalidStopIdx = ErrorType & {
  __typename?: 'InvalidStopIdx'
  message: Scalars['String']
}

export type InvalidStopLocation = ErrorType & {
  __typename?: 'InvalidStopLocation'
  message: Scalars['String']
}

export type InvalidStopReorder = ErrorType & {
  __typename?: 'InvalidStopReorder'
  message: Scalars['String']
}

export type InvalidStopStatus = ErrorType & {
  __typename?: 'InvalidStopStatus'
  message: Scalars['String']
}

export type InvalidStopType = ErrorType & {
  __typename?: 'InvalidStopType'
  message: Scalars['String']
}

export type InvalidStopUpdateField = ErrorType & {
  __typename?: 'InvalidStopUpdateField'
  message: Scalars['String']
}

export type InvalidTmCustomerCode = ErrorType & {
  __typename?: 'InvalidTMCustomerCode'
  message: Scalars['String']
}

export type InvalidTmwVersionIdAnton = ErrorType & {
  __typename?: 'InvalidTMWVersionIDAnton'
  message: Scalars['String']
}

export type InvalidTmwVersionIdClient = ErrorType & {
  __typename?: 'InvalidTMWVersionIDClient'
  message: Scalars['String']
}

export type InvalidTmwVersionIdScos = ErrorType & {
  __typename?: 'InvalidTMWVersionIDScos'
  message: Scalars['String']
}

export type InvalidTenderLoad = ErrorType & {
  __typename?: 'InvalidTenderLoad'
  message: Scalars['String']
}

export type InvalidTenderStatus = ErrorType & {
  __typename?: 'InvalidTenderStatus'
  message: Scalars['String']
}

export type InvalidTrackingLink = ErrorType & {
  __typename?: 'InvalidTrackingLink'
  message: Scalars['String']
}

export type InvalidTractorStatus = ErrorType & {
  __typename?: 'InvalidTractorStatus'
  message: Scalars['String']
}

export type InvalidTractorUpdate = ErrorType & {
  __typename?: 'InvalidTractorUpdate'
  message: Scalars['String']
}

export type InvalidTrailerAssign = ErrorType & {
  __typename?: 'InvalidTrailerAssign'
  message: Scalars['String']
}

export type InvalidTrailerChangeDelete = ErrorType & {
  __typename?: 'InvalidTrailerChangeDelete'
  message: Scalars['String']
}

export type InvalidTrailerCreate = ErrorType & {
  __typename?: 'InvalidTrailerCreate'
  message: Scalars['String']
}

export type InvalidTrailerStatus = ErrorType & {
  __typename?: 'InvalidTrailerStatus'
  message: Scalars['String']
}

export type InvalidTrailerUpdate = ErrorType & {
  __typename?: 'InvalidTrailerUpdate'
  message: Scalars['String']
}

export type InvalidUndoStops = ErrorType & {
  __typename?: 'InvalidUndoStops'
  message: Scalars['String']
}

export type InvalidUserCredentials = ErrorType & {
  __typename?: 'InvalidUserCredentials'
  message: Scalars['String']
}

export type InvalidVinUpdateError = ErrorType & {
  __typename?: 'InvalidVinUpdateError'
  message: Scalars['String']
}

export type InvalidXMinAway = ErrorType & {
  __typename?: 'InvalidXMinAway'
  message: Scalars['String']
}

export type LateArrivalException = {
  __typename?: 'LateArrivalException'
  createdAt?: Maybe<Scalars['DateTime']>
  customerDescription?: Maybe<Scalars['String']>
  description?: Maybe<Scalars['String']>
  id: Scalars['Int']
  stopId: Scalars['BigIntStopID']
  stopLateReason?: Maybe<StopLateReason>
  updatedAt?: Maybe<Scalars['DateTime']>
}

export enum LatenessTransitMode {
  Ltl = 'LTL',
  Tl = 'TL',
}

export type LayoverStopAddRequest = {
  appointmentStart?: InputMaybe<Scalars['DateTime']>
  arrivalTime?: InputMaybe<Scalars['DateTime']>
  departureTime?: InputMaybe<Scalars['DateTime']>
  gpsPoint?: InputMaybe<GpsPointInput>
  idx: Scalars['Int']
  legId: Scalars['Int']
  locationId?: InputMaybe<Scalars['BigIntLocationID']>
  plannedDwell?: InputMaybe<Scalars['TimeDelta']>
  tractorMileage?: InputMaybe<Scalars['Int']>
}

export type LayoverStopAddResponse =
  | InvalidLoadStatus
  | InvalidOdometer
  | InvalidRadiusVersion
  | InvalidStopAdd
  | InvalidStopAppointmentEnd
  | InvalidStopAppointmentStart
  | InvalidStopDateTime
  | InvalidStopIdx
  | InvalidStopLocation
  | InvalidStopStatus
  | LayoverStopAdded
  | NoCostCenterAssignedToLoad
  | ObjectDoesNotExist

export type LayoverStopAdded = {
  __typename?: 'LayoverStopAdded'
  load: Load
}

export type Leg = {
  __typename?: 'Leg'
  backhaulEligibleCode?: Maybe<BackhaulEligibleCode>
  carrierDetails: CarrierDetails
  costCenter?: Maybe<CostCenter>
  currentTotalEstimatedMiles?: Maybe<Scalars['Float']>
  destination?: Maybe<Address>
  driverOdometerEnd?: Maybe<Scalars['Int']>
  driverOdometerStart?: Maybe<Scalars['Int']>
  driverSignOffs: Array<DriverSignOffInfo>
  endTime?: Maybe<Scalars['DateTime']>
  equipmentMoveRequired?: Maybe<EquipmentMove>
  estimatedTripTime: Scalars['Int']
  georoute: Georoute
  georouteWithSpacing: Georoute
  id: Scalars['Int']
  idx: Scalars['Int']
  isRv3Load?: Maybe<Scalars['Boolean']>
  loadId: Scalars['Int']
  loadRyderNumber?: Maybe<Scalars['String']>
  origin?: Maybe<Address>
  plannedEndTime?: Maybe<Scalars['DateTime']>
  plannedMilesPcmiler?: Maybe<Scalars['Float']>
  plannedStartTime?: Maybe<Scalars['DateTime']>
  primaryDriver?: Maybe<Driver>
  primaryDriverId?: Maybe<Scalars['Int']>
  primaryDriverName?: Maybe<Scalars['String']>
  routeCode?: Maybe<Scalars['String']>
  routeId?: Maybe<Scalars['Int']>
  secondaryDriver?: Maybe<Driver>
  secondaryDriverId?: Maybe<Scalars['Int']>
  sourceId?: Maybe<Scalars['String']>
  startTime?: Maybe<Scalars['DateTime']>
  status: LegStatus
  stops: Array<Stop>
  tmwId: Scalars['Int']
  tractor?: Maybe<Tractor>
  tractorId?: Maybe<Scalars['Int']>
}

export type LegEquipmentMoveRequiredArgs = {
  tractorId?: InputMaybe<Scalars['Int']>
}

export type LegGeorouteWithSpacingArgs = {
  spacing: Scalars['Float']
}

export type LegMerge = {
  legIdx: Scalars['Int']
  loadId: Scalars['Int']
}

export type LegPlannedStartTimeResponse =
  | InvalidLegStatus
  | InvalidLegUpdateError
  | InvalidTmwVersionIdClient
  | InvalidTmwVersionIdScos
  | LegPlannedStartTimeUpdated
  | ObjectDoesNotExist
  | TmwValidationError

export type LegPlannedStartTimeUpdated = {
  __typename?: 'LegPlannedStartTimeUpdated'
  load: Load
  tmwVersionId: Scalars['BigInt']
}

export type LegSplit = {
  legId: Scalars['Int']
  locationId?: InputMaybe<Scalars['BigInt']>
  noteBody?: InputMaybe<Scalars['String']>
  /** Index of the stop before which to split the leg */
  stopIdx: Scalars['Int']
  tmwVersionId: Scalars['BigInt']
}

export enum LegStatus {
  Available = 'AVAILABLE',
  Cancelled = 'CANCELLED',
  Completed = 'COMPLETED',
  Dispatched = 'DISPATCHED',
  Planned = 'PLANNED',
  Started = 'STARTED',
  Unknown = 'UNKNOWN',
}

export type Load = {
  __typename?: 'Load'
  /** Resolves to the all associated TM load for an integrated DTS load. */
  associatedLoads: Array<AssociatedLoad>
  auditTrailEvents: Array<AuditTrailEvent>
  autoCompleteScheduledTime?: Maybe<Scalars['DateTime']>
  /** Resolves to the base DTS load for an integrated TM load. */
  baseDtsLoad?: Maybe<BaseLoad>
  billToId?: Maybe<Scalars['Int']>
  carrierIsPrime?: Maybe<Scalars['Boolean']>
  costCenter?: Maybe<CostCenter>
  courierJsonExtract?: Maybe<Scalars['String']>
  createdAt?: Maybe<Scalars['DateTime']>
  customerNumbers?: Maybe<Scalars['String']>
  customerReferenceNumbers: Array<CustomerReferenceNumber>
  dispatchAt?: Maybe<Scalars['DateTime']>
  documents: DocumentResponse
  endTime?: Maybe<Scalars['DateTime']>
  equipmentSize?: Maybe<Scalars['String']>
  equipmentType?: Maybe<EquipmentType>
  etasLastCalculated?: Maybe<Scalars['DateTime']>
  exceptions: Array<ExceptionTypes>
  firstPickupScheduledTimes?: Maybe<DynamicDateRange>
  firstPickupTimes?: Maybe<DynamicDateRange>
  firstStopScheduledTimes?: Maybe<DynamicDateRange>
  firstStopTimes?: Maybe<DynamicDateRange>
  freightDetails: FreightDetails
  freightRecordReferences: Array<FreightRecordReference>
  gpsEventsWithLocations: Array<GpsEventWithLocation>
  id: Scalars['Int']
  initialEstimatedTime: Scalars['Int']
  integratedRyderNumber?: Maybe<Scalars['String']>
  isRv3?: Maybe<Scalars['Boolean']>
  lastDeliveryScheduledTimes?: Maybe<DynamicDateRange>
  lastDeliveryTimes?: Maybe<DynamicDateRange>
  lastStopScheduledTimes?: Maybe<DynamicDateRange>
  lastStopTimes?: Maybe<DynamicDateRange>
  latestGpsEvent?: Maybe<GpsEventWithLocation>
  legs: Array<Leg>
  minNeedBy?: Maybe<LoadMinNeedByInfo>
  nextStop?: Maybe<Stop>
  notes: Array<LoadNote>
  operationalStop?: Maybe<OperationalStop>
  primaryReference?: Maybe<LoadReference>
  proReference?: Maybe<CustomerReferenceNumber>
  references: Array<CustomerReferenceNumber>
  route?: Maybe<Route>
  routeId?: Maybe<Scalars['Int']>
  ryderNumber?: Maybe<Scalars['String']>
  searchAndDisplayReferences: Array<CustomerReferenceNumber>
  /** @deprecated temporary for preseving backward compatibility. Eventually use `search_and_display_references` instead */
  searchAndDisplayReferences_Deprecated: Array<CustomerReferenceNumber>
  shipmentIds: Array<Scalars['Int']>
  source: LoadSource
  sourceSystem: SourceSystem
  startTime?: Maybe<Scalars['DateTime']>
  status: LoadStatus
  stopReferences: Array<StopReference>
  targetDispatchStartInterval?: Maybe<Scalars['TimeDelta']>
  tenderStatus: LoadTenderStatus
  tmwVersionId: Scalars['BigInt']
  topActionableLateStop?: Maybe<Stop>
  trailer?: Maybe<Trailer>
  trailerUnitNumbers: Array<Maybe<Scalars['String']>>
  transitMode: TransitMode
}

export type LoadCancelled = {
  __typename?: 'LoadCancelled'
  load: Load
}

export type LoadCreate = {
  costCenterId: Scalars['Int']
  plannedStartTime: Scalars['DateTime']
  routeId: Scalars['Int']
}

export type LoadCreateResponse =
  | InvalidRouteStopLocation
  | LoadCreated
  | ObjectDoesNotExist
  | TmwValidationError

export type LoadCreated = {
  __typename?: 'LoadCreated'
  load: Load
  loadId: Scalars['Int']
  loadReference: Scalars['String']
  ryderNumber: Scalars['String']
}

export type LoadDeleted = {
  __typename?: 'LoadDeleted'
  id: Scalars['Int']
}

export type LoadList = {
  __typename?: 'LoadList'
  loads: Array<Load>
}

export type LoadMarkedCompleted = {
  __typename?: 'LoadMarkedCompleted'
  load: Load
}

export type LoadMinNeedByInfo = {
  __typename?: 'LoadMinNeedByInfo'
  id: Scalars['BigIntStopID']
  needByTime: Scalars['DateTime']
  tzCode?: Maybe<Scalars['String']>
  tzName?: Maybe<Scalars['String']>
}

export type LoadNote = {
  __typename?: 'LoadNote'
  body: Scalars['String']
  createdAt: Scalars['DateTime']
  createdBy?: Maybe<User>
  id: Scalars['Int']
  loadId?: Maybe<Scalars['Int']>
  sourceCreatedAt?: Maybe<Scalars['DateTime']>
  stopId?: Maybe<Scalars['BigIntStopID']>
}

export type LoadNoteCreateRequest = {
  body: Scalars['String']
  loadId?: InputMaybe<Scalars['Int']>
  stopId?: InputMaybe<Scalars['BigIntStopID']>
}

export type LoadNoteCreated = {
  __typename?: 'LoadNoteCreated'
  load: Load
}

export type LoadNoteDelete = {
  id: Scalars['Int']
  loadId: Scalars['Int']
}

export type LoadNoteUpdate = {
  body: Scalars['String']
  id: Scalars['Int']
  loadId: Scalars['Int']
}

export type LoadPaginatedResponse = {
  __typename?: 'LoadPaginatedResponse'
  meta?: Maybe<PageMeta>
  results: Array<Load>
}

export type LoadQuery = {
  carrierIdIn?: InputMaybe<Array<Scalars['Int']>>
  carrierIsRyderDts?: InputMaybe<Scalars['Boolean']>
  carrierScacIn?: InputMaybe<Array<Scalars['String']>>
  carrierTypeIn?: InputMaybe<Array<CarrierType>>
  carrierUnassigned?: InputMaybe<Scalars['Boolean']>
  costCenterIdEq?: InputMaybe<Scalars['Int']>
  costCenterIdIn?: InputMaybe<Array<Scalars['Int']>>
  costCenterIdIsNotNull?: InputMaybe<Scalars['Boolean']>
  costCenterIdIsNull?: InputMaybe<Scalars['Boolean']>
  costCenterRadiusVersionEq?: InputMaybe<RadiusVersion>
  createdAtGte?: InputMaybe<Scalars['DateTime']>
  createdAtIsNotNull?: InputMaybe<Scalars['Boolean']>
  createdAtIsNull?: InputMaybe<Scalars['Boolean']>
  customerNumbersEq?: InputMaybe<Scalars['String']>
  customerNumbersIcontains?: InputMaybe<Scalars['String']>
  customerNumbersIsNotNull?: InputMaybe<Scalars['Boolean']>
  customerNumbersIsNull?: InputMaybe<Scalars['Boolean']>
  customerOrderIdEq?: InputMaybe<Scalars['String']>
  customerOrderIdIsNotNull?: InputMaybe<Scalars['Boolean']>
  customerOrderIdIsNull?: InputMaybe<Scalars['Boolean']>
  customerReferenceNumberEq?: InputMaybe<Scalars['String']>
  destinationLocationIdIn?: InputMaybe<Array<Scalars['Int']>>
  destinationLocationReferenceValueIn?: InputMaybe<Array<Scalars['String']>>
  dispatchAtGte?: InputMaybe<Scalars['DateTime']>
  dispatchAtIsNotNull?: InputMaybe<Scalars['Boolean']>
  dispatchAtIsNull?: InputMaybe<Scalars['Boolean']>
  dispatchAtLt?: InputMaybe<Scalars['DateTime']>
  driverIdEq?: InputMaybe<Scalars['Int']>
  driverIdIn?: InputMaybe<Array<Scalars['Int']>>
  estimatesUpdatedAtIsNotNull?: InputMaybe<Scalars['Boolean']>
  estimatesUpdatedAtIsNull?: InputMaybe<Scalars['Boolean']>
  estimatesUpdatedAtLt?: InputMaybe<Scalars['DateTime']>
  exceptions?: InputMaybe<Array<ExceptionType>>
  firstPickupScheduledTimesDateRange?: InputMaybe<Array<Scalars['DateTime']>>
  firstPickupTimesDateRange?: InputMaybe<Array<Scalars['DateTime']>>
  firstStopScheduledTimesDateRange?: InputMaybe<Array<Scalars['DateTime']>>
  firstStopTimesDateRange?: InputMaybe<Array<Scalars['DateTime']>>
  hasAnyGpsEvents?: InputMaybe<Scalars['Boolean']>
  hasStopWithNeedBy?: InputMaybe<Scalars['Boolean']>
  hasStopsRunningLate?: InputMaybe<Scalars['Boolean']>
  hideIntegratedTmLoads?: InputMaybe<Scalars['Boolean']>
  hideNonIntegratedDtsLoads?: InputMaybe<Scalars['Boolean']>
  idEq?: InputMaybe<Scalars['Int']>
  idIn?: InputMaybe<Array<Scalars['Int']>>
  integratedRefactorDestinationLocationReferenceValueIn?: InputMaybe<
    Array<Scalars['String']>
  >
  integratedRefactorOriginLocationReferenceValueIn?: InputMaybe<
    Array<Scalars['String']>
  >
  integratedRefactorReferenceOrAssociatedShipmentCodeIn?: InputMaybe<
    Array<Scalars['String']>
  >
  integratedRefactorRyderNumberIcontains?: InputMaybe<Scalars['String']>
  integratedRefactorShipmentDestinationLocationReferenceIn?: InputMaybe<
    Array<Scalars['String']>
  >
  integratedReferenceValueIn?: InputMaybe<Array<Array<Scalars['String']>>>
  lastDeliveryScheduledTimesDateRange?: InputMaybe<Array<Scalars['DateTime']>>
  lastDeliveryTimesDateRange?: InputMaybe<Array<Scalars['DateTime']>>
  lastStopScheduledTimesDateRange?: InputMaybe<Array<Scalars['DateTime']>>
  lastStopTimesDateRange?: InputMaybe<Array<Scalars['DateTime']>>
  limit?: InputMaybe<Scalars['Int']>
  loadReferencesContains?: InputMaybe<Array<Array<Scalars['String']>>>
  localeIn?: InputMaybe<Array<Array<InputMaybe<Scalars['String']>>>>
  locationIdIn?: InputMaybe<Array<Scalars['BigIntLocationID']>>
  locationNameIn?: InputMaybe<Array<Scalars['String']>>
  locationReferenceValueIn?: InputMaybe<Array<Scalars['String']>>
  offset?: InputMaybe<Scalars['Int']>
  originLocationIdIn?: InputMaybe<Array<Scalars['Int']>>
  originLocationReferenceValueIn?: InputMaybe<Array<Scalars['String']>>
  plannedStartDateRange?: InputMaybe<Array<Scalars['Date']>>
  plannedStartTimeDateRange?: InputMaybe<Array<Scalars['DateTime']>>
  plannedStartTimeGt?: InputMaybe<Scalars['DateTime']>
  plannedStartTimeGte?: InputMaybe<Scalars['DateTime']>
  plannedStartTimeLte?: InputMaybe<Scalars['DateTime']>
  referenceIn?: InputMaybe<Scalars['String']>
  referenceOrAssociatedShipmentCodeIn?: InputMaybe<Array<Scalars['String']>>
  referenceValueEq?: InputMaybe<Scalars['String']>
  referenceValueIn?: InputMaybe<Array<Array<Scalars['String']>>>
  removeDuplicateAssociatedTmIntegratedLoads?: InputMaybe<Scalars['Boolean']>
  removeUnassociatedDtsIntegratedLoads?: InputMaybe<Scalars['Boolean']>
  routeCodeIn?: InputMaybe<Array<Scalars['String']>>
  routeCodeStartsWith?: InputMaybe<Scalars['String']>
  routeIdEq?: InputMaybe<Scalars['Int']>
  routeIdIn?: InputMaybe<Array<Scalars['Int']>>
  routeIdIsNotNull?: InputMaybe<Scalars['Boolean']>
  routeIdIsNull?: InputMaybe<Scalars['Boolean']>
  ryderNumberEq?: InputMaybe<Scalars['String']>
  ryderNumberIcontains?: InputMaybe<Scalars['String']>
  ryderNumberIsNotNull?: InputMaybe<Scalars['Boolean']>
  ryderNumberIsNull?: InputMaybe<Scalars['Boolean']>
  shipmentCodeEqAndCostCenterIdEq?: InputMaybe<Array<Scalars['String']>>
  shipmentDestinationLocationReferenceIn?: InputMaybe<Array<Scalars['String']>>
  sort?: Array<LoadSortFields>
  sortByCostCenterName?: InputMaybe<SortInput>
  sortByEndTime?: InputMaybe<SortInput>
  sortByLatestGpsEventTimestamp?: InputMaybe<SortInput>
  sortByLoadRouteCode?: InputMaybe<SortInput>
  sortByMinNeedBy?: InputMaybe<SortInput>
  sortByOrigin?: InputMaybe<SortInput>
  sortByPlannedStartTime?: InputMaybe<SortInput>
  sortByPrimaryDriverOrCarrier?: InputMaybe<SortInput>
  sortByTopActionableLateStopSeverity?: InputMaybe<SortInput>
  sortByViolations?: InputMaybe<SortInput>
  sourceIdEq?: InputMaybe<Scalars['String']>
  sourceIdIsNotNull?: InputMaybe<Scalars['Boolean']>
  sourceIdIsNull?: InputMaybe<Scalars['Boolean']>
  sourceSystemEq?: InputMaybe<SourceSystem>
  sourceSystemIn?: InputMaybe<Array<SourceSystem>>
  statusEq?: InputMaybe<LoadStatus>
  statusIn?: InputMaybe<Array<LoadStatus>>
  statusNe?: InputMaybe<LoadStatus>
  stopReferenceValueIn?: InputMaybe<Array<Array<Scalars['String']>>>
  suppressRoutes?: InputMaybe<Scalars['Boolean']>
  tmwIdEq?: InputMaybe<Scalars['Int']>
  tmwIdIsNotNull?: InputMaybe<Scalars['Boolean']>
  tmwIdIsNull?: InputMaybe<Scalars['Boolean']>
  topActionableLateStopLatenessStatus?: InputMaybe<
    Array<InputMaybe<StopLatenessStatus>>
  >
  tractorIdIn?: InputMaybe<Array<Scalars['Int']>>
  trailerIdIn?: InputMaybe<Array<Scalars['Int']>>
  trailerIdIsNotNull?: InputMaybe<Scalars['Boolean']>
  trailerIdIsNull?: InputMaybe<Scalars['Boolean']>
  trailerUnitNumberIn?: InputMaybe<Array<Scalars['String']>>
  transitModeEq?: InputMaybe<Scalars['String']>
  transitModeIn?: InputMaybe<Array<Scalars['String']>>
  updatedAtGte?: InputMaybe<Scalars['DateTime']>
  updatedAtIsNotNull?: InputMaybe<Scalars['Boolean']>
  updatedAtIsNull?: InputMaybe<Scalars['Boolean']>
  updatedAtLt?: InputMaybe<Scalars['DateTime']>
}

export type LoadReference = {
  __typename?: 'LoadReference'
  displayName?: Maybe<Scalars['String']>
  id: Scalars['Int']
  isDisplayed: Scalars['Boolean']
  loadId: Scalars['Int']
  sourceSystem: SourceSystem
  type: Scalars['String']
  value: Scalars['String']
}

export type LoadReferenceCreate = {
  loadId: Scalars['Int']
  type?: InputMaybe<Scalars['String']>
  value?: InputMaybe<Scalars['String']>
}

export type LoadReferenceCreated = {
  __typename?: 'LoadReferenceCreated'
  load: Load
  reference: CustomerReferenceNumber
}

export type LoadReferenceDelete = {
  id: Scalars['Int']
  loadId: Scalars['Int']
}

export type LoadReferenceDeleted = {
  __typename?: 'LoadReferenceDeleted'
  load: Load
}

export type LoadReferenceUpdate = {
  id: Scalars['Int']
  loadId: Scalars['Int']
  sourceSystem?: InputMaybe<SourceSystem>
  type?: InputMaybe<Scalars['String']>
  value?: InputMaybe<Scalars['String']>
}

export type LoadReferenceUpdated = {
  __typename?: 'LoadReferenceUpdated'
  load: Load
}

export type LoadResponse = Load | PermissionTypeError

export enum LoadSortFields {
  CreatedAtAsc = 'CREATED_AT_ASC',
  CreatedAtDesc = 'CREATED_AT_DESC',
  ExecutionCompletedAtAsc = 'EXECUTION_COMPLETED_AT_ASC',
  ExecutionCompletedAtDesc = 'EXECUTION_COMPLETED_AT_DESC',
  RyderNumberAsc = 'RYDER_NUMBER_ASC',
  RyderNumberDesc = 'RYDER_NUMBER_DESC',
  StatusAsc = 'STATUS_ASC',
  StatusDesc = 'STATUS_DESC',
}

export enum LoadSource {
  Radius = 'RADIUS',
  Rydershare = 'RYDERSHARE',
  Scos = 'SCOS',
  Tm = 'TM',
  Unknown = 'UNKNOWN',
}

export enum LoadStatus {
  Accepted = 'ACCEPTED',
  AcceptPending = 'ACCEPT_PENDING',
  Available = 'AVAILABLE',
  Cancelled = 'CANCELLED',
  Completed = 'COMPLETED',
  Declined = 'DECLINED',
  DeclinePending = 'DECLINE_PENDING',
  Dispatched = 'DISPATCHED',
  Imported = 'IMPORTED',
  InAudit = 'IN_AUDIT',
  OptimizationPending = 'OPTIMIZATION_PENDING',
  OptimizationReady = 'OPTIMIZATION_READY',
  Planned = 'PLANNED',
  Started = 'STARTED',
  Suspended = 'SUSPENDED',
  Tendered = 'TENDERED',
  TenderOffered = 'TENDER_OFFERED',
  TenderRejected = 'TENDER_REJECTED',
  Unknown = 'UNKNOWN',
}

export type LoadSubscription = LoadDeleted | LoadList

export enum LoadTenderStatus {
  NotTendered = 'NOT_TENDERED',
  Tendered = 'TENDERED',
  Withdrawn = 'WITHDRAWN',
}

export type LoadTenderWithdrawn = {
  __typename?: 'LoadTenderWithdrawn'
  load: Load
}

export type LoadTendered = {
  __typename?: 'LoadTendered'
  load: Load
}

export type Location = {
  __typename?: 'Location'
  address?: Maybe<Address>
  archivedAt?: Maybe<Scalars['DateTime']>
  contacts: Array<Contact>
  costCenters: Array<CostCenter>
  customerFacilityId?: Maybe<Scalars['String']>
  defaultStopType?: Maybe<Scalars['String']>
  facilityCode?: Maybe<Scalars['String']>
  id: Scalars['BigIntLocationID']
  name?: Maybe<Scalars['String']>
  note?: Maybe<Scalars['String']>
  notes: Array<FacilityNote>
  observesDst?: Maybe<Scalars['Boolean']>
  operatingHours: Array<OperatingHours>
  point?: Maybe<GpsPoint>
  polygons: Array<GpsPolygon>
  radius: Scalars['Int']
  references: Array<LocationReference>
  sourceId?: Maybe<Scalars['String']>
  timeZoneCode: Scalars['String']
  timeZoneName: Scalars['String']
}

export enum LocationActionType {
  Drop = 'DROP',
  DropAndHook = 'DROP_AND_HOOK',
  Hook = 'HOOK',
  Load = 'LOAD',
  None = 'NONE',
  Unknown = 'UNKNOWN',
  Unload = 'UNLOAD',
}

export type LocationConsigneeXMinAwayUpdate = {
  locationId?: InputMaybe<Scalars['BigIntLocationID']>
  locationReference?: InputMaybe<Scalars['String']>
  xMinAwayMinutes?: InputMaybe<Scalars['Int']>
}

export type LocationConsigneeXMinAwayUpdateResponse =
  | InvalidXMinAway
  | LocationConsigneeXMinAwayUpdated
  | ObjectDoesNotExist

export type LocationConsigneeXMinAwayUpdated = {
  __typename?: 'LocationConsigneeXMinAwayUpdated'
  locationId?: Maybe<Scalars['BigIntLocationID']>
  locationReference?: Maybe<Scalars['String']>
  updatedConsigneeCount: Scalars['Int']
  xMinAwayMinutes?: Maybe<Scalars['Int']>
}

export type LocationPaginatedResponse = {
  __typename?: 'LocationPaginatedResponse'
  meta?: Maybe<PageMeta>
  results: Array<Location>
}

export type LocationQuery = {
  archivedAtIsNotNull?: InputMaybe<Scalars['Boolean']>
  archivedAtIsNull?: InputMaybe<Scalars['Boolean']>
  costCenterIdIn?: InputMaybe<Array<Scalars['Int']>>
  facilityCodeEq?: InputMaybe<Scalars['String']>
  facilityCodeIn?: InputMaybe<Array<Scalars['String']>>
  facilityCodeIsNotNull?: InputMaybe<Scalars['Boolean']>
  facilityCodeIsNull?: InputMaybe<Scalars['Boolean']>
  fuzzyMatch?: InputMaybe<Scalars['String']>
  fuzzyMatchOrLocationReferenceValue?: InputMaybe<Scalars['String']>
  idEq?: InputMaybe<Scalars['Int']>
  idIn?: InputMaybe<Array<Scalars['BigIntLocationID']>>
  limit?: InputMaybe<Scalars['Int']>
  loadIdIn?: InputMaybe<Array<Scalars['Int']>>
  locationReferenceValueIn?: InputMaybe<Array<Scalars['String']>>
  nameEq?: InputMaybe<Scalars['String']>
  nameIcontains?: InputMaybe<Scalars['String']>
  nameIn?: InputMaybe<Array<Scalars['String']>>
  nameIsNotNull?: InputMaybe<Scalars['Boolean']>
  nameIsNull?: InputMaybe<Scalars['Boolean']>
  noteEq?: InputMaybe<Scalars['String']>
  noteIsNotNull?: InputMaybe<Scalars['Boolean']>
  noteIsNull?: InputMaybe<Scalars['Boolean']>
  offset?: InputMaybe<Scalars['Int']>
  polygonIdIn?: InputMaybe<Array<Scalars['Int']>>
  routeIdIn?: InputMaybe<Array<Scalars['Int']>>
  sort?: Array<LocationSortFields>
  sortByName?: InputMaybe<SortInput>
  sourceIdEq?: InputMaybe<Scalars['String']>
  sourceIdIn?: InputMaybe<Array<Scalars['String']>>
  sourceIdIsNotNull?: InputMaybe<Scalars['Boolean']>
  sourceIdIsNull?: InputMaybe<Scalars['Boolean']>
  sourceSystemEq?: InputMaybe<SourceSystem>
  sourceSystemIn?: InputMaybe<Array<SourceSystem>>
  sourceSystemIsNotNull?: InputMaybe<Scalars['Boolean']>
  sourceSystemIsNull?: InputMaybe<Scalars['Boolean']>
  tmwIdEq?: InputMaybe<Scalars['String']>
  tmwIdIn?: InputMaybe<Array<Scalars['String']>>
  tmwIdIsNotNull?: InputMaybe<Scalars['Boolean']>
  tmwIdIsNull?: InputMaybe<Scalars['Boolean']>
}

export type LocationReference = {
  __typename?: 'LocationReference'
  locationId: Scalars['Int']
  type: Scalars['String']
  value: Scalars['String']
}

export type LocationResponse =
  | InvalidOperatingHoursError
  | Location
  | ObjectDoesNotExist
  | OverlappingPolygons

export enum LocationSortFields {
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  NameAsc = 'NAME_ASC',
  NameDesc = 'NAME_DESC',
}

export type LocationUpdate = {
  id: Scalars['BigIntLocationID']
  name?: InputMaybe<Scalars['String']>
  note?: InputMaybe<Scalars['String']>
  operatingHours?: InputMaybe<Array<OperatingHoursCreate>>
  point?: InputMaybe<GpsPointInput>
  polygonCreates?: InputMaybe<Array<GpsPolygonCreate>>
  polygonUpdates?: InputMaybe<Array<GpsPolygonUpdate>>
  radius?: InputMaybe<Scalars['Int']>
}

export type ManualArriveDepartError =
  | InvalidLegStatus
  | InvalidLegUpdateError
  | InvalidOdometer
  | InvalidRadiusVersion
  | InvalidStopDateTime
  | InvalidStopForLeg
  | NoDriverAssignedToLeg
  | ObjectDoesNotExist

export type ManualArriveDepartInput = {
  stopArrivalDepartures: Array<StopArrivalDeparture>
}

export type ManualArriveDepartInvalid = {
  __typename?: 'ManualArriveDepartInvalid'
  error: ManualArriveDepartError
  stopId?: Maybe<Scalars['BigIntStopID']>
}

export type ManualArriveDepartResponse = Load | ManualArriveDepartInvalid

export type MarkLoadCompletedResponse =
  | InvalidLoadStatus
  | InvalidRadiusVersion
  | LoadMarkedCompleted
  | ObjectDoesNotExist

export type MarkedRead = {
  __typename?: 'MarkedRead'
  notificationIds: Array<Scalars['Int']>
  readAt: Scalars['DateTime']
}

export type MergeLegResponse =
  | InvalidLegIdx
  | InvalidLegStatus
  | InvalidLoadStatus
  | InvalidRadiusVersion
  | InvalidStopEvent
  | InvalidStopStatus
  | MergeLegSuccess
  | ObjectDoesNotExist

export type MergeLegSuccess = {
  __typename?: 'MergeLegSuccess'
  load: Load
}

export type MileageType = {
  __typename?: 'MileageType'
  code: Scalars['String']
  name: Scalars['String']
}

export type MissingDocument = {
  __typename?: 'MissingDocument'
  shipmentId?: Maybe<Scalars['Int']>
  stopId?: Maybe<Scalars['BigIntStopID']>
  type: DocumentType
}

export type MissingDocumentException = {
  __typename?: 'MissingDocumentException'
  createdAt?: Maybe<Scalars['DateTime']>
  description?: Maybe<Scalars['String']>
  documentType?: Maybe<DocumentType>
  id: Scalars['Int']
  shipmentId?: Maybe<Scalars['Int']>
  stopId: Scalars['BigIntStopID']
  updatedAt?: Maybe<Scalars['DateTime']>
}

export type MissionControlLoad = {
  __typename?: 'MissionControlLoad'
  id: Scalars['Int']
  integratedRyderNumber?: Maybe<Scalars['String']>
  latestGpsCity?: Maybe<Scalars['String']>
  latestGpsCountryCode?: Maybe<Scalars['String']>
  latestGpsLat?: Maybe<Scalars['Float']>
  latestGpsLon?: Maybe<Scalars['Float']>
  latestGpsStateOrProvinceAbbrev?: Maybe<Scalars['String']>
  nextStop?: Maybe<MissionControlStop>
  primaryReferenceType?: Maybe<Scalars['String']>
  primaryReferenceValue?: Maybe<Scalars['String']>
}

export type MissionControlLoadQuery = {
  hasGpsEvent?: InputMaybe<Scalars['Boolean']>
}

export type MissionControlNetworkLoadQuery = {
  carrierIdIn?: InputMaybe<Array<Scalars['Int']>>
  carrierIsRyderDts?: InputMaybe<Scalars['Boolean']>
  carrierScacIn?: InputMaybe<Array<Scalars['String']>>
  carrierTypeIn?: InputMaybe<Array<CarrierType>>
  carrierUnassigned?: InputMaybe<Scalars['Boolean']>
  costCenterIdEq?: InputMaybe<Scalars['Int']>
  costCenterIdIn?: InputMaybe<Array<Scalars['Int']>>
  costCenterIdIsNotNull?: InputMaybe<Scalars['Boolean']>
  costCenterIdIsNull?: InputMaybe<Scalars['Boolean']>
  costCenterRadiusVersionEq?: InputMaybe<RadiusVersion>
  createdAtGte?: InputMaybe<Scalars['DateTime']>
  createdAtIsNotNull?: InputMaybe<Scalars['Boolean']>
  createdAtIsNull?: InputMaybe<Scalars['Boolean']>
  customerNumbersEq?: InputMaybe<Scalars['String']>
  customerNumbersIcontains?: InputMaybe<Scalars['String']>
  customerNumbersIsNotNull?: InputMaybe<Scalars['Boolean']>
  customerNumbersIsNull?: InputMaybe<Scalars['Boolean']>
  customerOrderIdEq?: InputMaybe<Scalars['String']>
  customerOrderIdIsNotNull?: InputMaybe<Scalars['Boolean']>
  customerOrderIdIsNull?: InputMaybe<Scalars['Boolean']>
  customerReferenceNumberEq?: InputMaybe<Scalars['String']>
  destinationLocationIdIn?: InputMaybe<Array<Scalars['Int']>>
  destinationLocationReferenceValueIn?: InputMaybe<Array<Scalars['String']>>
  dispatchAtGte?: InputMaybe<Scalars['DateTime']>
  dispatchAtIsNotNull?: InputMaybe<Scalars['Boolean']>
  dispatchAtIsNull?: InputMaybe<Scalars['Boolean']>
  dispatchAtLt?: InputMaybe<Scalars['DateTime']>
  driverIdEq?: InputMaybe<Scalars['Int']>
  driverIdIn?: InputMaybe<Array<Scalars['Int']>>
  estimatesUpdatedAtIsNotNull?: InputMaybe<Scalars['Boolean']>
  estimatesUpdatedAtIsNull?: InputMaybe<Scalars['Boolean']>
  estimatesUpdatedAtLt?: InputMaybe<Scalars['DateTime']>
  exceptions?: InputMaybe<Array<ExceptionType>>
  firstPickupScheduledTimesDateRange?: InputMaybe<Array<Scalars['DateTime']>>
  firstPickupTimesDateRange?: InputMaybe<Array<Scalars['DateTime']>>
  firstStopScheduledTimesDateRange?: InputMaybe<Array<Scalars['DateTime']>>
  firstStopTimesDateRange?: InputMaybe<Array<Scalars['DateTime']>>
  hasAnyGpsEvents?: InputMaybe<Scalars['Boolean']>
  hasStopWithNeedBy?: InputMaybe<Scalars['Boolean']>
  hasStopsRunningLate?: InputMaybe<Scalars['Boolean']>
  hideIntegratedTmLoads?: InputMaybe<Scalars['Boolean']>
  hideNonIntegratedDtsLoads?: InputMaybe<Scalars['Boolean']>
  idEq?: InputMaybe<Scalars['Int']>
  idIn?: InputMaybe<Array<Scalars['Int']>>
  integratedRefactorDestinationLocationReferenceValueIn?: InputMaybe<
    Array<Scalars['String']>
  >
  integratedRefactorOriginLocationReferenceValueIn?: InputMaybe<
    Array<Scalars['String']>
  >
  integratedRefactorReferenceOrAssociatedShipmentCodeIn?: InputMaybe<
    Array<Scalars['String']>
  >
  integratedRefactorRyderNumberIcontains?: InputMaybe<Scalars['String']>
  integratedRefactorShipmentDestinationLocationReferenceIn?: InputMaybe<
    Array<Scalars['String']>
  >
  integratedReferenceValueIn?: InputMaybe<Array<Array<Scalars['String']>>>
  lastDeliveryScheduledTimesDateRange?: InputMaybe<Array<Scalars['DateTime']>>
  lastDeliveryTimesDateRange?: InputMaybe<Array<Scalars['DateTime']>>
  lastStopScheduledTimesDateRange?: InputMaybe<Array<Scalars['DateTime']>>
  lastStopTimesDateRange?: InputMaybe<Array<Scalars['DateTime']>>
  limit?: InputMaybe<Scalars['Int']>
  loadReferencesContains?: InputMaybe<Array<Array<Scalars['String']>>>
  localeIn?: InputMaybe<Array<Array<InputMaybe<Scalars['String']>>>>
  locationIdIn?: InputMaybe<Array<Scalars['BigIntLocationID']>>
  locationNameIn?: InputMaybe<Array<Scalars['String']>>
  locationReferenceValueIn?: InputMaybe<Array<Scalars['String']>>
  offset?: InputMaybe<Scalars['Int']>
  originLocationIdIn?: InputMaybe<Array<Scalars['Int']>>
  originLocationReferenceValueIn?: InputMaybe<Array<Scalars['String']>>
  plannedStartDateRange?: InputMaybe<Array<Scalars['Date']>>
  plannedStartTimeDateRange?: InputMaybe<Array<Scalars['DateTime']>>
  plannedStartTimeGt?: InputMaybe<Scalars['DateTime']>
  plannedStartTimeGte?: InputMaybe<Scalars['DateTime']>
  plannedStartTimeLte?: InputMaybe<Scalars['DateTime']>
  referenceIn?: InputMaybe<Scalars['String']>
  referenceOrAssociatedShipmentCodeIn?: InputMaybe<Array<Scalars['String']>>
  referenceValueEq?: InputMaybe<Scalars['String']>
  referenceValueIn?: InputMaybe<Array<Array<Scalars['String']>>>
  removeDuplicateAssociatedTmIntegratedLoads?: InputMaybe<Scalars['Boolean']>
  removeUnassociatedDtsIntegratedLoads?: InputMaybe<Scalars['Boolean']>
  routeCodeIn?: InputMaybe<Array<Scalars['String']>>
  routeCodeStartsWith?: InputMaybe<Scalars['String']>
  routeIdEq?: InputMaybe<Scalars['Int']>
  routeIdIn?: InputMaybe<Array<Scalars['Int']>>
  routeIdIsNotNull?: InputMaybe<Scalars['Boolean']>
  routeIdIsNull?: InputMaybe<Scalars['Boolean']>
  ryderNumberEq?: InputMaybe<Scalars['String']>
  ryderNumberIcontains?: InputMaybe<Scalars['String']>
  ryderNumberIsNotNull?: InputMaybe<Scalars['Boolean']>
  ryderNumberIsNull?: InputMaybe<Scalars['Boolean']>
  shipmentCodeEqAndCostCenterIdEq?: InputMaybe<Array<Scalars['String']>>
  shipmentDestinationLocationReferenceIn?: InputMaybe<Array<Scalars['String']>>
  sort?: Array<LoadSortFields>
  sortByCostCenterName?: InputMaybe<SortInput>
  sortByEndTime?: InputMaybe<SortInput>
  sortByLatestGpsEventTimestamp?: InputMaybe<SortInput>
  sortByLoadRouteCode?: InputMaybe<SortInput>
  sortByMinNeedBy?: InputMaybe<SortInput>
  sortByOrigin?: InputMaybe<SortInput>
  sortByPlannedStartTime?: InputMaybe<SortInput>
  sortByPrimaryDriverOrCarrier?: InputMaybe<SortInput>
  sortByTopActionableLateStopSeverity?: InputMaybe<SortInput>
  sortByViolations?: InputMaybe<SortInput>
  sourceIdEq?: InputMaybe<Scalars['String']>
  sourceIdIsNotNull?: InputMaybe<Scalars['Boolean']>
  sourceIdIsNull?: InputMaybe<Scalars['Boolean']>
  sourceSystemEq?: InputMaybe<SourceSystem>
  sourceSystemIn?: InputMaybe<Array<SourceSystem>>
  statusEq?: InputMaybe<LoadStatus>
  statusIn?: InputMaybe<Array<LoadStatus>>
  statusNe?: InputMaybe<LoadStatus>
  stopReferenceValueIn?: InputMaybe<Array<Array<Scalars['String']>>>
  suppressRoutes?: InputMaybe<Scalars['Boolean']>
  tmwIdEq?: InputMaybe<Scalars['Int']>
  tmwIdIsNotNull?: InputMaybe<Scalars['Boolean']>
  tmwIdIsNull?: InputMaybe<Scalars['Boolean']>
  topActionableLateStopLatenessStatus?: InputMaybe<
    Array<InputMaybe<StopLatenessStatus>>
  >
  tractorIdIn?: InputMaybe<Array<Scalars['Int']>>
  trailerIdIn?: InputMaybe<Array<Scalars['Int']>>
  trailerIdIsNotNull?: InputMaybe<Scalars['Boolean']>
  trailerIdIsNull?: InputMaybe<Scalars['Boolean']>
  trailerUnitNumberIn?: InputMaybe<Array<Scalars['String']>>
  transitModeEq?: InputMaybe<Scalars['String']>
  transitModeIn?: InputMaybe<Array<Scalars['String']>>
  updatedAtGte?: InputMaybe<Scalars['DateTime']>
  updatedAtIsNotNull?: InputMaybe<Scalars['Boolean']>
  updatedAtIsNull?: InputMaybe<Scalars['Boolean']>
  updatedAtLt?: InputMaybe<Scalars['DateTime']>
}

export type MissionControlStop = {
  __typename?: 'MissionControlStop'
  carrierEta?: Maybe<Scalars['DateTime']>
  estimatedArrivalTime?: Maybe<Scalars['DateTime']>
  lat?: Maybe<Scalars['Float']>
  lon?: Maybe<Scalars['Float']>
  timeZoneName?: Maybe<Scalars['String']>
}

export type Mutation = {
  __typename?: 'Mutation'
  addCostCenterToCustomer: AddedCustomerCostCenterResponse
  addCustomerLatenessConfigurationToCustomer: AddedCustomerLatenessConfigurationResponse
  addDriverQualification: DriverQualification
  addLayoverStop: LayoverStopAddResponse
  addStop: StopAddResponse
  addTrailerChange: AddTrailerChangeResponse
  assignCarrierToLeg: AssignCarrierToLegResponse
  assignDriverToShareRequest: DriverShareRequestResponse
  assignDriversToLeg: AssignDriversToLegResponse
  assignTractorToLeg: AssignTractorToLegResponse
  assignTrailerToLoad: AssignTrailerToLoadResponse
  assignTrailerToStop: AssignTrailerToStopResponse
  attemptStop: StopAttemptResponse
  cancelLoad: CancelLoadResponse
  completeServiceEvent: CompleteServiceEventResponse
  createConsignee: ConsigneeCreateResponse
  createCustomer: CreateCustomerResponse
  createCustomerUser: CustomerUserCreateResponse
  createDriverShareRequest: DriverShareRequestResponse
  createFacility: CreateFacilityResponse
  createFacilityContact: CreateFacilityContactResponse
  createFacilityNote: CreateFacilityNoteResponse
  createFreightRecord: FreightRecordCreateResponse
  createHarleyDealerUser: HarleyDealerUserCreateResponse
  createLoad: LoadCreateResponse
  createLoadNote: CreateLoadNoteResponse
  createNote: CreateNoteResponse
  createOsdRecord: OsdRecordCreateResponse
  createReference: CreateReferenceResponse
  createServiceEvent: CreateServiceEventResponse
  createTrailer: CreateTrailerResponse
  deleteFacilityContact: DeleteFacilityContactResponse
  deleteFacilityNote: DeleteFacilityNoteResponse
  deleteFreightRecord: FreightRecordDeleteResponse
  deleteNote: DeleteNoteResponse
  /** Delete a qualification. */
  deleteQualification: DeleteQualificationResponse
  deleteReference: DeleteReferenceResponse
  deleteServiceEvent: DeleteServiceEventResponse
  deleteStop: StopDeleteResponse
  deleteTrailerChange: DeleteTrailerChangeResponse
  denyDriverShareRequest: DriverShareRequestResponse
  dispatchLoad: DispatchLoadToDriverResponse
  duplicateStop: StopDuplicateResponse
  /** Create a new qualification, or return an existing match. */
  getOrCreateQualification: QualificationResponse
  login: UserResponse
  logout: User
  manualArriveDepart: ManualArriveDepartResponse
  markLoadCompleted: MarkLoadCompletedResponse
  markNotificationsAsRead: MarkedRead
  mergeLeg: MergeLegResponse
  removeCostCenterFromCustomer: RemovedCustomerCostCenterResponse
  removeCustomerLatenessConfigurationFromCustomer: RemovedCustomerLatenessConfigurationResponse
  removeDriverQualification: RemoveDriverQualificationResponse
  reorderCompletedStops: ReorderCompletedStopsResponse
  reorderStop: StopReorderResponse
  rescheduleStop: StopRescheduleResponse
  skipStop: StopSkipResponse
  splitLeg: SplitLegResponse
  startServiceEvent: StartServiceEventResponse
  tenderLoad: TenderLoadResponse
  toggleConsigneeNotificationType: ConsigneeNotificationTypeToggleResponse
  toggleCustomerFilterConfiguration: CustomerFilterConfigToggleResponse
  undoStops: StopsUndoneResponse
  /** Modify default filter for a user */
  updateActiveFilterGroup: UpdateActiveFilterGroupResponse
  updateBackhaulCode: UpdateBackhaulCodeResponse
  updateBillTo: UpdateBillToResponse
  updateConsigneeAllowNotifications: ConsigneeAllowNotificationsUpdateResponse
  updateCustomer: UpdateCustomerResponse
  updateCustomerLatenessConfiguration: AddedCustomerLatenessConfigurationResponse
  updateCustomerUser: CustomerUserUpdateResponse
  updateDriver: Driver
  updateDriverQualification: DriverQualification
  updateException: ExceptionUpdateResponse
  updateFacilityContact: UpdateFacilityContactResponse
  updateFacilityNote: UpdateFacilityNoteResponse
  updateFreightRecord: FreightRecordUpdateResponse
  updateLegPlannedStartTime: LegPlannedStartTimeResponse
  updateLocation: LocationResponse
  updateLocationConsigneeXMinAway: LocationConsigneeXMinAwayUpdateResponse
  updateNeedBy: UpdateShipmentNeedByResponse
  updateNote: UpdateNoteResponse
  updateOsdRecord: UpdateOsdRecordResponse
  /** Update a qualification. */
  updateQualification: QualificationResponse
  updateReference: UpdateReferenceResponse
  updateRoute: UpdateRouteResponse
  updateServiceEvent: UpdateServiceEventResponse
  updateStop: StopUpdateResponse
  updateTractorSpecification: UpdateTractorSpecificationResponse
  updateTrailerCostCenter: UpdateTrailerCostCenterResponse
  updateTrailerSpecification: UpdateTrailerSpecificationResponse
  updateUserSettings: UserSettingsResponse
  upsertCustomerColumnConfiguration: UpsertCustomerColumnConfigurationResponse
  withdrawLoadTender: WithdrawLoadTenderResponse
}

export type MutationAddCostCenterToCustomerArgs = {
  input: CustomerCostCenterCreate
}

export type MutationAddCustomerLatenessConfigurationToCustomerArgs = {
  input: CustomerLatenessConfigurationCreate
}

export type MutationAddDriverQualificationArgs = {
  input: DriverQualificationAdd
}

export type MutationAddLayoverStopArgs = {
  input: LayoverStopAddRequest
}

export type MutationAddStopArgs = {
  input: StopAddRequest
}

export type MutationAddTrailerChangeArgs = {
  input: AddTrailerChangeInput
}

export type MutationAssignCarrierToLegArgs = {
  carrierId?: InputMaybe<Scalars['Int']>
  legId: Scalars['Int']
}

export type MutationAssignDriverToShareRequestArgs = {
  input: AssignDriverToShareRequestInput
}

export type MutationAssignDriversToLegArgs = {
  legId: Scalars['Int']
  primaryDriverId?: InputMaybe<Scalars['Int']>
  secondaryDriverId?: InputMaybe<Scalars['Int']>
  tmwVersionId: Scalars['BigInt']
}

export type MutationAssignTractorToLegArgs = {
  legId: Scalars['Int']
  tmwVersionId: Scalars['BigInt']
  tractorId?: InputMaybe<Scalars['Int']>
}

export type MutationAssignTrailerToLoadArgs = {
  loadId: Scalars['Int']
  trailerId?: InputMaybe<Scalars['Int']>
}

export type MutationAssignTrailerToStopArgs = {
  input: AssignTrailerToStopInput
}

export type MutationAttemptStopArgs = {
  stopId: Scalars['BigIntStopID']
}

export type MutationCancelLoadArgs = {
  loadId: Scalars['Int']
  noteBody?: InputMaybe<Scalars['String']>
}

export type MutationCompleteServiceEventArgs = {
  input: ServiceEventComplete
}

export type MutationCreateConsigneeArgs = {
  input: ConsigneeCreate
}

export type MutationCreateCustomerArgs = {
  input: CustomerCreate
}

export type MutationCreateCustomerUserArgs = {
  input: CustomerUserCreate
}

export type MutationCreateDriverShareRequestArgs = {
  input: DriverShareRequestCreateInput
}

export type MutationCreateFacilityArgs = {
  input: FacilityCreate
}

export type MutationCreateFacilityContactArgs = {
  input: FacilityContactCreateRequest
}

export type MutationCreateFacilityNoteArgs = {
  input: FacilityNoteCreateRequest
}

export type MutationCreateFreightRecordArgs = {
  input: FreightRecordCreate
}

export type MutationCreateHarleyDealerUserArgs = {
  input: HarleyDealerUserCreate
}

export type MutationCreateLoadArgs = {
  input: LoadCreate
}

export type MutationCreateLoadNoteArgs = {
  input: LoadNoteCreateRequest
}

export type MutationCreateNoteArgs = {
  input: NoteCreateInput
}

export type MutationCreateOsdRecordArgs = {
  input: OsdRecordCreateRequest
}

export type MutationCreateReferenceArgs = {
  input: ReferenceCreate
}

export type MutationCreateServiceEventArgs = {
  input: ServiceEventCreate
}

export type MutationCreateTrailerArgs = {
  input: TrailerCreateRequest
}

export type MutationDeleteFacilityContactArgs = {
  input: FacilityContactDeleteRequest
}

export type MutationDeleteFacilityNoteArgs = {
  input: FacilityNoteDeleteRequest
}

export type MutationDeleteFreightRecordArgs = {
  input: FreightRecordDelete
}

export type MutationDeleteNoteArgs = {
  input: NoteDeleteInput
}

export type MutationDeleteQualificationArgs = {
  id: Scalars['Int']
}

export type MutationDeleteReferenceArgs = {
  input: ReferenceDelete
}

export type MutationDeleteServiceEventArgs = {
  input: ServiceEventDelete
}

export type MutationDeleteStopArgs = {
  stopId: Scalars['BigIntStopID']
  tmwVersionId: Scalars['BigInt']
}

export type MutationDeleteTrailerChangeArgs = {
  stopId: Scalars['BigIntStopID']
}

export type MutationDenyDriverShareRequestArgs = {
  input: DenyDriverShareRequestInput
}

export type MutationDispatchLoadArgs = {
  loadId: Scalars['Int']
  noteBody?: InputMaybe<Scalars['String']>
  tmwVersionId: Scalars['BigInt']
}

export type MutationDuplicateStopArgs = {
  input: StopDuplicateRequest
}

export type MutationGetOrCreateQualificationArgs = {
  input: QualificationCreate
}

export type MutationLoginArgs = {
  password: Scalars['String']
  username: Scalars['String']
}

export type MutationManualArriveDepartArgs = {
  input: ManualArriveDepartInput
}

export type MutationMarkLoadCompletedArgs = {
  loadId: Scalars['Int']
  noteBody?: InputMaybe<Scalars['String']>
}

export type MutationMarkNotificationsAsReadArgs = {
  notificationIds: Array<Scalars['Int']>
}

export type MutationMergeLegArgs = {
  input: LegMerge
}

export type MutationRemoveCostCenterFromCustomerArgs = {
  input: CustomerCostCenter
}

export type MutationRemoveCustomerLatenessConfigurationFromCustomerArgs = {
  input: CustomerLatenessConfigurationDelete
}

export type MutationRemoveDriverQualificationArgs = {
  driverId: Scalars['Int']
  qualificationId: Scalars['Int']
}

export type MutationReorderCompletedStopsArgs = {
  input: ReorderCompletedStopsRequest
}

export type MutationReorderStopArgs = {
  input: StopReorder
}

export type MutationRescheduleStopArgs = {
  input: StopRescheduleRequest
}

export type MutationSkipStopArgs = {
  stopId: Scalars['BigIntStopID']
}

export type MutationSplitLegArgs = {
  input: LegSplit
}

export type MutationStartServiceEventArgs = {
  input: ServiceEventStart
}

export type MutationTenderLoadArgs = {
  input: TenderLoadRequest
}

export type MutationToggleConsigneeNotificationTypeArgs = {
  input: ConsigneeNotificationTypeToggle
}

export type MutationToggleCustomerFilterConfigurationArgs = {
  input: CustomerFilterConfigToggle
}

export type MutationUndoStopsArgs = {
  input: UndoStopsInput
}

export type MutationUpdateActiveFilterGroupArgs = {
  input: UpdateActiveFilterGroupInput
}

export type MutationUpdateBackhaulCodeArgs = {
  backhaulCode: Scalars['String']
  loadId: Scalars['Int']
  tmwVersionId: Scalars['BigInt']
}

export type MutationUpdateBillToArgs = {
  billToId: Scalars['Int']
  loadId: Scalars['Int']
}

export type MutationUpdateConsigneeAllowNotificationsArgs = {
  input: ConsigneeAllowNotificationsUpdate
}

export type MutationUpdateCustomerArgs = {
  input: CustomerCodeUpdate
}

export type MutationUpdateCustomerLatenessConfigurationArgs = {
  input: CustomerLatenessConfiguration
}

export type MutationUpdateCustomerUserArgs = {
  input: CustomerUserUpdate
}

export type MutationUpdateDriverArgs = {
  input: DriverUpdate
}

export type MutationUpdateDriverQualificationArgs = {
  input: DriverQualificationUpdate
}

export type MutationUpdateExceptionArgs = {
  input: ExceptionUpdateRequest
}

export type MutationUpdateFacilityContactArgs = {
  input: FacilityContactUpdateRequest
}

export type MutationUpdateFacilityNoteArgs = {
  input: FacilityNoteUpdateRequest
}

export type MutationUpdateFreightRecordArgs = {
  input: FreightRecordUpdate
}

export type MutationUpdateLegPlannedStartTimeArgs = {
  legId: Scalars['Int']
  plannedStartTime: Scalars['DateTime']
  tmwVersionId: Scalars['BigInt']
}

export type MutationUpdateLocationArgs = {
  input: LocationUpdate
}

export type MutationUpdateLocationConsigneeXMinAwayArgs = {
  input: LocationConsigneeXMinAwayUpdate
}

export type MutationUpdateNeedByArgs = {
  input: ShipmentNeedByUpdateRequest
}

export type MutationUpdateNoteArgs = {
  input: NoteUpdateInput
}

export type MutationUpdateOsdRecordArgs = {
  input: OsdRecordUpdate
}

export type MutationUpdateQualificationArgs = {
  input: QualificationUpdate
}

export type MutationUpdateReferenceArgs = {
  input: ReferenceUpdate
}

export type MutationUpdateRouteArgs = {
  input: RouteUpdateRequest
}

export type MutationUpdateServiceEventArgs = {
  input: ServiceEventUpdate
}

export type MutationUpdateStopArgs = {
  input: StopUpdate
}

export type MutationUpdateTractorSpecificationArgs = {
  input: TractorSpecificationUpdate
}

export type MutationUpdateTrailerCostCenterArgs = {
  input: TrailerCostCenterUpdate
}

export type MutationUpdateTrailerSpecificationArgs = {
  input: TrailerSpecificationUpdate
}

export type MutationUpdateUserSettingsArgs = {
  input: UserSettingsUpdate
}

export type MutationUpsertCustomerColumnConfigurationArgs = {
  input: CustomerColumnConfigurationUpsert
}

export type MutationWithdrawLoadTenderArgs = {
  input: WithdrawLoadTenderRequest
}

export type NamedStopEvent = {
  __typename?: 'NamedStopEvent'
  name?: Maybe<Scalars['String']>
  scosAction: ScosStopAction
}

export type NoCostCenterAssignedToLoad = ErrorType & {
  __typename?: 'NoCostCenterAssignedToLoad'
  message: Scalars['String']
}

export type NoDriverAssignedToLeg = ErrorType & {
  __typename?: 'NoDriverAssignedToLeg'
  message: Scalars['String']
}

export type NotSupportedByCostCenter = ErrorType & {
  __typename?: 'NotSupportedByCostCenter'
  message: Scalars['String']
}

export type Note = {
  __typename?: 'Note'
  body: Scalars['String']
  createdAt: Scalars['DateTime']
  id: Scalars['Int']
}

export type NoteCreateInput = {
  tractorNoteCreate?: InputMaybe<TractorNoteCreate>
  trailerNoteCreate?: InputMaybe<TrailerNoteCreate>
}

export type NoteCreated = {
  __typename?: 'NoteCreated'
  note: Note
}

export type NoteDeleteInput = {
  loadNoteDelete?: InputMaybe<LoadNoteDelete>
  stopNoteDelete?: InputMaybe<StopNoteDelete>
  tractorNoteDelete?: InputMaybe<TractorNoteDelete>
  trailerNoteDelete?: InputMaybe<TrailerNoteDelete>
}

export type NoteDeleted = {
  __typename?: 'NoteDeleted'
  id: Scalars['Int']
}

export type NoteUpdateInput = {
  loadNoteUpdate?: InputMaybe<LoadNoteUpdate>
  stopNoteUpdate?: InputMaybe<StopNoteUpdate>
  tractorNoteUpdate?: InputMaybe<TractorNoteUpdate>
  trailerNoteUpdate?: InputMaybe<TrailerNoteUpdate>
}

export type NoteUpdated = {
  __typename?: 'NoteUpdated'
  note: Note
}

export type Notification = {
  __typename?: 'Notification'
  driver?: Maybe<Driver>
  driverId?: Maybe<Scalars['Int']>
  freightRecordId?: Maybe<Scalars['Int']>
  id: Scalars['Int']
  legIdx?: Maybe<Scalars['Int']>
  load?: Maybe<Load>
  loadId?: Maybe<Scalars['Int']>
  readAt?: Maybe<Scalars['DateTime']>
  stopIdx?: Maybe<Scalars['Int']>
  tier: RiskTier
  timestamp: Scalars['DateTime']
  type: NotificationType
}

export enum NotificationType {
  Detention = 'DETENTION',
  HosViolation = 'HOS_VIOLATION',
  LateAppointment = 'LATE_APPOINTMENT',
  LoadAuditDue = 'LOAD_AUDIT_DUE',
  LoadMatchingMissingEmpty = 'LOAD_MATCHING_MISSING_EMPTY',
  LoadNotStarted = 'LOAD_NOT_STARTED',
  OsdDamaged = 'OSD_DAMAGED',
  OsdOverage = 'OSD_OVERAGE',
  OsdShortage = 'OSD_SHORTAGE',
  StopAttempted = 'STOP_ATTEMPTED',
  StopSkipped = 'STOP_SKIPPED',
  TenderWithdrawn = 'TENDER_WITHDRAWN',
}

export enum OAuthProviderType {
  Google = 'GOOGLE',
  Okta = 'OKTA',
  Unknown = 'UNKNOWN',
}

export type ObjectDoesNotExist = ErrorType & {
  __typename?: 'ObjectDoesNotExist'
  message: Scalars['String']
}

export type OperatingHours = {
  __typename?: 'OperatingHours'
  day: DayOfWeek
  endTime: Scalars['Time']
  startTime: Scalars['Time']
}

export type OperatingHoursCreate = {
  day: DayOfWeek
  endTime: Scalars['Time']
  startTime: Scalars['Time']
}

export type OperationalStop = {
  __typename?: 'OperationalStop'
  legIdx: Scalars['Int']
  stopIdx: Scalars['Int']
}

export type OsdRecord = {
  __typename?: 'OsdRecord'
  barcode: Scalars['String']
  comments?: Maybe<Scalars['String']>
  freightRecordId: Scalars['Int']
  id: Scalars['Int']
  status: OsdRecordStatus
}

export type OsdRecordCreateRequest = {
  barcode: Scalars['String']
  freightRecordId: Scalars['Int']
  status: OsdRecordStatus
}

export type OsdRecordCreateResponse =
  | FreightRecordNotExists
  | InvalidFreightRecordUpdate
  | InvalidLoadStatus
  | InvalidOsdRecord
  | InvalidRadiusVersion
  | OsdRecordCreated

export type OsdRecordCreated = {
  __typename?: 'OsdRecordCreated'
  load: Load
  osdRecord: OsdRecord
}

export type OsdRecordPaginatedResponse = {
  __typename?: 'OsdRecordPaginatedResponse'
  meta?: Maybe<PageMeta>
  results: Array<OsdRecord>
}

export type OsdRecordQuery = {
  barcodeEq?: InputMaybe<Scalars['String']>
  barcodeIcontains?: InputMaybe<Scalars['String']>
  costCenterIdIn?: InputMaybe<Array<Scalars['Int']>>
  distinctOn?: InputMaybe<Array<Scalars['String']>>
  limit?: InputMaybe<Scalars['Int']>
  offset?: InputMaybe<Scalars['Int']>
}

export enum OsdRecordStatus {
  Damage = 'DAMAGE',
  Good = 'GOOD',
  Over = 'OVER',
  Planned = 'PLANNED',
  Short = 'SHORT',
}

export type OsdRecordUpdate = {
  barcode: Scalars['String']
  id: Scalars['Int']
}

export type OsdRecordUpdated = {
  __typename?: 'OsdRecordUpdated'
  load: Load
  osdRecord: OsdRecord
}

export type OtherCostCenterDistance = {
  __typename?: 'OtherCostCenterDistance'
  distance: Scalars['Float']
  id: Scalars['Int']
}

export type OverageException = {
  __typename?: 'OverageException'
  createdAt?: Maybe<Scalars['DateTime']>
  description?: Maybe<Scalars['String']>
  id: Scalars['Int']
  osdRecordId: Scalars['Int']
  stopId: Scalars['BigIntStopID']
  updatedAt?: Maybe<Scalars['DateTime']>
}

export type OverlappingPolygons = ErrorType & {
  __typename?: 'OverlappingPolygons'
  message: Scalars['String']
}

export type PageMeta = {
  __typename?: 'PageMeta'
  /** The current page number in the dataset. */
  page: Scalars['Int']
  /** The total number of pages in the dataset. */
  pages: Scalars['Int']
  /** The total number of items in the dataset. */
  total: Scalars['Int']
}

export type PermissionTypeError = ErrorType & {
  __typename?: 'PermissionTypeError'
  message: Scalars['String']
}

export type Qualification = {
  __typename?: 'Qualification'
  id: Scalars['Int']
  name: Scalars['String']
}

export type QualificationCreate = {
  name: Scalars['String']
}

export type QualificationDeleted = {
  __typename?: 'QualificationDeleted'
  id: Scalars['Int']
}

export type QualificationQuery = {
  idEq?: InputMaybe<Scalars['Int']>
  idIn?: InputMaybe<Array<Scalars['Int']>>
  nameEq?: InputMaybe<Scalars['String']>
  nameIcontains?: InputMaybe<Scalars['String']>
  nameIsNotNull?: InputMaybe<Scalars['Boolean']>
  nameIsNull?: InputMaybe<Scalars['Boolean']>
}

export type QualificationResponse = ObjectDoesNotExist | Qualification

export type QualificationUpdate = {
  id: Scalars['Int']
  name: Scalars['String']
}

export enum QuantityUnit {
  BagsBlue = 'BAGS_BLUE',
  BagsRed = 'BAGS_RED',
  BlackCage = 'BLACK_CAGE',
  BlueBin = 'BLUE_BIN',
  Books = 'BOOKS',
  Boxes = 'BOXES',
  Cartons = 'CARTONS',
  Cases = 'CASES',
  Clearance = 'CLEARANCE',
  Containers = 'CONTAINERS',
  Dandux = 'DANDUX',
  Duro = 'DURO',
  Each = 'EACH',
  Ewaste = 'EWASTE',
  EComTotes = 'E_COM_TOTES',
  FoodBarrel = 'FOOD_BARREL',
  FullGaylords = 'FULL_GAYLORDS',
  Furniture = 'FURNITURE',
  GarmentRack = 'GARMENT_RACK',
  Gaylord = 'GAYLORD',
  HazmatTote = 'HAZMAT_TOTE',
  Hoppers = 'HOPPERS',
  Jewelry = 'JEWELRY',
  Mattresses = 'MATTRESSES',
  Miscellaneous = 'MISCELLANEOUS',
  Packages = 'PACKAGES',
  Pallets = 'PALLETS',
  Pieces = 'PIECES',
  RawShoes = 'RAW_SHOES',
  RawTextile = 'RAW_TEXTILE',
  RawWares = 'RAW_WARES',
  RollingBin = 'ROLLING_BIN',
  SalvageTextile = 'SALVAGE_TEXTILE',
  SalvageWares = 'SALVAGE_WARES',
  ShopgoodwillCrates = 'SHOPGOODWILL_CRATES',
  StackEmptyGaylords = 'STACK_EMPTY_GAYLORDS',
  StackEmptyPallets = 'STACK_EMPTY_PALLETS',
  Totes = 'TOTES',
  Trash = 'TRASH',
}

export type Query = {
  __typename?: 'Query'
  currentUser?: Maybe<User>
  /** Get a list of active cost centers. */
  getAllActiveCostCenters: Array<CostCenter>
  getCarriers: Array<Carrier>
  getCarriersV2: CarrierPaginatedResponse
  /** Get a consignee by ID. */
  getConsignee?: Maybe<Consignee>
  /** Get allowed mileage types for a given cost center. */
  getCostCenterMileageTypes: Array<MileageType>
  /** Get a list of cost centers. */
  getCostCenters: CostCenterPaginatedResponse
  /** Search for reference numbers by substring. */
  getCustomerReferenceNumbers: CustomerReferenceNumberPaginatedResponse
  /** Get customer accounts */
  getCustomers: CustomerPaginatedResponse
  /** Get distance to a list of cost centers */
  getDistanceFromCostCenterToOtherCostCenters: CostCenterToOtherCostCenterDistance
  /** Get a list of Driver Share Request Queries. */
  getDriverShareRequests: DriverShareRequestPaginatedResponse
  /** Get a list of drivers. */
  getDrivers: DriverPaginatedResponse
  /** Get a list of drivers with status. */
  getDriversWithStatus: GetDriversStatusResponse
  /** Get EMACS aggregates for cost centers within a date range */
  getEmacsAggregatesForCostCenter: Array<CostCenterEmacsInfo>
  /** Get a paginated list of exceptions for the requesting customer. */
  getExceptionsForCustomers: CustomerExceptionRowPaginatedResponse
  /** Get a list of facilities */
  getFacilities: FacilityPaginatedResponse
  /** Get facility by facility id */
  getFacility: Facility
  /** Get freight record references */
  getFreightRecordReferences: FreightRecordReferencePaginatedResponse
  /** Get a load. */
  getLoad: Load
  /** Get a count of loads matching a query. */
  getLoadCount: Scalars['Int']
  /** Search for load references by substring. */
  getLoadReferences: CustomerReferenceNumberPaginatedResponse
  /**
   * Get a load.
   * @deprecated No longer in use?
   */
  getLoadV2: LoadResponse
  /** Get a list of loads. */
  getLoads: LoadPaginatedResponse
  /** Get location by location id */
  getLocation?: Maybe<Location>
  /** Get list of locations */
  getLocations: LocationPaginatedResponse
  /** Get locations in given bounds */
  getLocationsInBounds: LocationPaginatedResponse
  /** Get a list of Mission Control loads. */
  getMissionControlLoads: Array<MissionControlLoad>
  /** Get a count of loads for Mission Control network cards. Skips non-secure user filter groups so results align with map markers. */
  getMissionControlNetworkLoadCount: Scalars['Int']
  /** Get a paginated list of loads for Mission Control network cards. Skips non-secure user filter groups so results align with map markers. */
  getMissionControlNetworkLoads: LoadPaginatedResponse
  getNotificationsForUser: Array<Notification>
  /** Get OS&D records */
  getOsdRecords: OsdRecordPaginatedResponse
  /** Get all qualifications. */
  getQualifications: Array<Qualification>
  /** Get a list of reference types for entity and source system. */
  getReferenceTypes: Array<ReferenceType>
  /** Get a list of reschedulable stops. */
  getReschedulableStops: Array<ReschedulableStop>
  /** Get a list of routes. */
  getRoutes: RoutePaginatedResponse
  /** Get a list of shipment addresses */
  getShipmentAddresses: Array<Address>
  /** Get a count of shipments matching a query. */
  getShipmentCount: Scalars['Int']
  /** Search for shipment references by substring. */
  getShipmentReferences: ShipmentReferencePaginatedResponse
  /** Search for shipments by substring. */
  getShipments: ShipmentPaginatedResponse
  /** Get a stop estimate. */
  getStopEstimate: StopEstimateQueryResponse
  /** Get stop references */
  getStopReferences: StopReferencePaginatedResponse
  /** get tracking info for stop */
  getTrackingInfo?: Maybe<GetTrackingInfoResponse>
  /** Get a tracking link for a given stop for a load */
  getTrackingLink: TrackingLink
  /** Get a tractor by ID. */
  getTractor: Tractor
  /** Get a list of tractors. */
  getTractors: TractorPaginatedResponse
  /** Get a trailer by ID. */
  getTrailer: Trailer
  /** Get a list of trailers. */
  getTrailers: TrailerPaginatedResponse
  getUser?: Maybe<User>
  /** Get a list of users. */
  getUsers: UserPaginatedResponse
  /** validate a given tracking link */
  validateTrackingLink: ValidateTrackingLinkResponse
}

export type QueryGetCarriersArgs = {
  query: CarrierQuery
}

export type QueryGetCarriersV2Args = {
  query: CarrierQuery
}

export type QueryGetConsigneeArgs = {
  consigneeId: Scalars['Int']
}

export type QueryGetCostCenterMileageTypesArgs = {
  costCenterId: Scalars['Int']
}

export type QueryGetCostCentersArgs = {
  query: CostCenterQuery
}

export type QueryGetCustomerReferenceNumbersArgs = {
  query: CustomerReferenceNumberQuery
}

export type QueryGetCustomersArgs = {
  query: CustomerQuery
}

export type QueryGetDistanceFromCostCenterToOtherCostCentersArgs = {
  costCenterId: Scalars['Int']
  otherCostCenterIds: Array<Scalars['Int']>
}

export type QueryGetDriverShareRequestsArgs = {
  filter?: InputMaybe<DriverShareRequestQuery>
}

export type QueryGetDriversArgs = {
  query: DriverQuery
}

export type QueryGetDriversWithStatusArgs = {
  query: DriverQuery
}

export type QueryGetEmacsAggregatesForCostCenterArgs = {
  costCenterQuery: CostCenterQuery
  endDate: Scalars['Date']
  startDate: Scalars['Date']
  timezone: Scalars['String']
}

export type QueryGetExceptionsForCustomersArgs = {
  query: CustomerExceptionQuery
}

export type QueryGetFacilitiesArgs = {
  query: FacilityQuery
}

export type QueryGetFacilityArgs = {
  facilityId: Scalars['BigIntLocationID']
}

export type QueryGetFreightRecordReferencesArgs = {
  query: FreightRecordReferenceQuery
}

export type QueryGetLoadArgs = {
  loadId: Scalars['Int']
}

export type QueryGetLoadCountArgs = {
  query: LoadQuery
}

export type QueryGetLoadReferencesArgs = {
  query: CustomerReferenceNumberQuery
}

export type QueryGetLoadV2Args = {
  loadId: Scalars['Int']
}

export type QueryGetLoadsArgs = {
  query: LoadQuery
}

export type QueryGetLocationArgs = {
  id: Scalars['BigIntLocationID']
}

export type QueryGetLocationsArgs = {
  query: LocationQuery
}

export type QueryGetLocationsInBoundsArgs = {
  polygon: GpsPolygonBaseInput
}

export type QueryGetMissionControlLoadsArgs = {
  query: MissionControlLoadQuery
}

export type QueryGetMissionControlNetworkLoadCountArgs = {
  query: MissionControlNetworkLoadQuery
}

export type QueryGetMissionControlNetworkLoadsArgs = {
  query: MissionControlNetworkLoadQuery
}

export type QueryGetNotificationsForUserArgs = {
  timeFloor?: InputMaybe<Scalars['DateTime']>
}

export type QueryGetOsdRecordsArgs = {
  query: OsdRecordQuery
}

export type QueryGetQualificationsArgs = {
  query: QualificationQuery
}

export type QueryGetReferenceTypesArgs = {
  query: ReferenceTypeQuery
}

export type QueryGetReschedulableStopsArgs = {
  query: ReschedulableStopQuery
}

export type QueryGetRoutesArgs = {
  query: RouteQuery
}

export type QueryGetShipmentAddressesArgs = {
  query: AddressQuery
}

export type QueryGetShipmentCountArgs = {
  query: ShipmentQuery
}

export type QueryGetShipmentReferencesArgs = {
  query: ShipmentReferenceQuery
}

export type QueryGetShipmentsArgs = {
  query: ShipmentQuery
}

export type QueryGetStopEstimateArgs = {
  query: StopEstimateQuery
}

export type QueryGetStopReferencesArgs = {
  query: StopReferenceQuery
}

export type QueryGetTrackingInfoArgs = {
  input: TrackingLinkInput
}

export type QueryGetTrackingLinkArgs = {
  stopId: Scalars['BigIntStopID']
}

export type QueryGetTractorArgs = {
  tractorId: Scalars['Int']
}

export type QueryGetTractorsArgs = {
  query: TractorQuery
}

export type QueryGetTrailerArgs = {
  trailerId: Scalars['Int']
}

export type QueryGetTrailersArgs = {
  query: TrailerQuery
}

export type QueryGetUserArgs = {
  id: Scalars['Int']
}

export type QueryGetUsersArgs = {
  filter?: InputMaybe<UserQuery>
}

export type QueryValidateTrackingLinkArgs = {
  input: TrackingLinkInput
}

export enum RadiusVersion {
  V2 = 'V2',
  V3 = 'V3',
}

export type ReferenceCreate = {
  freightRecordCreate?: InputMaybe<FreightRecordReferenceCreate>
  loadCreate?: InputMaybe<LoadReferenceCreate>
  stopCreate?: InputMaybe<StopReferenceCreate>
}

export type ReferenceDelete = {
  freightRecordDelete?: InputMaybe<FreightRecordReferenceDelete>
  loadDelete?: InputMaybe<LoadReferenceDelete>
  stopDelete?: InputMaybe<StopReferenceDelete>
}

export type ReferenceType = {
  __typename?: 'ReferenceType'
  entity: Entity
  id: Scalars['Int']
  name?: Maybe<Scalars['String']>
  sourceSystem: SourceSystem
  type: Scalars['String']
}

export type ReferenceTypeQuery = {
  costCenterIdEq?: InputMaybe<Scalars['Int']>
  entityEq?: InputMaybe<Entity>
  entityIn?: InputMaybe<Array<Entity>>
  sourceSystemEq?: InputMaybe<SourceSystem>
  sourceSystemIn?: InputMaybe<Array<SourceSystem>>
  typeEq?: InputMaybe<Scalars['String']>
}

export type ReferenceUpdate = {
  freightRecordUpdate?: InputMaybe<FreightRecordReferenceUpdate>
  loadUpdate?: InputMaybe<LoadReferenceUpdate>
  stopUpdate?: InputMaybe<StopReferenceUpdate>
}

export enum RelativeDatetimeField {
  AppointmentEndTime = 'APPOINTMENT_END_TIME',
  AppointmentStartTime = 'APPOINTMENT_START_TIME',
}

export type RemoveDriverQualificationResponse =
  | DriverQualificationRemoved
  | ObjectDoesNotExist

export type RemovedCustomerCostCenterResponse = CustomerCostCenterUpdated

export type RemovedCustomerLatenessConfigurationResponse =
  | CustomerLatenessConfigurationNotFound
  | CustomerLatenessConfigurationUpdated
  | InvalidCustomerLatenessConfiguration

export type ReorderCompletedStopsError =
  | InvalidLoadStatus
  | InvalidRadiusVersion
  | InvalidStopEvent
  | InvalidStopReorder
  | ObjectDoesNotExist

export type ReorderCompletedStopsInvalid = {
  __typename?: 'ReorderCompletedStopsInvalid'
  error: ReorderCompletedStopsError
  stopId?: Maybe<Scalars['BigIntStopID']>
}

export type ReorderCompletedStopsRequest = {
  completedStopIdsInNewOrder: Array<Scalars['BigIntStopID']>
  legId: Scalars['Int']
}

export type ReorderCompletedStopsResponse =
  | CompletedStopsReordered
  | ReorderCompletedStopsInvalid

export type ReschedulableStop = {
  __typename?: 'ReschedulableStop'
  createdAt: Scalars['DateTime']
  load: Load
  primaryDriver?: Maybe<Driver>
  stopDetails: Stop
  stopId: Scalars['BigIntStopID']
}

export type ReschedulableStopQuery = {
  costCenterIdIn?: InputMaybe<Array<Scalars['Int']>>
  createdAtGt?: InputMaybe<Scalars['DateTime']>
  createdAtGte?: InputMaybe<Scalars['DateTime']>
  createdAtIsNotNull?: InputMaybe<Scalars['Boolean']>
  createdAtIsNull?: InputMaybe<Scalars['Boolean']>
  limit?: InputMaybe<Scalars['Int']>
  loadStatusIn?: InputMaybe<Array<LoadStatus>>
  offset?: InputMaybe<Scalars['Int']>
  rescheduledStopIdEq?: InputMaybe<Scalars['BigIntStopID']>
  rescheduledStopIdIn?: InputMaybe<Array<Scalars['BigIntStopID']>>
  rescheduledStopIdIsNotNull?: InputMaybe<Scalars['Boolean']>
  rescheduledStopIdIsNull?: InputMaybe<Scalars['Boolean']>
  sort?: Array<ReschedulableStopSortFields>
  stopIdEq?: InputMaybe<Scalars['BigIntStopID']>
  stopIdIn?: InputMaybe<Array<Scalars['BigIntStopID']>>
}

export enum ReschedulableStopSortFields {
  CreatedAtAsc = 'CREATED_AT_ASC',
  CreatedAtDesc = 'CREATED_AT_DESC',
  UpdatedAtAsc = 'UPDATED_AT_ASC',
  UpdatedAtDesc = 'UPDATED_AT_DESC',
}

export enum RiskTier {
  Critical = 'CRITICAL',
  Resolved = 'RESOLVED',
  Risk = 'RISK',
}

export type Route = {
  __typename?: 'Route'
  code: Scalars['String']
  id: Scalars['Int']
  name: Scalars['String']
  stops: Array<RouteStop>
}

export type RoutePaginatedResponse = {
  __typename?: 'RoutePaginatedResponse'
  meta?: Maybe<PageMeta>
  results: Array<Route>
}

export type RouteQuery = {
  codeEq?: InputMaybe<Scalars['String']>
  costCenterIdEq?: InputMaybe<Scalars['Int']>
  costCenterIdIn?: InputMaybe<Array<Scalars['Int']>>
  costCenterIdIsNotNull?: InputMaybe<Scalars['Boolean']>
  costCenterIdIsNull?: InputMaybe<Scalars['Boolean']>
  endDateRange?: InputMaybe<Array<InputMaybe<Scalars['DateTime']>>>
  excludeRetired?: InputMaybe<Scalars['Boolean']>
  fuzzyMatch?: InputMaybe<Scalars['String']>
  idEq?: InputMaybe<Scalars['Int']>
  idIn?: InputMaybe<Array<Scalars['Int']>>
  isSuppressedNe?: InputMaybe<Scalars['Boolean']>
  limit?: InputMaybe<Scalars['Int']>
  loadIdIn?: InputMaybe<Array<Scalars['Int']>>
  nameEq?: InputMaybe<Scalars['String']>
  nameIcontains?: InputMaybe<Scalars['String']>
  offset?: InputMaybe<Scalars['Int']>
  sort?: Array<RouteSortFields>
  startDateRange?: InputMaybe<Array<InputMaybe<Scalars['DateTime']>>>
  tripTypeIsNotNull?: InputMaybe<Scalars['Boolean']>
  tripTypeIsNull?: InputMaybe<Scalars['Boolean']>
}

export enum RouteSortFields {
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  NameAsc = 'NAME_ASC',
  NameDesc = 'NAME_DESC',
}

export type RouteStop = {
  __typename?: 'RouteStop'
  appointmentEnd?: Maybe<Scalars['DateTime']>
  appointmentStart?: Maybe<Scalars['DateTime']>
  id: Scalars['Int']
  idx: Scalars['Int']
  location?: Maybe<Location>
  mileageType: Scalars['String']
  scosAction: ScosStopAction
  stopType: Scalars['String']
}

export type RouteUpdateRequest = {
  loadId: Scalars['Int']
  routeId: Scalars['Int']
}

export type RouteUpdated = {
  __typename?: 'RouteUpdated'
  load: Load
}

export type RunningLateException = {
  __typename?: 'RunningLateException'
  stopId: Scalars['BigIntStopID']
}

export enum ScosStopAction {
  Bbt = 'BBT',
  Bcst = 'BCST',
  Bmt = 'BMT',
  Cdrp = 'CDRP',
  Chk = 'CHK',
  Cpup = 'CPUP',
  Crt = 'CRT',
  Ctr = 'CTR',
  D = 'D',
  Dep = 'DEP',
  Dhl = 'DHL',
  Div = 'DIV',
  Dld = 'DLD',
  Dlr = 'DLR',
  Dlt = 'DLT',
  Dmt = 'DMT',
  Drl = 'DRL',
  Drm = 'DRM',
  Drp = 'DRP',
  Dtl = 'DTL',
  Dtw = 'DTW',
  Dul = 'DUL',
  Ebt = 'EBT',
  Empty = 'EMPTY',
  Emt = 'EMT',
  Exc = 'EXC',
  Fuel = 'FUEL',
  Ful = 'FUL',
  Hct = 'HCT',
  Hlt = 'HLT',
  Hmt = 'HMT',
  Hpl = 'HPL',
  Hpllld = 'HPLLLD',
  Hpllul = 'HPLLUL',
  Htl = 'HTL',
  Ibbt = 'IBBT',
  Ibm = 'IBM',
  Ibmt = 'IBMT',
  Idlt = 'IDLT',
  Idmt = 'IDMT',
  Iebt = 'IEBT',
  Iemt = 'IEMT',
  Ihct = 'IHCT',
  Ihlt = 'IHLT',
  Ihmt = 'IHMT',
  Inserv = 'INSERV',
  Lld = 'LLD',
  Llld = 'LLLD',
  Llu = 'LLU',
  Llv = 'LLV',
  Lul = 'LUL',
  Lyl = 'LYL',
  Nbcst = 'NBCST',
  Nbs = 'NBS',
  Pld = 'PLD',
  Pul = 'PUL',
  Rl = 'RL',
  Rpt = 'RPT',
  Rsc = 'RSC',
  Rtp = 'RTP',
  Sap = 'SAP',
  Swpd = 'SWPD',
  Swpdrv = 'SWPDRV',
  Trcb = 'TRCB',
  Trcbkd = 'TRCBKD',
  Trp = 'TRP',
  Ttrp = 'TTRP',
  Ulc = 'ULC',
  Una = 'UNA',
  Wsh = 'WSH',
  Xdl = 'XDL',
  Xdu = 'XDU',
}

export type SentNotification = {
  __typename?: 'SentNotification'
  etaAtSend?: Maybe<Scalars['DateTime']>
  id: Scalars['Int']
  load?: Maybe<Load>
  loadId?: Maybe<Scalars['Int']>
  notificationType: ConsigneeNotificationType
  sentAt: Scalars['DateTime']
  stop?: Maybe<Stop>
  stopId?: Maybe<Scalars['Int']>
}

export type ServiceEvent = {
  __typename?: 'ServiceEvent'
  endDate?: Maybe<Scalars['Date']>
  estimatedEndDate?: Maybe<Scalars['Date']>
  estimatedStartDate: Scalars['Date']
  id: Scalars['Int']
  note?: Maybe<Scalars['String']>
  serviceType: ServiceEventType
  startDate?: Maybe<Scalars['Date']>
  status: ServiceEventStatus
}

export type ServiceEventComplete = {
  tractorServiceEventComplete?: InputMaybe<TractorServiceEventComplete>
  trailerServiceEventComplete?: InputMaybe<TrailerServiceEventComplete>
}

export type ServiceEventCreate = {
  tractorServiceEventCreate?: InputMaybe<TractorServiceEventCreate>
  trailerServiceEventCreate?: InputMaybe<TrailerServiceEventCreate>
}

export type ServiceEventDelete = {
  tractorServiceEventDelete?: InputMaybe<TractorServiceEventDelete>
  trailerServiceEventDelete?: InputMaybe<TrailerServiceEventDelete>
}

export type ServiceEventDeleted = {
  __typename?: 'ServiceEventDeleted'
  id: Scalars['Int']
}

export type ServiceEventPaginatedResponse = {
  __typename?: 'ServiceEventPaginatedResponse'
  meta?: Maybe<PageMeta>
  results: Array<ServiceEvent>
}

export type ServiceEventStart = {
  tractorServiceEventStart?: InputMaybe<TractorServiceEventStart>
  trailerServiceEventStart?: InputMaybe<TrailerServiceEventStart>
}

export enum ServiceEventStatus {
  Completed = 'COMPLETED',
  InTheShop = 'IN_THE_SHOP',
  Planned = 'PLANNED',
  PmDue = 'PM_DUE',
}

export enum ServiceEventType {
  CorrectiveMaintenance = 'CORRECTIVE_MAINTENANCE',
  EmergencyRepairs = 'EMERGENCY_REPAIRS',
  InspectionOrCompliance = 'INSPECTION_OR_COMPLIANCE',
  InstallationOrModification = 'INSTALLATION_OR_MODIFICATION',
  PreventativeMaintenance = 'PREVENTATIVE_MAINTENANCE',
}

export type ServiceEventUpdate = {
  tractorServiceEventUpdate?: InputMaybe<TractorServiceEventUpdate>
  trailerServiceEventUpdate?: InputMaybe<TrailerServiceEventUpdate>
}

export type Shipment = {
  __typename?: 'Shipment'
  actualDelivery?: Maybe<Scalars['DateTime']>
  actualPickup?: Maybe<Scalars['DateTime']>
  appointmentDelivery?: Maybe<Scalars['DateTime']>
  appointmentPickup?: Maybe<Scalars['DateTime']>
  attributeReferences: Array<ShipmentReference>
  carrier?: Maybe<Carrier>
  carrierTrackingLink?: Maybe<Scalars['String']>
  code: Scalars['String']
  costCenter?: Maybe<CostCenter>
  costCenterId: Scalars['Int']
  createDate?: Maybe<Scalars['DateTime']>
  deliveryScheduledTimes?: Maybe<DynamicDateRange>
  deliveryTimes?: Maybe<DynamicDateRange>
  destination?: Maybe<Location>
  destinationLocation?: Maybe<Location>
  destinationStop?: Maybe<Stop>
  effectiveStatus?: Maybe<ShipmentStatus>
  georoute: Georoute
  georouteWithSpacing: Georoute
  gpsEventsWithLocations: Array<GpsEventWithLocation>
  id: Scalars['Int']
  loads: Array<Maybe<Load>>
  needBy?: Maybe<Scalars['DateTime']>
  origin?: Maybe<Location>
  originLocation?: Maybe<Location>
  originStop?: Maybe<Stop>
  pickupScheduledTimes?: Maybe<DynamicDateRange>
  pickupTimes?: Maybe<DynamicDateRange>
  plannedDeliveryEnd?: Maybe<Scalars['DateTime']>
  plannedDeliveryStart?: Maybe<Scalars['DateTime']>
  plannedPickupEnd?: Maybe<Scalars['DateTime']>
  plannedPickupStart?: Maybe<Scalars['DateTime']>
  primaryReference?: Maybe<ShipmentReference>
  requestedDeliveryEnd?: Maybe<Scalars['DateTime']>
  requestedDeliveryStart?: Maybe<Scalars['DateTime']>
  requestedPickupEnd?: Maybe<Scalars['DateTime']>
  requestedPickupStart?: Maybe<Scalars['DateTime']>
  searchAndDisplayReferences: Array<ShipmentReference>
  shipmentLoads: Array<Maybe<ShipmentLoad>>
  status: ShipmentStatus
}

export type ShipmentGeorouteWithSpacingArgs = {
  spacing: Scalars['Float']
}

export type ShipmentLoad = {
  __typename?: 'ShipmentLoad'
  /** Resolves to the all associated TM load for an integrated DTS load. */
  associatedLoads: Array<AssociatedLoad>
  auditTrailEvents: Array<AuditTrailEvent>
  autoCompleteScheduledTime?: Maybe<Scalars['DateTime']>
  /** Resolves to the base DTS load for an integrated TM load. */
  baseDtsLoad?: Maybe<BaseLoad>
  billToId?: Maybe<Scalars['Int']>
  breadcrumbLocations: Array<GpsEventWithLocation>
  carrierIsPrime?: Maybe<Scalars['Boolean']>
  costCenter?: Maybe<CostCenter>
  courierJsonExtract?: Maybe<Scalars['String']>
  createdAt?: Maybe<Scalars['DateTime']>
  customerNumbers?: Maybe<Scalars['String']>
  customerReferenceNumbers: Array<CustomerReferenceNumber>
  dispatchAt?: Maybe<Scalars['DateTime']>
  documents: DocumentResponse
  dropoffStop?: Maybe<Stop>
  endTime?: Maybe<Scalars['DateTime']>
  equipmentSize?: Maybe<Scalars['String']>
  equipmentType?: Maybe<EquipmentType>
  etasLastCalculated?: Maybe<Scalars['DateTime']>
  exceptions: Array<ExceptionTypes>
  firstPickupScheduledTimes?: Maybe<DynamicDateRange>
  firstPickupTimes?: Maybe<DynamicDateRange>
  firstStopScheduledTimes?: Maybe<DynamicDateRange>
  firstStopTimes?: Maybe<DynamicDateRange>
  freightDetails: FreightDetails
  freightRecordReferences: Array<FreightRecordReference>
  gpsEventsWithLocations: Array<GpsEventWithLocation>
  id: Scalars['Int']
  initialEstimatedTime: Scalars['Int']
  integratedRyderNumber?: Maybe<Scalars['String']>
  isRv3?: Maybe<Scalars['Boolean']>
  lastDeliveryScheduledTimes?: Maybe<DynamicDateRange>
  lastDeliveryTimes?: Maybe<DynamicDateRange>
  lastStopScheduledTimes?: Maybe<DynamicDateRange>
  lastStopTimes?: Maybe<DynamicDateRange>
  latestGpsEvent?: Maybe<GpsEventWithLocation>
  legs: Array<Leg>
  minNeedBy?: Maybe<LoadMinNeedByInfo>
  nextStop?: Maybe<Stop>
  notes: Array<LoadNote>
  operationalStop?: Maybe<OperationalStop>
  pickToDropGeoroute: Georoute
  pickToDropGeorouteWithSpacing: Georoute
  pickupStop?: Maybe<Stop>
  primaryReference?: Maybe<LoadReference>
  proReference?: Maybe<CustomerReferenceNumber>
  references: Array<CustomerReferenceNumber>
  route?: Maybe<Route>
  routeId?: Maybe<Scalars['Int']>
  ryderNumber?: Maybe<Scalars['String']>
  searchAndDisplayReferences: Array<CustomerReferenceNumber>
  /** @deprecated temporary for preseving backward compatibility. Eventually use `search_and_display_references` instead */
  searchAndDisplayReferences_Deprecated: Array<CustomerReferenceNumber>
  shipmentId: Scalars['Int']
  shipmentIds: Array<Scalars['Int']>
  source: LoadSource
  sourceSystem: SourceSystem
  startTime?: Maybe<Scalars['DateTime']>
  status: LoadStatus
  stopReferences: Array<StopReference>
  targetDispatchStartInterval?: Maybe<Scalars['TimeDelta']>
  tenderStatus: LoadTenderStatus
  tmwVersionId: Scalars['BigInt']
  topActionableLateStop?: Maybe<Stop>
  trailer?: Maybe<Trailer>
  trailerUnitNumbers: Array<Maybe<Scalars['String']>>
  transitMode: TransitMode
}

export type ShipmentLoadPickToDropGeorouteWithSpacingArgs = {
  spacing: Scalars['Float']
}

export type ShipmentNeedByUpdateRequest = {
  needBy?: InputMaybe<Scalars['DateTime']>
  shipmentId: Scalars['Int']
}

export type ShipmentNeedByUpdated = {
  __typename?: 'ShipmentNeedByUpdated'
  shipmentId: Scalars['Int']
}

export type ShipmentPaginatedResponse = {
  __typename?: 'ShipmentPaginatedResponse'
  meta?: Maybe<PageMeta>
  results: Array<Shipment>
}

export type ShipmentQuery = {
  actualDeliveryDateRange?: InputMaybe<Array<Scalars['DateTime']>>
  actualPickupDateRange?: InputMaybe<Array<Scalars['DateTime']>>
  appointmentDeliveryDateRange?: InputMaybe<Array<Scalars['DateTime']>>
  appointmentPickupDateRange?: InputMaybe<Array<Scalars['DateTime']>>
  carrierEtaDateRange?: InputMaybe<Array<Scalars['DateTime']>>
  carrierIdIn?: InputMaybe<Array<Scalars['Int']>>
  carrierTypeIn?: InputMaybe<Array<CarrierType>>
  carrierUnassigned?: InputMaybe<Scalars['Boolean']>
  codeEq?: InputMaybe<Scalars['String']>
  codeIcontains?: InputMaybe<Scalars['String']>
  codeIn?: InputMaybe<Array<Scalars['String']>>
  codeOrAssociatedLoadReferenceIn?: InputMaybe<Array<Scalars['String']>>
  costCenterIdEq?: InputMaybe<Scalars['Int']>
  costCenterIdIn?: InputMaybe<Array<Scalars['Int']>>
  deliveryScheduledTimesDateRange?: InputMaybe<Array<Scalars['DateTime']>>
  deliveryTimesDateRange?: InputMaybe<Array<Scalars['DateTime']>>
  destinationLocaleIn?: InputMaybe<Array<Array<InputMaybe<Scalars['String']>>>>
  destinationLocationReferenceValueIn?: InputMaybe<Array<Scalars['String']>>
  destinationNeedByDateRange?: InputMaybe<Array<Scalars['DateTime']>>
  destinationNeedByExists?: InputMaybe<Scalars['Boolean']>
  destinationStopIdEq?: InputMaybe<Scalars['Int']>
  exceptions?: InputMaybe<Array<ExceptionType>>
  hasDestinationStopsRunningLate?: InputMaybe<Scalars['Boolean']>
  idIn?: InputMaybe<Array<Scalars['Int']>>
  isCriticalCareEq?: InputMaybe<Scalars['Boolean']>
  isCriticalCareIsNotNull?: InputMaybe<Scalars['Boolean']>
  isCriticalCareIsNull?: InputMaybe<Scalars['Boolean']>
  limit?: InputMaybe<Scalars['Int']>
  loadIdIn?: InputMaybe<Array<Scalars['Int']>>
  localeIn?: InputMaybe<Array<Array<Scalars['String']>>>
  offset?: InputMaybe<Scalars['Int']>
  originLocaleIn?: InputMaybe<Array<Array<InputMaybe<Scalars['String']>>>>
  originLocationReferenceValueIn?: InputMaybe<Array<Scalars['String']>>
  pickupScheduledTimesDateRange?: InputMaybe<Array<Scalars['DateTime']>>
  pickupTimesDateRange?: InputMaybe<Array<Scalars['DateTime']>>
  plannedDeliveryStartDateRange?: InputMaybe<Array<Scalars['DateTime']>>
  plannedPickupDateRange?: InputMaybe<Array<Scalars['DateTime']>>
  poSupplierIn?: InputMaybe<Array<Scalars['String']>>
  referenceEq?: InputMaybe<Array<Scalars['String']>>
  referenceIn?: InputMaybe<Scalars['String']>
  referenceValueIn?: InputMaybe<Array<Array<Scalars['String']>>>
  relatedLoadIdEq?: InputMaybe<Scalars['Int']>
  shipmentDestinationLocationReferenceIn?: InputMaybe<Array<Scalars['String']>>
  shipmentReferenceEq?: InputMaybe<Array<Scalars['String']>>
  sortByNeedBy?: InputMaybe<SortInput>
  sortByPlannedArrivalStart?: InputMaybe<SortInput>
  statusEq?: InputMaybe<ShipmentStatus>
  statusIn?: InputMaybe<Array<ShipmentStatus>>
  transitModeIn?: InputMaybe<Array<TransitMode>>
}

export type ShipmentReference = {
  __typename?: 'ShipmentReference'
  displayName?: Maybe<Scalars['String']>
  id: Scalars['Int']
  isDisplayed: Scalars['Boolean']
  shipmentId: Scalars['Int']
  type: Scalars['String']
  value: Scalars['String']
}

export type ShipmentReferencePaginatedResponse = {
  __typename?: 'ShipmentReferencePaginatedResponse'
  meta?: Maybe<PageMeta>
  results: Array<ShipmentReference>
}

export type ShipmentReferenceQuery = {
  costCenterIdIn?: InputMaybe<Array<Scalars['Int']>>
  distinctOn?: InputMaybe<Array<Scalars['String']>>
  idEq?: InputMaybe<Scalars['Int']>
  idIn?: InputMaybe<Array<Scalars['Int']>>
  isSearchAndDisplay?: InputMaybe<Scalars['Boolean']>
  limit?: InputMaybe<Scalars['Int']>
  offset?: InputMaybe<Scalars['Int']>
  referenceTypeCostCenterIdIn?: InputMaybe<Array<Scalars['Int']>>
  shipmentIdEq?: InputMaybe<Scalars['Int']>
  shipmentIdIn?: InputMaybe<Array<Scalars['Int']>>
  sourceSystemEq?: InputMaybe<SourceSystem>
  typeEq?: InputMaybe<Scalars['String']>
  typeIn?: InputMaybe<Array<Scalars['String']>>
  valueEq?: InputMaybe<Scalars['String']>
  valueIcontains?: InputMaybe<Scalars['String']>
  valueIlikeAny?: InputMaybe<Array<Scalars['String']>>
  valueIn?: InputMaybe<Array<Scalars['String']>>
}

export enum ShipmentStatus {
  Cancelled = 'CANCELLED',
  Delivered = 'DELIVERED',
  OnHold = 'ON_HOLD',
  Open = 'OPEN',
  PickedUp = 'PICKED_UP',
  Planned = 'PLANNED',
  Unknown = 'UNKNOWN',
}

export type ShortageException = {
  __typename?: 'ShortageException'
  createdAt?: Maybe<Scalars['DateTime']>
  description?: Maybe<Scalars['String']>
  id: Scalars['Int']
  osdRecordId: Scalars['Int']
  stopId: Scalars['BigIntStopID']
  updatedAt?: Maybe<Scalars['DateTime']>
}

export type SkippedStopException = {
  __typename?: 'SkippedStopException'
  createdAt?: Maybe<Scalars['DateTime']>
  createdBy?: Maybe<User>
  description?: Maybe<Scalars['String']>
  driverCreatedBy?: Maybe<Scalars['Int']>
  id: Scalars['Int']
  rescheduledRyderNumber?: Maybe<Scalars['String']>
  stopId: Scalars['BigIntStopID']
  updatedAt?: Maybe<Scalars['DateTime']>
}

export enum SortInput {
  Asc = 'ASC',
  Desc = 'DESC',
  None = 'NONE',
}

export enum SourceSystem {
  Card = 'CARD',
  Lms = 'LMS',
  Radius = 'RADIUS',
  Tm = 'TM',
  Tmw = 'TMW',
}

export type SplitLegResponse =
  | InvalidLegWithCarrierAction
  | InvalidLoadStatus
  | InvalidStopEvent
  | InvalidStopIdx
  | InvalidStopLocation
  | InvalidStopStatus
  | InvalidTmwVersionIdAnton
  | InvalidTmwVersionIdClient
  | InvalidTmwVersionIdScos
  | NoCostCenterAssignedToLoad
  | NotSupportedByCostCenter
  | ObjectDoesNotExist
  | SplitLegSuccess
  | TmwValidationError
  | TractorNotExists

export type SplitLegSuccess = {
  __typename?: 'SplitLegSuccess'
  load: Load
}

/** Response type for starting a service event. */
export type StartServiceEventResponse =
  | InvalidServiceEventStart
  | InvalidServiceEventStatus
  | InvalidTractorStatus
  | InvalidTrailerStatus
  | NotSupportedByCostCenter
  | ObjectDoesNotExist
  | TractorServiceEventStarted
  | TrailerServiceEventStarted

export type Stop = {
  __typename?: 'Stop'
  action: LocationActionType
  actualMiles?: Maybe<Scalars['Int']>
  adaptiveDeliveryDate?: Maybe<AdaptiveDeliveryDate>
  appointmentEnd?: Maybe<Scalars['DateTime']>
  appointmentStart?: Maybe<Scalars['DateTime']>
  arrivalTime?: Maybe<Scalars['DateTime']>
  associatedShipmentIds: StopAssociatedShipments
  associatedTmStop?: Maybe<AssociatedTmStop>
  attemptable: Scalars['Boolean']
  baseDtsStop?: Maybe<BaseDtsStop>
  carrierEta?: Maybe<Scalars['DateTime']>
  /** @deprecated Use effectiveEta instead */
  carrierOrGeneratedEta?: Maybe<Scalars['DateTime']>
  customerAppointmentEnd?: Maybe<Scalars['DateTime']>
  departureTime?: Maybe<Scalars['DateTime']>
  documents: DocumentResponse
  effectiveEta?: Maybe<Scalars['DateTime']>
  effectiveEtaType?: Maybe<DynamicDateType>
  estimateData?: Maybe<StopEstimateFields>
  estimatedArrivalTime?: Maybe<Scalars['DateTime']>
  estimatedDepartureTime?: Maybe<Scalars['DateTime']>
  exceptions: Array<ExceptionTypes>
  id: Scalars['BigIntStopID']
  idx: Scalars['Int']
  isAppointmentValid: Scalars['Boolean']
  isCriticalAppointment: Scalars['Boolean']
  isDocExpected: Scalars['Boolean']
  isReorderable: Scalars['Boolean']
  isReschedulable: Scalars['Boolean']
  isTrailerAssignable: Scalars['Boolean']
  isTrailerSegmentStart: Scalars['Boolean']
  isValidForTrailerChange: Scalars['Boolean']
  latenessStatus?: Maybe<StopLatenessStatus>
  latenessThresholdTime?: Maybe<Scalars['DateTime']>
  location?: Maybe<Location>
  mileageType?: Maybe<Scalars['String']>
  minNeedBy?: Maybe<Scalars['DateTime']>
  /** @deprecated Use min_need_by instead */
  needBy?: Maybe<Scalars['DateTime']>
  notes: Array<LoadNote>
  plannedArrivalEnd?: Maybe<Scalars['DateTime']>
  plannedArrivalStart?: Maybe<Scalars['DateTime']>
  plannedDepartureEnd?: Maybe<Scalars['DateTime']>
  plannedDepartureStart?: Maybe<Scalars['DateTime']>
  plannedMiles?: Maybe<Scalars['Float']>
  references: Array<CustomerReferenceNumber>
  removable: Scalars['Boolean']
  runningLateSeconds: Scalars['Int']
  scosAction?: Maybe<ScosStopAction>
  scosActionFullName?: Maybe<Scalars['String']>
  skippable: Scalars['Boolean']
  status?: Maybe<StopStatus>
  stopReferences: Array<StopReference>
  tractorMileage?: Maybe<Scalars['Int']>
  trailer?: Maybe<Trailer>
  trailerId?: Maybe<Scalars['Int']>
  trailerSegmentIdx?: Maybe<Scalars['Int']>
  type?: Maybe<Scalars['String']>
  unactualizable: Scalars['Boolean']
  updatedAt?: Maybe<Scalars['DateTime']>
  validForSplit: Scalars['Boolean']
}

export type StopAddRequest = {
  appointmentEnd?: InputMaybe<Scalars['DateTime']>
  appointmentStart?: InputMaybe<Scalars['DateTime']>
  arrivalTime?: InputMaybe<Scalars['DateTime']>
  departureTime?: InputMaybe<Scalars['DateTime']>
  idx: Scalars['Int']
  isCriticalAppointment?: InputMaybe<Scalars['Boolean']>
  legId: Scalars['Int']
  locationId: Scalars['BigIntLocationID']
  scosAction: ScosStopAction
  tmwVersionId?: InputMaybe<Scalars['BigInt']>
  tractorMileage?: InputMaybe<Scalars['Int']>
  type?: InputMaybe<Scalars['String']>
}

export type StopAddResponse =
  | InvalidLegStartTime
  | InvalidOdometer
  | InvalidStopAdd
  | InvalidStopAppointmentEnd
  | InvalidStopAppointmentStart
  | InvalidStopAppointmentTime
  | InvalidStopDateTime
  | InvalidStopEvent
  | InvalidStopLocation
  | InvalidStopStatus
  | InvalidStopType
  | InvalidTmwVersionIdClient
  | InvalidTmwVersionIdScos
  | NoCostCenterAssignedToLoad
  | ObjectDoesNotExist
  | StopAdded
  | TmwValidationError

export type StopAdded = {
  __typename?: 'StopAdded'
  load: Load
  tmwVersionId: Scalars['BigInt']
}

export type StopArrivalDeparture = {
  arrivalTime?: InputMaybe<Scalars['DateTime']>
  departureTime: Scalars['DateTime']
  id: Scalars['BigIntStopID']
  tractorMileage?: InputMaybe<Scalars['Int']>
  updatedBy?: InputMaybe<Scalars['Int']>
}

export type StopAssociatedShipments = {
  __typename?: 'StopAssociatedShipments'
  deliveryShipmentIds: Array<Scalars['Int']>
  pickupShipmentIds: Array<Scalars['Int']>
}

export type StopAttemptResponse =
  | InvalidAttemptStop
  | InvalidLegStatus
  | InvalidLoadStatus
  | InvalidRadiusVersion
  | ObjectDoesNotExist
  | StopAttempted

export type StopAttempted = {
  __typename?: 'StopAttempted'
  load: Load
  stopId: Scalars['BigIntStopID']
}

export type StopDeleteResponse =
  | InvalidLegStatus
  | InvalidLegUpdateError
  | InvalidLoadStatus
  | InvalidStopDelete
  | InvalidStopEvent
  | InvalidStopStatus
  | InvalidTmwVersionIdClient
  | InvalidTmwVersionIdScos
  | ObjectDoesNotExist
  | StopDeleted
  | TmwValidationError

export type StopDeleted = {
  __typename?: 'StopDeleted'
  load: Load
}

export type StopDuplicateRequest = {
  appointmentEnd?: InputMaybe<Scalars['DateTime']>
  appointmentStart?: InputMaybe<Scalars['DateTime']>
  locationId: Scalars['BigIntLocationID']
  scosAction: ScosStopAction
  stopId: Scalars['BigIntStopID']
  tmwVersionId: Scalars['BigInt']
}

export type StopDuplicateResponse =
  | InvalidStopAppointmentEnd
  | InvalidStopAppointmentStart
  | InvalidStopAppointmentTime
  | InvalidStopDateTime
  | InvalidStopEvent
  | InvalidStopLocation
  | InvalidStopStatus
  | InvalidTmwVersionIdClient
  | InvalidTmwVersionIdScos
  | NoCostCenterAssignedToLoad
  | ObjectDoesNotExist
  | StopAdded
  | TmwValidationError

export type StopEstimate = {
  __typename?: 'StopEstimate'
  estimateData: StopEstimateFields
  stopLocation: StopEstimateLocation
}

export type StopEstimateFields = {
  __typename?: 'StopEstimateFields'
  estimatedArrivalTime?: Maybe<Scalars['DateTime']>
  estimatedDepartureTime?: Maybe<Scalars['DateTime']>
  estimatedDwellTime?: Maybe<Scalars['Int']>
  estimatedMilesFromPrevStop?: Maybe<Scalars['Float']>
  estimatedTimeFromPrevStop?: Maybe<Scalars['Int']>
  milesFromPrevStop?: Maybe<Scalars['Float']>
  timeFromPrevStop?: Maybe<Scalars['Int']>
}

export type StopEstimateLocation = {
  __typename?: 'StopEstimateLocation'
  address?: Maybe<Address>
  locationId?: Maybe<Scalars['BigIntLocationID']>
  name?: Maybe<Scalars['String']>
  point: GpsPoint
  timeZoneCode: Scalars['String']
  timeZoneName: Scalars['String']
}

export type StopEstimateQuery = {
  arrivalTime?: InputMaybe<Scalars['DateTime']>
  departureTime?: InputMaybe<Scalars['DateTime']>
  legId: Scalars['Int']
  loadId: Scalars['Int']
  locationId?: InputMaybe<Scalars['BigIntLocationID']>
  stopIdx: Scalars['Int']
}

export type StopEstimateQueryResponse =
  | InvalidStopEstimateQuery
  | ObjectDoesNotExist
  | StopEstimate

export type StopLateReason = {
  __typename?: 'StopLateReason'
  category: Scalars['String']
  code: Scalars['String']
  id: Scalars['Int']
  name: Scalars['String']
}

export enum StopLatenessStatus {
  Late = 'LATE',
  RunningLate = 'RUNNING_LATE',
}

export type StopNoteDelete = {
  id: Scalars['Int']
  stopId: Scalars['BigIntStopID']
}

export type StopNoteUpdate = {
  body: Scalars['String']
  id: Scalars['Int']
  stopId: Scalars['BigIntStopID']
}

export type StopReference = {
  __typename?: 'StopReference'
  displayName?: Maybe<Scalars['String']>
  id: Scalars['Int']
  stopId: Scalars['BigIntStopID']
  type: Scalars['String']
  value: Scalars['String']
}

export type StopReferenceCreate = {
  stopId: Scalars['BigIntStopID']
  type?: InputMaybe<Scalars['String']>
  value?: InputMaybe<Scalars['String']>
}

export type StopReferenceCreated = {
  __typename?: 'StopReferenceCreated'
  load: Load
  reference: StopReference
}

export type StopReferenceDelete = {
  id: Scalars['Int']
}

export type StopReferenceDeleted = {
  __typename?: 'StopReferenceDeleted'
  load: Load
  reference: StopReference
}

export type StopReferencePaginatedResponse = {
  __typename?: 'StopReferencePaginatedResponse'
  meta?: Maybe<PageMeta>
  results: Array<StopReference>
}

export type StopReferenceQuery = {
  costCenterIdIn?: InputMaybe<Array<Scalars['Int']>>
  distinctOn?: InputMaybe<Array<Scalars['String']>>
  idEq?: InputMaybe<Scalars['Int']>
  idIn?: InputMaybe<Array<Scalars['Int']>>
  limit?: InputMaybe<Scalars['Int']>
  offset?: InputMaybe<Scalars['Int']>
  stopIdEq?: InputMaybe<Scalars['BigIntStopID']>
  stopIdIn?: InputMaybe<Array<Scalars['BigIntStopID']>>
  typeEq?: InputMaybe<Scalars['String']>
  typeIn?: InputMaybe<Array<Scalars['String']>>
  valueEq?: InputMaybe<Scalars['String']>
  valueIcontains?: InputMaybe<Scalars['String']>
  valueIlikeAny?: InputMaybe<Array<Scalars['String']>>
  valueIn?: InputMaybe<Array<Scalars['String']>>
}

export type StopReferenceUpdate = {
  id: Scalars['Int']
  type?: InputMaybe<Scalars['String']>
  value?: InputMaybe<Scalars['String']>
}

export type StopReferenceUpdated = {
  __typename?: 'StopReferenceUpdated'
  load: Load
  reference: StopReference
}

export type StopReorder = {
  fromIdx: Scalars['Int']
  legId: Scalars['Int']
  tmwVersionId?: InputMaybe<Scalars['BigInt']>
  toIdx: Scalars['Int']
}

export type StopReorderResponse =
  | InvalidLegUpdateError
  | InvalidLoadStatus
  | InvalidStopEvent
  | InvalidStopReorder
  | InvalidStopStatus
  | InvalidTmwVersionIdClient
  | InvalidTmwVersionIdScos
  | ObjectDoesNotExist
  | StopReordered
  | TmwValidationError

export type StopReordered = {
  __typename?: 'StopReordered'
  load: Load
}

export type StopRescheduleRequest = {
  appointmentEnd: Scalars['DateTime']
  appointmentStart: Scalars['DateTime']
  sourceStopId: Scalars['BigIntStopID']
  targetLegIdx: Scalars['Int']
  targetLoadId: Scalars['Int']
  targetStopIdx: Scalars['Int']
}

export type StopRescheduleResponse =
  | InvalidLegStatus
  | InvalidRadiusVersion
  | InvalidRescheduleStop
  | InvalidStopEvent
  | NoCostCenterAssignedToLoad
  | ObjectDoesNotExist
  | StopRescheduled

export type StopRescheduled = {
  __typename?: 'StopRescheduled'
  load: Load
}

export type StopSkipResponse =
  | InvalidRadiusVersion
  | InvalidSkipStop
  | InvalidStopEvent
  | InvalidStopStatus
  | ObjectDoesNotExist
  | StopSkipped

export type StopSkipped = {
  __typename?: 'StopSkipped'
  load: Load
}

export enum StopStatus {
  Attempted = 'ATTEMPTED',
  Skipped = 'SKIPPED',
  Unknown = 'UNKNOWN',
}

export type StopUpdate = {
  appointmentEnd?: InputMaybe<Scalars['DateTime']>
  appointmentStart?: InputMaybe<Scalars['DateTime']>
  arrivalTime?: InputMaybe<Scalars['DateTime']>
  departureTime?: InputMaybe<Scalars['DateTime']>
  id: Scalars['BigIntStopID']
  isCriticalAppointment?: InputMaybe<Scalars['Boolean']>
  locationId?: InputMaybe<Scalars['BigIntLocationID']>
  mileageType?: InputMaybe<Scalars['String']>
  scosAction?: InputMaybe<ScosStopAction>
  tmwVersionId?: InputMaybe<Scalars['BigInt']>
  tractorMileage?: InputMaybe<Scalars['Int']>
  type?: InputMaybe<Scalars['String']>
}

export type StopUpdateResponse =
  | InvalidOdometer
  | InvalidStopAppointmentEnd
  | InvalidStopAppointmentStart
  | InvalidStopAppointmentTime
  | InvalidStopDateTime
  | InvalidStopEvent
  | InvalidStopStatus
  | InvalidStopUpdateField
  | InvalidTmwVersionIdClient
  | InvalidTmwVersionIdScos
  | Load
  | ObjectDoesNotExist
  | TmwValidationError

export type StopsUndone = {
  __typename?: 'StopsUndone'
  load: Load
  stopIds: Array<Scalars['BigIntStopID']>
}

export type StopsUndoneResponse =
  | InvalidLegStatus
  | InvalidLoadStatus
  | InvalidUndoStops
  | ObjectDoesNotExist
  | StopsUndone

export type Subscription = {
  __typename?: 'Subscription'
  onUserUpdate: User
  subscribeLoads: LoadSubscription
  subscribeUserNotifications: Array<Notification>
}

export type SubscriptionOnUserUpdateArgs = {
  id: Scalars['Int']
}

export type SubscriptionSubscribeLoadsArgs = {
  idIn: Array<Scalars['Int']>
}

export type SubscriptionSubscribeUserNotificationsArgs = {
  userId: Scalars['Int']
}

export type TmwValidationError = ErrorType & {
  __typename?: 'TMWValidationError'
  message: Scalars['String']
}

export type TenderLoadRequest = {
  loadHash: Scalars['String']
  loadId: Scalars['Int']
  reason?: InputMaybe<Scalars['String']>
}

export type TenderLoadResponse =
  | InvalidLoadStatus
  | InvalidRadiusVersion
  | InvalidRoute
  | InvalidTenderLoad
  | InvalidTenderStatus
  | LoadTendered
  | NoCostCenterAssignedToLoad
  | NotSupportedByCostCenter
  | ObjectDoesNotExist

export type TooManyFavoriteCostCenters = ErrorType & {
  __typename?: 'TooManyFavoriteCostCenters'
  message: Scalars['String']
}

export type TrackingInfo = {
  __typename?: 'TrackingInfo'
  carrier?: Maybe<Carrier>
  customer?: Maybe<Customer>
  destination: TrackingInfoStop
  exceptions: Array<ExceptionTypes>
  georoute: Georoute
  georouteWithSpacing: Georoute
  loadRyderNumber: Scalars['String']
  origin: TrackingInfoStop
  status: TrackingStatus
  tractorDirectionDegreesAzimuth?: Maybe<Scalars['Float']>
  tractorLocationAddress?: Maybe<Address>
  tractorLocationPoint?: Maybe<GpsPoint>
}

export type TrackingInfoGeorouteWithSpacingArgs = {
  spacing: Scalars['Float']
}

export type TrackingInfoLocation = {
  __typename?: 'TrackingInfoLocation'
  address?: Maybe<Address>
  name?: Maybe<Scalars['String']>
  point?: Maybe<GpsPoint>
  timeZoneCode: Scalars['String']
  timeZoneName: Scalars['String']
}

export type TrackingInfoShipment = {
  __typename?: 'TrackingInfoShipment'
  id: Scalars['Int']
  needBy?: Maybe<Scalars['DateTime']>
  searchAndDisplayReferences: Array<ShipmentReference>
}

export type TrackingInfoStop = {
  __typename?: 'TrackingInfoStop'
  appointmentEnd?: Maybe<Scalars['DateTime']>
  appointmentStart?: Maybe<Scalars['DateTime']>
  arrivalTime?: Maybe<Scalars['DateTime']>
  departureTime?: Maybe<Scalars['DateTime']>
  estimatedArrivalTime?: Maybe<Scalars['DateTime']>
  estimatedDepartureTime?: Maybe<Scalars['DateTime']>
  id: Scalars['BigIntStopID']
  idx: Scalars['Int']
  latenessThresholdTime?: Maybe<Scalars['DateTime']>
  location?: Maybe<TrackingInfoLocation>
  minNeedBy?: Maybe<Scalars['DateTime']>
  /** @deprecated Use min_need_by instead */
  needBy?: Maybe<Scalars['DateTime']>
  plannedArrivalEnd?: Maybe<Scalars['DateTime']>
  plannedArrivalStart?: Maybe<Scalars['DateTime']>
  plannedDepartureEnd?: Maybe<Scalars['DateTime']>
  plannedDepartureStart?: Maybe<Scalars['DateTime']>
  shipments: Array<TrackingInfoShipment>
  status?: Maybe<StopStatus>
}

export type TrackingLink = {
  __typename?: 'TrackingLink'
  link: Scalars['String']
}

export type TrackingLinkInput = {
  digest: Scalars['String']
  stopId: Scalars['BigIntStopID']
  version: TrackingVersion
}

export type TrackingLinkInternalError = ErrorType & {
  __typename?: 'TrackingLinkInternalError'
  message: Scalars['String']
}

export enum TrackingStatus {
  Completed = 'COMPLETED',
  EnRoute = 'EN_ROUTE',
  Planned = 'PLANNED',
  Unavailable = 'UNAVAILABLE',
}

export enum TrackingVersion {
  V1 = 'v1',
}

export type Tractor = {
  __typename?: 'Tractor'
  address?: Maybe<Address>
  assignedCostCenterId?: Maybe<Scalars['Int']>
  businessUnitCostCenterId?: Maybe<Scalars['Int']>
  costCenters: Array<CostCenter>
  description?: Maybe<Scalars['String']>
  directionDegreesAzimuth?: Maybe<Scalars['Float']>
  editingEnabled: Scalars['Boolean']
  equipmentStatus: EquipmentStatus
  grossWeight?: Maybe<Scalars['Float']>
  id: Scalars['Int']
  isLicenseExpired: Scalars['Boolean']
  isRetired: Scalars['Boolean']
  latestGpsEvent?: Maybe<TractorGpsEvent>
  licenseExpiryDate?: Maybe<Scalars['DateTime']>
  make?: Maybe<Scalars['String']>
  model?: Maybe<Scalars['String']>
  name?: Maybe<Scalars['String']>
  nextServiceEvent?: Maybe<ServiceEvent>
  notes: Array<Note>
  odometer?: Maybe<Scalars['Int']>
  overlappingLoadAssignments: Array<Load>
  ownerType?: Maybe<EquipmentOwnerType>
  retireDate?: Maybe<Scalars['DateTime']>
  serviceEventEditingEnabled: Scalars['Boolean']
  serviceEvents: ServiceEventPaginatedResponse
  sourceSystem: TractorSourceSystem
  status: TractorStatus
  tz?: Maybe<Scalars['String']>
  unitNumber?: Maybe<Scalars['String']>
  vehicleClassName?: Maybe<Scalars['String']>
  vin: Scalars['String']
  year?: Maybe<Scalars['Int']>
}

export type TractorOverlappingLoadAssignmentsArgs = {
  legId: Scalars['Int']
}

export type TractorServiceEventsArgs = {
  limit?: InputMaybe<Scalars['Int']>
  offset?: InputMaybe<Scalars['Int']>
}

export type TractorAssignedToLeg = {
  __typename?: 'TractorAssignedToLeg'
  equipmentMoveAction?: Maybe<EquipmentMove>
  legId: Scalars['Int']
  load: Load
}

export type TractorGpsEvent = {
  __typename?: 'TractorGPSEvent'
  point: GpsPoint
  speedMph: Scalars['Int']
  status: Scalars['String']
  timestamp: Scalars['DateTime']
}

export type TractorNotExists = ErrorType & {
  __typename?: 'TractorNotExists'
  message: Scalars['String']
}

export type TractorNoteCreate = {
  body: Scalars['String']
  tractorId: Scalars['Int']
}

export type TractorNoteDelete = {
  id: Scalars['Int']
  tractorId: Scalars['Int']
}

export type TractorNoteUpdate = {
  body: Scalars['String']
  id: Scalars['Int']
  tractorId: Scalars['Int']
}

export type TractorPaginatedResponse = {
  __typename?: 'TractorPaginatedResponse'
  meta?: Maybe<PageMeta>
  results: Array<Tractor>
}

export type TractorQuery = {
  assignedCostCenterIds?: InputMaybe<Array<Scalars['Int']>>
  businessUnitCostCenterCodeIn?: InputMaybe<Array<Scalars['String']>>
  costCenterCodeIn?: InputMaybe<Array<Scalars['String']>>
  costCenterIdIn?: InputMaybe<Array<Scalars['Int']>>
  descriptionIlike?: InputMaybe<Scalars['String']>
  descriptionIsNotNull?: InputMaybe<Scalars['Boolean']>
  descriptionIsNull?: InputMaybe<Scalars['Boolean']>
  equipmentStatusIn?: InputMaybe<Array<EquipmentStatus>>
  fuzzyMatch?: InputMaybe<Scalars['String']>
  idEq?: InputMaybe<Scalars['Int']>
  idIn?: InputMaybe<Array<Scalars['Int']>>
  limit?: InputMaybe<Scalars['Int']>
  notRetired?: InputMaybe<Scalars['Boolean']>
  offset?: InputMaybe<Scalars['Int']>
  ownerTypeIn?: InputMaybe<Array<EquipmentOwnerType>>
  ownerTypeIsNotNull?: InputMaybe<Scalars['Boolean']>
  ownerTypeIsNull?: InputMaybe<Scalars['Boolean']>
  sort?: Array<TractorSortFields>
  statusIn?: InputMaybe<Array<TractorStatus>>
  statusIsNotNull?: InputMaybe<Scalars['Boolean']>
  statusIsNull?: InputMaybe<Scalars['Boolean']>
  unitNumberEq?: InputMaybe<Scalars['String']>
  unitNumberIn?: InputMaybe<Array<Scalars['String']>>
  unitNumberIsNotNull?: InputMaybe<Scalars['Boolean']>
  unitNumberIsNull?: InputMaybe<Scalars['Boolean']>
  vinEq?: InputMaybe<Scalars['String']>
}

export type TractorServiceEventComplete = {
  endDate: Scalars['Date']
  id: Scalars['Int']
  note?: InputMaybe<Scalars['String']>
  tractorId: Scalars['Int']
}

export type TractorServiceEventCompleted = {
  __typename?: 'TractorServiceEventCompleted'
  tractor: Tractor
}

export type TractorServiceEventCreate = {
  estimatedStartDate: Scalars['Date']
  note?: InputMaybe<Scalars['String']>
  serviceType: ServiceEventType
  tractorId: Scalars['Int']
}

export type TractorServiceEventCreated = {
  __typename?: 'TractorServiceEventCreated'
  serviceEvent: ServiceEvent
  tractor: Tractor
}

export type TractorServiceEventDelete = {
  id: Scalars['Int']
  tractorId: Scalars['Int']
}

export type TractorServiceEventStart = {
  estimatedEndDate: Scalars['Date']
  id: Scalars['Int']
  note?: InputMaybe<Scalars['String']>
  startDate: Scalars['Date']
  tractorId: Scalars['Int']
}

export type TractorServiceEventStarted = {
  __typename?: 'TractorServiceEventStarted'
  tractor: Tractor
}

export type TractorServiceEventUpdate = {
  estimatedEndDate?: InputMaybe<Scalars['Date']>
  estimatedStartDate?: InputMaybe<Scalars['Date']>
  id: Scalars['Int']
  note?: InputMaybe<Scalars['String']>
  tractorId: Scalars['Int']
}

export type TractorServiceEventUpdated = {
  __typename?: 'TractorServiceEventUpdated'
  tractor: Tractor
}

export enum TractorSortFields {
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  VinAsc = 'VIN_ASC',
  VinDesc = 'VIN_DESC',
}

export enum TractorSourceSystem {
  Geotab = 'GEOTAB',
  Tmw = 'TMW',
  Vmd = 'VMD',
}

export type TractorSpecificationUpdate = {
  grossWeight?: InputMaybe<Scalars['Int']>
  id: Scalars['Int']
  make?: InputMaybe<Scalars['String']>
  model?: InputMaybe<Scalars['String']>
  vehicleClassName?: InputMaybe<TractorVehicleClassName>
  year?: InputMaybe<Scalars['Int']>
}

export type TractorSpecificationUpdated = {
  __typename?: 'TractorSpecificationUpdated'
  grossWeight?: Maybe<Scalars['Float']>
  id: Scalars['Int']
  make?: Maybe<Scalars['String']>
  model?: Maybe<Scalars['String']>
  vehicleClassName?: Maybe<Scalars['String']>
  year?: Maybe<Scalars['Int']>
}

export enum TractorStatus {
  Avl = 'AVL',
  Out = 'OUT',
  Pln = 'PLN',
  Unk = 'UNK',
  Use = 'USE',
  Vac = 'VAC',
}

export enum TractorVehicleClassName {
  SaSleeperTractor = 'SA_SLEEPER_TRACTOR',
  SaTractor = 'SA_TRACTOR',
  SaYardTractor = 'SA_YARD_TRACTOR',
  TaBigBoreTruck = 'TA_BIG_BORE_TRUCK',
  TaConvSleeperTractor = 'TA_CONV_SLEEPER_TRACTOR',
  TaTractor = 'TA_TRACTOR',
  Unknown = 'UNKNOWN',
}

export type Trailer = {
  __typename?: 'Trailer'
  businessUnitCostCenterId?: Maybe<Scalars['Int']>
  costCenter?: Maybe<CostCenter>
  editingEnabled: Scalars['Boolean']
  equipmentStatus: EquipmentStatus
  grossWeight?: Maybe<Scalars['Float']>
  id: Scalars['Int']
  isEditableCostCenter: Scalars['Boolean']
  lastKnownLocation?: Maybe<Location>
  length?: Maybe<Scalars['Float']>
  licenseExpiryDate?: Maybe<Scalars['DateTime']>
  make?: Maybe<Scalars['String']>
  model?: Maybe<Scalars['String']>
  nextServiceEvent?: Maybe<ServiceEvent>
  notes: Array<Note>
  overlappingLoadAssignments: Array<Load>
  ownerType: EquipmentOwnerType
  serviceEventEditingEnabled: Scalars['Boolean']
  serviceEvents: ServiceEventPaginatedResponse
  sourceSystem: TrailerSourceSystem
  status: TrailerStatus
  type: TrailerType
  unitNumber?: Maybe<Scalars['String']>
  vin?: Maybe<Scalars['String']>
  year?: Maybe<Scalars['Int']>
}

export type TrailerOverlappingLoadAssignmentsArgs = {
  loadId: Scalars['Int']
}

export type TrailerServiceEventsArgs = {
  limit?: InputMaybe<Scalars['Int']>
  offset?: InputMaybe<Scalars['Int']>
}

export type TrailerAssignedToLoad = {
  __typename?: 'TrailerAssignedToLoad'
  load: Load
}

export type TrailerAssignedToStop = {
  __typename?: 'TrailerAssignedToStop'
  load: Load
}

export type TrailerChangeAdded = {
  __typename?: 'TrailerChangeAdded'
  load: Load
}

export type TrailerChangeDeleted = {
  __typename?: 'TrailerChangeDeleted'
  load: Load
}

export type TrailerCostCenterUpdate = {
  costCenterId: Scalars['Int']
  trailerId: Scalars['Int']
}

export type TrailerCreateRequest = {
  costCenterId: Scalars['Int']
  type: TrailerType
  unitNumber: Scalars['String']
  vin: Scalars['String']
}

export type TrailerCreated = {
  __typename?: 'TrailerCreated'
  trailer: Trailer
}

export type TrailerNoteCreate = {
  body: Scalars['String']
  trailerId: Scalars['Int']
}

export type TrailerNoteDelete = {
  id: Scalars['Int']
  trailerId: Scalars['Int']
}

export type TrailerNoteUpdate = {
  body: Scalars['String']
  id: Scalars['Int']
  trailerId: Scalars['Int']
}

export type TrailerPaginatedResponse = {
  __typename?: 'TrailerPaginatedResponse'
  meta?: Maybe<PageMeta>
  results: Array<Trailer>
}

export type TrailerQuery = {
  assignedCostCenterIds?: InputMaybe<Array<Scalars['Int']>>
  businessUnitCostCenterIdEq?: InputMaybe<Scalars['Int']>
  businessUnitCostCenterIdIn?: InputMaybe<Array<Scalars['Int']>>
  businessUnitCostCenterIdIsNotNull?: InputMaybe<Scalars['Boolean']>
  businessUnitCostCenterIdIsNull?: InputMaybe<Scalars['Boolean']>
  costCenterIdEq?: InputMaybe<Scalars['Int']>
  costCenterIdForCustomer?: InputMaybe<Scalars['Int']>
  costCenterIdIn?: InputMaybe<Array<Scalars['Int']>>
  costCenterIdIsNotNull?: InputMaybe<Scalars['Boolean']>
  costCenterIdIsNull?: InputMaybe<Scalars['Boolean']>
  equipmentStatusIn?: InputMaybe<Array<EquipmentStatus>>
  fuzzyMatch?: InputMaybe<Scalars['String']>
  idEq?: InputMaybe<Scalars['Int']>
  idIn?: InputMaybe<Array<Scalars['Int']>>
  limit?: InputMaybe<Scalars['Int']>
  offset?: InputMaybe<Scalars['Int']>
  ownerTypeIn?: InputMaybe<Array<Scalars['String']>>
  sort?: Array<TrailerSortFields>
  statusEq?: InputMaybe<Scalars['String']>
  typeIn?: InputMaybe<Array<Scalars['String']>>
  unitNumberEq?: InputMaybe<Scalars['String']>
  unitNumberIn?: InputMaybe<Array<Scalars['String']>>
  unitNumberIsNotNull?: InputMaybe<Scalars['Boolean']>
  unitNumberIsNull?: InputMaybe<Scalars['Boolean']>
  vinEq?: InputMaybe<Scalars['String']>
  vinIn?: InputMaybe<Array<Scalars['String']>>
  vinIsNotNull?: InputMaybe<Scalars['Boolean']>
  vinIsNull?: InputMaybe<Scalars['Boolean']>
}

export type TrailerServiceEventComplete = {
  endDate: Scalars['Date']
  id: Scalars['Int']
  note?: InputMaybe<Scalars['String']>
  trailerId: Scalars['Int']
}

export type TrailerServiceEventCompleted = {
  __typename?: 'TrailerServiceEventCompleted'
  trailer: Trailer
}

export type TrailerServiceEventCreate = {
  estimatedStartDate: Scalars['Date']
  note?: InputMaybe<Scalars['String']>
  serviceType: ServiceEventType
  trailerId: Scalars['Int']
}

export type TrailerServiceEventCreated = {
  __typename?: 'TrailerServiceEventCreated'
  serviceEvent: ServiceEvent
  trailer: Trailer
}

export type TrailerServiceEventDelete = {
  id: Scalars['Int']
  trailerId: Scalars['Int']
}

export type TrailerServiceEventStart = {
  estimatedEndDate: Scalars['Date']
  id: Scalars['Int']
  note?: InputMaybe<Scalars['String']>
  startDate: Scalars['Date']
  trailerId: Scalars['Int']
}

export type TrailerServiceEventStarted = {
  __typename?: 'TrailerServiceEventStarted'
  trailer: Trailer
}

export type TrailerServiceEventUpdate = {
  estimatedEndDate?: InputMaybe<Scalars['Date']>
  estimatedStartDate?: InputMaybe<Scalars['Date']>
  id: Scalars['Int']
  note?: InputMaybe<Scalars['String']>
  trailerId: Scalars['Int']
}

export type TrailerServiceEventUpdated = {
  __typename?: 'TrailerServiceEventUpdated'
  trailer: Trailer
}

export enum TrailerSortFields {
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
}

export enum TrailerSourceSystem {
  Radius = 'RADIUS',
  Vmd = 'VMD',
}

export type TrailerSpecificationUpdate = {
  grossWeight?: InputMaybe<Scalars['Int']>
  id: Scalars['Int']
  length?: InputMaybe<Scalars['Int']>
  make?: InputMaybe<Scalars['String']>
  model?: InputMaybe<Scalars['String']>
  type?: InputMaybe<TrailerType>
  vin?: InputMaybe<Scalars['String']>
  year?: InputMaybe<Scalars['Int']>
}

export type TrailerSpecificationUpdated = {
  __typename?: 'TrailerSpecificationUpdated'
  grossWeight?: Maybe<Scalars['Float']>
  id: Scalars['Int']
  length?: Maybe<Scalars['Int']>
  make?: Maybe<Scalars['String']>
  model?: Maybe<Scalars['String']>
  type?: Maybe<TrailerType>
  vin?: Maybe<Scalars['String']>
  year?: Maybe<Scalars['Int']>
}

export enum TrailerStatus {
  Active = 'ACTIVE',
  Inactive = 'INACTIVE',
}

export enum TrailerType {
  Dry = 'DRY',
  Flatbed = 'FLATBED',
  Reefer = 'REEFER',
  Tanker = 'TANKER',
  Unknown = 'UNKNOWN',
}

export enum TransitMode {
  Air = 'AIR',
  Drayage = 'DRAYAGE',
  Intermodal = 'INTERMODAL',
  Ltl = 'LTL',
  Ocean = 'OCEAN',
  Parcel = 'PARCEL',
  Rail = 'RAIL',
  Tl = 'TL',
  Unknown = 'UNKNOWN',
}

export type UnableToRetrieveDocuments = ErrorType & {
  __typename?: 'UnableToRetrieveDocuments'
  message: Scalars['String']
}

export type UndoStopsInput = {
  loadId?: InputMaybe<Scalars['Int']>
  stopId?: InputMaybe<Scalars['BigIntStopID']>
}

export type UpdateActiveFilterGroupInput = {
  filterGroupId: Scalars['Int']
}

export type UpdateActiveFilterGroupResponse = {
  __typename?: 'UpdateActiveFilterGroupResponse'
  updatedFilterGroupId: Scalars['Int']
}

export type UpdateBackhaulCodeResponse =
  | BackhaulCodeUpdated
  | InvalidLoadStatus
  | InvalidTmwVersionIdClient
  | InvalidTmwVersionIdScos
  | ObjectDoesNotExist
  | TmwValidationError

export type UpdateBillToResponse =
  | BillToUpdated
  | InvalidBillToUpdate
  | InvalidLoadStatus
  | InvalidRadiusVersion
  | ObjectDoesNotExist

export type UpdateCustomerResponse =
  | CustomerUpdated
  | InvalidTmCustomerCode
  | ObjectDoesNotExist

export type UpdateFacilityContactResponse =
  | FacilityContactUpdated
  | InvalidContact
  | InvalidEmailAddress
  | InvalidFacilityForEdit
  | InvalidPhoneNumber
  | ObjectDoesNotExist

export type UpdateFacilityNoteResponse =
  | FacilityNoteUpdated
  | InvalidFacilityForEdit
  | ObjectDoesNotExist

/** Response type for updating a note. */
export type UpdateNoteResponse =
  | InvalidLoadNoteUpdate
  | InvalidLoadStatus
  | InvalidNoteBody
  | InvalidRadiusVersion
  | InvalidTractorStatus
  | InvalidTrailerStatus
  | NoteUpdated
  | ObjectDoesNotExist

export type UpdateOsdRecordResponse =
  | InvalidFreightRecordUpdate
  | InvalidLoadStatus
  | InvalidRadiusVersion
  | ObjectDoesNotExist
  | OsdRecordUpdated

export type UpdateReferenceResponse =
  | FreightRecordReferenceUpdated
  | InvalidLoadStatus
  | InvalidRadiusVersion
  | InvalidReferenceUpdate
  | LoadReferenceUpdated
  | ObjectDoesNotExist
  | StopReferenceUpdated

export type UpdateRouteResponse =
  | InvalidLoadStatus
  | InvalidRadiusVersion
  | InvalidRouteUpdate
  | ObjectDoesNotExist
  | RouteUpdated

/** Response type for creating a service event. */
export type UpdateServiceEventResponse =
  | InvalidServiceEventStatus
  | InvalidServiceEventUpdate
  | InvalidTractorStatus
  | InvalidTrailerStatus
  | NotSupportedByCostCenter
  | ObjectDoesNotExist
  | TractorServiceEventUpdated
  | TrailerServiceEventUpdated

export type UpdateShipmentNeedByResponse =
  | InvalidNeedByUpdate
  | ObjectDoesNotExist
  | ShipmentNeedByUpdated

/** Response type for updating tractor specifications. */
export type UpdateTractorSpecificationResponse =
  | InvalidTractorUpdate
  | NotSupportedByCostCenter
  | ObjectDoesNotExist
  | TractorSpecificationUpdated

/** Response type for updating trailer cost center. */
export type UpdateTrailerCostCenterResponse =
  | InvalidTrailerUpdate
  | ObjectDoesNotExist
  | Trailer

/** Response type for updating trailer specifications. */
export type UpdateTrailerSpecificationResponse =
  | InvalidTrailerUpdate
  | InvalidVinUpdateError
  | NotSupportedByCostCenter
  | ObjectDoesNotExist
  | TrailerSpecificationUpdated

export type UpsertCustomerColumnConfigurationResponse =
  | CustomerColumnConfigurationUpserted
  | InvalidColumnConfiguration
  | ObjectDoesNotExist

export type User = {
  __typename?: 'User'
  authCostCenters: Array<CostCenter>
  columnConfigurations: Array<ColumnConfiguration>
  customer?: Maybe<Customer>
  email: Scalars['String']
  fullname?: Maybe<Scalars['String']>
  hasSecureFilters: Scalars['Boolean']
  id: Scalars['Int']
  isSuperuser: Scalars['Boolean']
  isVerified: Scalars['Boolean']
  loadUserFilterGroups: Array<UserFilterGroup>
  oauthProfilePictureUrl?: Maybe<Scalars['String']>
  oauthProviderId?: Maybe<Scalars['String']>
  oauthProviderType?: Maybe<OAuthProviderType>
  phoneNumber?: Maybe<Scalars['String']>
  role: UserRole
  settings: UserSettings
  shipmentUserFilterGroups: Array<UserFilterGroup>
  uuid: Scalars['String']
  viewType: UserViewType
}

export type UserAlreadyExists = ErrorType & {
  __typename?: 'UserAlreadyExists'
  message: Scalars['String']
}

export type UserFilterGroup = {
  __typename?: 'UserFilterGroup'
  filterGroup: FilterGroup
  isActive: Scalars['Boolean']
  userId: Scalars['Int']
}

export type UserHasCustomer = ErrorType & {
  __typename?: 'UserHasCustomer'
  message: Scalars['String']
}

export type UserPaginatedResponse = {
  __typename?: 'UserPaginatedResponse'
  meta?: Maybe<PageMeta>
  results: Array<User>
}

export type UserQuery = {
  customerIdEq?: InputMaybe<Scalars['Int']>
  fullnameIlike?: InputMaybe<Scalars['String']>
  fullnameIsNotNull?: InputMaybe<Scalars['Boolean']>
  fullnameIsNull?: InputMaybe<Scalars['Boolean']>
  hasCustomer?: InputMaybe<Scalars['Boolean']>
  hasNoCustomer?: InputMaybe<Scalars['Boolean']>
  isVerifiedEq?: InputMaybe<Scalars['Boolean']>
  limit?: InputMaybe<Scalars['Int']>
  offset?: InputMaybe<Scalars['Int']>
  roleEq?: InputMaybe<UserRole>
  roleIn?: InputMaybe<Array<UserRole>>
  sort?: Array<UserSortFields>
  userEmail?: InputMaybe<Scalars['String']>
}

export type UserResponse =
  | InvalidEmailAddress
  | InvalidPassword
  | InvalidUserCredentials
  | ObjectDoesNotExist
  | User
  | UserAlreadyExists

export enum UserRole {
  Customer = 'CUSTOMER',
  None = 'NONE',
  Operator = 'OPERATOR',
  Sysadmin = 'SYSADMIN',
}

export type UserSettings = {
  __typename?: 'UserSettings'
  favoriteCostCenters: Array<CostCenter>
  homePage?: Maybe<HomePage>
  updatedAt?: Maybe<Scalars['DateTime']>
  userId: Scalars['Int']
}

export type UserSettingsResponse =
  | ObjectDoesNotExist
  | TooManyFavoriteCostCenters
  | UserSettings

export type UserSettingsUpdate = {
  favoriteCostCenters?: InputMaybe<Array<Scalars['Int']>>
  homePage?: InputMaybe<HomePage>
  userId: Scalars['Int']
}

export enum UserSortFields {
  FullnameAsc = 'FULLNAME_ASC',
  FullnameDesc = 'FULLNAME_DESC',
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
}

export enum UserViewType {
  HdDealer = 'HD_DEALER',
  Standard = 'STANDARD',
}

export type ValidTrackingLink = {
  __typename?: 'ValidTrackingLink'
  valid: Scalars['Boolean']
}

export type ValidateTrackingLinkResponse =
  | InvalidTrackingLink
  | TrackingLinkInternalError
  | ValidTrackingLink

export enum VolumeUnit {
  CubicFeet = 'CUBIC_FEET',
  Gallons = 'GALLONS',
}

export enum WeightUnit {
  HundredWeight = 'HUNDRED_WEIGHT',
  Kilograms = 'KILOGRAMS',
  Pounds = 'POUNDS',
  Tons = 'TONS',
}

export type WithdrawLoadTenderRequest = {
  loadId: Scalars['Int']
  reason?: InputMaybe<Scalars['String']>
}

export type WithdrawLoadTenderResponse =
  | InvalidLoadStatus
  | InvalidRadiusVersion
  | InvalidRoute
  | InvalidTenderStatus
  | LoadTenderWithdrawn
  | NoCostCenterAssignedToLoad
  | NotSupportedByCostCenter
  | ObjectDoesNotExist

export type Worker = {
  __typename?: 'Worker'
  email?: Maybe<Scalars['String']>
  employeeId: Scalars['String']
  firstName?: Maybe<Scalars['String']>
  lastName?: Maybe<Scalars['String']>
  middleName?: Maybe<Scalars['String']>
  phone?: Maybe<Scalars['String']>
}
